/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../services/api/API.service";
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const getClient = /* GraphQL */ `query GetClient($id: ID!) {
  getClient(id: $id) {
    id
    status
    business_name
    comertial_name
    logo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    grayLogo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    contact {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    address {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    biography
    plan
    fee
    increment
    mercadoFee
    mercadoIncrement
    popFee
    popIncrement
    printedFee
    printedIncrement
    users
    restrictedUsers
    nonRestrictedUsers
    regions
    providers
    popProviders
    printedProviders
    logisticFrequency
    agents {
      id
      name
      email
      phoneNumber
      __typename
    }
    administrators {
      id
      name
      email
      phoneNumber
      __typename
    }
    signDocument {
      url
      enabled
      __typename
    }
    legal_representative
    legal_representative_email
    legal_representative_address
    tcdUsers
    billingUsers {
      id
      name
      email
      phoneNumber
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetClientQueryVariables, APITypes.GetClientQuery>;
export const listClients = /* GraphQL */ `query ListClients(
  $filter: ModelClientFilterInput
  $limit: Int
  $nextToken: String
) {
  listClients(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      business_name
      comertial_name
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      biography
      plan
      fee
      increment
      mercadoFee
      mercadoIncrement
      popFee
      popIncrement
      printedFee
      printedIncrement
      users
      restrictedUsers
      nonRestrictedUsers
      regions
      providers
      popProviders
      printedProviders
      logisticFrequency
      agents {
        id
        name
        email
        phoneNumber
        __typename
      }
      administrators {
        id
        name
        email
        phoneNumber
        __typename
      }
      signDocument {
        url
        enabled
        __typename
      }
      legal_representative
      legal_representative_email
      legal_representative_address
      tcdUsers
      billingUsers {
        id
        name
        email
        phoneNumber
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListClientsQueryVariables,
  APITypes.ListClientsQuery
>;
export const getClientSetting = /* GraphQL */ `query GetClientSetting($id: ID!) {
  getClientSetting(id: $id) {
    id
    crmJiraId
    orderBudget
    domain
    filterColors
    primaryColors
    accentColors
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetClientSettingQueryVariables,
  APITypes.GetClientSettingQuery
>;
export const listClientSettings = /* GraphQL */ `query ListClientSettings(
  $filter: ModelClientSettingFilterInput
  $limit: Int
  $nextToken: String
) {
  listClientSettings(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      crmJiraId
      orderBudget
      domain
      filterColors
      primaryColors
      accentColors
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListClientSettingsQueryVariables,
  APITypes.ListClientSettingsQuery
>;
export const getClientOption = /* GraphQL */ `query GetClientOption($id: ID!) {
  getClientOption(id: $id) {
    id
    pakmail
    orderVat
    hasMercado
    hasAmazon
    hasAutomobiles
    publicDashboards
    printPrices
    logisticPrices
    hidePricesAndFlow
    showPhones
    fullCoupaDescriptions
    isPremium
    isPop
    isPrinted
    allPremiumRfqs
    allPopRfqs
    allPrintedRfqs
    autoUpdateHomePage
    showVat
    requiredDeliveryInfo
    restrictedCatalogue
    excludeCoupa
    tcdPayment
    automaticLogisticGuides
    transferencePayment
    customCatalogue
    disableProjectDescriptions
    showBranding
    customCostCenter
    couponsEnabled
    showChat
    hasCrmSync
    onlyQuotes
    autoSaveDeliveryInfo
    limitMaxRequestOnDiscounts
    freeLocalShipping
    discountShipping
    printingBreakdown
    skipAlendum
    skipFMS
    clientReminders
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetClientOptionQueryVariables,
  APITypes.GetClientOptionQuery
>;
export const listClientOptions = /* GraphQL */ `query ListClientOptions(
  $filter: ModelClientOptionFilterInput
  $limit: Int
  $nextToken: String
) {
  listClientOptions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      pakmail
      orderVat
      hasMercado
      hasAmazon
      hasAutomobiles
      publicDashboards
      printPrices
      logisticPrices
      hidePricesAndFlow
      showPhones
      fullCoupaDescriptions
      isPremium
      isPop
      isPrinted
      allPremiumRfqs
      allPopRfqs
      allPrintedRfqs
      autoUpdateHomePage
      showVat
      requiredDeliveryInfo
      restrictedCatalogue
      excludeCoupa
      tcdPayment
      automaticLogisticGuides
      transferencePayment
      customCatalogue
      disableProjectDescriptions
      showBranding
      customCostCenter
      couponsEnabled
      showChat
      hasCrmSync
      onlyQuotes
      autoSaveDeliveryInfo
      limitMaxRequestOnDiscounts
      freeLocalShipping
      discountShipping
      printingBreakdown
      skipAlendum
      skipFMS
      clientReminders
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListClientOptionsQueryVariables,
  APITypes.ListClientOptionsQuery
>;
export const getProvider = /* GraphQL */ `query GetProvider($id: ID!) {
  getProvider(id: $id) {
    id
    isApproved
    logo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    grayLogo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    comertial_name
    bussiness_name {
      tax_residence {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      rfc
      name
      __typename
    }
    idProcter
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    contact {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    address {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    biography
    constancia {
      key
      url
      color
      palette
      colorName
      __typename
    }
    comprobante {
      key
      url
      color
      palette
      colorName
      __typename
    }
    experience
    pros
    cons
    cte_rating {
      name
      rating
      __typename
    }
    shopping_rating {
      name
      rating
      __typename
    }
    video
    tags
    money_filter_c
    money_filter_d
    users
    bank
    account
    clabe
    cuenta_correo
    edocuenta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    ife {
      key
      url
      color
      palette
      colorName
      __typename
    }
    poderes {
      key
      url
      color
      palette
      colorName
      __typename
    }
    acta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    isProvider
    sameAddress
    isPop
    isPrinted
    hasLogistic
    created
    updated
    addFiles {
      key
      url
      sign
      status
      __typename
    }
    signFiles {
      key
      url
      sign
      status
      __typename
    }
    representante_legal
    escritura_constitucion
    notario_a
    constituido_down_edo
    rrpp
    isPremium
    isTrustProvider
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProviderQueryVariables,
  APITypes.GetProviderQuery
>;
export const listProviders = /* GraphQL */ `query ListProviders(
  $filter: ModelProviderFilterInput
  $limit: Int
  $nextToken: String
) {
  listProviders(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProvidersQueryVariables,
  APITypes.ListProvidersQuery
>;
export const getProviderSetting = /* GraphQL */ `query GetProviderSetting($id: ID!) {
  getProviderSetting(id: $id) {
    id
    primaryColors
    accentColors
    categories
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProviderSettingQueryVariables,
  APITypes.GetProviderSettingQuery
>;
export const listProviderSettings = /* GraphQL */ `query ListProviderSettings(
  $filter: ModelProviderSettingFilterInput
  $limit: Int
  $nextToken: String
) {
  listProviderSettings(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      primaryColors
      accentColors
      categories
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProviderSettingsQueryVariables,
  APITypes.ListProviderSettingsQuery
>;
export const getProviderFile = /* GraphQL */ `query GetProviderFile($id: ID!) {
  getProviderFile(id: $id) {
    id
    acta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    constancia {
      key
      url
      color
      palette
      colorName
      __typename
    }
    comprobante {
      key
      url
      color
      palette
      colorName
      __typename
    }
    edocuenta {
      key
      url
      color
      palette
      colorName
      __typename
    }
    ife {
      key
      url
      color
      palette
      colorName
      __typename
    }
    poderes {
      key
      url
      color
      palette
      colorName
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProviderFileQueryVariables,
  APITypes.GetProviderFileQuery
>;
export const listProviderFiles = /* GraphQL */ `query ListProviderFiles(
  $filter: ModelProviderFileFilterInput
  $limit: Int
  $nextToken: String
) {
  listProviderFiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProviderFilesQueryVariables,
  APITypes.ListProviderFilesQuery
>;
export const getColors = /* GraphQL */ `query GetColors($id: ID!) {
  getColors(id: $id) {
    id
    status
    name
    rgb
    hex
    position
    variantNames
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetColorsQueryVariables, APITypes.GetColorsQuery>;
export const listColors = /* GraphQL */ `query ListColors(
  $filter: ModelColorsFilterInput
  $limit: Int
  $nextToken: String
) {
  listColors(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      name
      rgb
      hex
      position
      variantNames
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListColorsQueryVariables,
  APITypes.ListColorsQuery
>;
export const getHomePageCarouselBanner = /* GraphQL */ `query GetHomePageCarouselBanner($id: ID!) {
  getHomePageCarouselBanner(id: $id) {
    id
    status
    isPublic
    title
    subtitle
    copy
    path
    bgImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    position
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetHomePageCarouselBannerQueryVariables,
  APITypes.GetHomePageCarouselBannerQuery
>;
export const listHomePageCarouselBanners = /* GraphQL */ `query ListHomePageCarouselBanners(
  $filter: ModelHomePageCarouselBannerFilterInput
  $limit: Int
  $nextToken: String
) {
  listHomePageCarouselBanners(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      isPublic
      title
      subtitle
      copy
      path
      bgImage {
        key
        url
        color
        palette
        colorName
        __typename
      }
      position
      visibleFor
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHomePageCarouselBannersQueryVariables,
  APITypes.ListHomePageCarouselBannersQuery
>;
export const getHomePage = /* GraphQL */ `query GetHomePage($id: ID!) {
  getHomePage(id: $id) {
    id
    status
    isPublic
    showArrow
    showNumeration
    icon
    title
    subtitle
    body
    route
    titlePosition
    textAlign
    bgImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    bgColor
    borderColor
    textColor
    position
    verticalLine
    browseButton
    visibleFor
    visibleForUserBrand
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetHomePageQueryVariables,
  APITypes.GetHomePageQuery
>;
export const listHomePages = /* GraphQL */ `query ListHomePages(
  $filter: ModelHomePageFilterInput
  $limit: Int
  $nextToken: String
) {
  listHomePages(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      isPublic
      showArrow
      showNumeration
      icon
      title
      subtitle
      body
      route
      titlePosition
      textAlign
      bgImage {
        key
        url
        color
        palette
        colorName
        __typename
      }
      bgColor
      borderColor
      textColor
      position
      verticalLine
      browseButton
      visibleFor
      visibleForUserBrand
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHomePagesQueryVariables,
  APITypes.ListHomePagesQuery
>;
export const getHomePageBottomBanner = /* GraphQL */ `query GetHomePageBottomBanner($id: ID!) {
  getHomePageBottomBanner(id: $id) {
    id
    status
    isPublic
    title
    subtitle
    icon
    route
    showArrow
    bannerImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    bgColor
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetHomePageBottomBannerQueryVariables,
  APITypes.GetHomePageBottomBannerQuery
>;
export const listHomePageBottomBanners = /* GraphQL */ `query ListHomePageBottomBanners(
  $filter: ModelHomePageBottomBannerFilterInput
  $limit: Int
  $nextToken: String
) {
  listHomePageBottomBanners(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      isPublic
      title
      subtitle
      icon
      route
      showArrow
      bannerImage {
        key
        url
        color
        palette
        colorName
        __typename
      }
      bgColor
      visibleFor
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListHomePageBottomBannersQueryVariables,
  APITypes.ListHomePageBottomBannersQuery
>;
export const getProducto = /* GraphQL */ `query GetProducto($id: ID!) {
  getProducto(id: $id) {
    id
    providerId
    categoryId
    name
    status
    bestSeller
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    order
    sku
    brand
    colors
    pgClasitication
    delivery_time
    delivery_time_units
    stock
    minRequest
    maxRequest
    article_of_clothing
    size
    price
    long_description
    short_description
    creator
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    category {
      id
      name
      description
      unspsc
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      imageMobile {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      visibleForUserBrand
      region
      tags
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      hasAllowables
      hasPreapproveds
      hasRestricted
      isPublic
      isTop
      createdAt
      slug
      parentId
      rootId
      path
      status
      pathIds
      source
      trazoCategoryId
      nameExternal
      depth
      childrenCount
      isLeaf
      oldVersion
      productLine
      updatedAt
      __typename
    }
    isExternal
    isAllowable
    isRestricted
    isAutoSkipped
    isAutoAllowed
    isPurse
    massiveLayout
    hasBaseAmmount
    isFreeAmmount
    isCard
    isByRequest
    isMultiPrice
    cardBaseAmmount
    minCardBaseAmmount
    maxCardBaseAmmount
    nameExternal
    unspsc
    variants {
      sku
      name
      description
      colors
      filterColors
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      stock_available
      price
      size
      logoType
      __typename
    }
    visibleFor
    filterColors
    regions
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    productDescriptionItem {
      index
      status
      key
      description
      __typename
    }
    source
    trazoProductId
    trazoCategoryId
    stockUpdatedAt
    priceUpdatedAt
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProductoQueryVariables,
  APITypes.GetProductoQuery
>;
export const listProductos = /* GraphQL */ `query ListProductos(
  $filter: ModelProductoFilterInput
  $limit: Int
  $nextToken: String
) {
  listProductos(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      providerId
      categoryId
      name
      status
      bestSeller
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      order
      sku
      brand
      colors
      pgClasitication
      delivery_time
      delivery_time_units
      stock
      minRequest
      maxRequest
      article_of_clothing
      size
      price
      long_description
      short_description
      creator
      provider {
        id
        isApproved
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comertial_name
        bussiness_name {
          rfc
          name
          __typename
        }
        idProcter
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        biography
        constancia {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comprobante {
          key
          url
          color
          palette
          colorName
          __typename
        }
        experience
        pros
        cons
        cte_rating {
          name
          rating
          __typename
        }
        shopping_rating {
          name
          rating
          __typename
        }
        video
        tags
        money_filter_c
        money_filter_d
        users
        bank
        account
        clabe
        cuenta_correo
        edocuenta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        ife {
          key
          url
          color
          palette
          colorName
          __typename
        }
        poderes {
          key
          url
          color
          palette
          colorName
          __typename
        }
        acta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        isProvider
        sameAddress
        isPop
        isPrinted
        hasLogistic
        created
        updated
        addFiles {
          key
          url
          sign
          status
          __typename
        }
        signFiles {
          key
          url
          sign
          status
          __typename
        }
        representante_legal
        escritura_constitucion
        notario_a
        constituido_down_edo
        rrpp
        isPremium
        isTrustProvider
        createdAt
        updatedAt
        __typename
      }
      category {
        id
        name
        description
        unspsc
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        imageMobile {
          key
          url
          color
          palette
          colorName
          __typename
        }
        visibleFor
        visibleForUserBrand
        region
        tags
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        hasAllowables
        hasPreapproveds
        hasRestricted
        isPublic
        isTop
        createdAt
        slug
        parentId
        rootId
        path
        status
        pathIds
        source
        trazoCategoryId
        nameExternal
        depth
        childrenCount
        isLeaf
        oldVersion
        productLine
        updatedAt
        __typename
      }
      isExternal
      isAllowable
      isRestricted
      isAutoSkipped
      isAutoAllowed
      isPurse
      massiveLayout
      hasBaseAmmount
      isFreeAmmount
      isCard
      isByRequest
      isMultiPrice
      cardBaseAmmount
      minCardBaseAmmount
      maxCardBaseAmmount
      nameExternal
      unspsc
      variants {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      visibleFor
      filterColors
      regions
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      productDescriptionItem {
        index
        status
        key
        description
        __typename
      }
      source
      trazoProductId
      trazoCategoryId
      stockUpdatedAt
      priceUpdatedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProductosQueryVariables,
  APITypes.ListProductosQuery
>;
export const getProductVariant = /* GraphQL */ `query GetProductVariant($id: ID!) {
  getProductVariant(id: $id) {
    id
    productId
    sku
    name
    description
    colors
    filterColors
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    stock_available
    price
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProductVariantQueryVariables,
  APITypes.GetProductVariantQuery
>;
export const listProductVariants = /* GraphQL */ `query ListProductVariants(
  $filter: ModelProductVariantFilterInput
  $limit: Int
  $nextToken: String
) {
  listProductVariants(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      productId
      sku
      name
      description
      colors
      filterColors
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      stock_available
      price
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProductVariantsQueryVariables,
  APITypes.ListProductVariantsQuery
>;
export const getProductOption = /* GraphQL */ `query GetProductOption($id: ID!) {
  getProductOption(id: $id) {
    id
    ownOrder
    isPangga
    volumetricWeight
    isEvaluated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProductOptionQueryVariables,
  APITypes.GetProductOptionQuery
>;
export const listProductOptions = /* GraphQL */ `query ListProductOptions(
  $filter: ModelProductOptionFilterInput
  $limit: Int
  $nextToken: String
) {
  listProductOptions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      ownOrder
      isPangga
      volumetricWeight
      isEvaluated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProductOptionsQueryVariables,
  APITypes.ListProductOptionsQuery
>;
export const getProductDimention = /* GraphQL */ `query GetProductDimention($id: ID!) {
  getProductDimention(id: $id) {
    id
    width
    height
    depth
    weight
    boxWidth
    boxHeight
    boxDepth
    boxWeight
    boxQuantity
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProductDimentionQueryVariables,
  APITypes.GetProductDimentionQuery
>;
export const listProductDimentions = /* GraphQL */ `query ListProductDimentions(
  $filter: ModelProductDimentionFilterInput
  $limit: Int
  $nextToken: String
) {
  listProductDimentions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      width
      height
      depth
      weight
      boxWidth
      boxHeight
      boxDepth
      boxWeight
      boxQuantity
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProductDimentionsQueryVariables,
  APITypes.ListProductDimentionsQuery
>;
export const getMassiveChangeLayouts = /* GraphQL */ `query GetMassiveChangeLayouts($id: ID!) {
  getMassiveChangeLayouts(id: $id) {
    id
    type
    status
    providerId
    creatorId
    creatorRole
    productsNumber
    file {
      key
      url
      color
      palette
      colorName
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMassiveChangeLayoutsQueryVariables,
  APITypes.GetMassiveChangeLayoutsQuery
>;
export const listMassiveChangeLayouts = /* GraphQL */ `query ListMassiveChangeLayouts(
  $filter: ModelMassiveChangeLayoutsFilterInput
  $limit: Int
  $nextToken: String
) {
  listMassiveChangeLayouts(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      status
      providerId
      creatorId
      creatorRole
      productsNumber
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMassiveChangeLayoutsQueryVariables,
  APITypes.ListMassiveChangeLayoutsQuery
>;
export const getCategory = /* GraphQL */ `query GetCategory($id: ID!) {
  getCategory(id: $id) {
    id
    name
    description
    unspsc
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    imageMobile {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    visibleForUserBrand
    region
    tags
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    hasAllowables
    hasPreapproveds
    hasRestricted
    isPublic
    isTop
    createdAt
    slug
    parentId
    rootId
    path
    status
    pathIds
    source
    trazoCategoryId
    nameExternal
    depth
    childrenCount
    isLeaf
    oldVersion
    productLine
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCategoryQueryVariables,
  APITypes.GetCategoryQuery
>;
export const listCategories = /* GraphQL */ `query ListCategories(
  $filter: ModelCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listCategories(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      unspsc
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      imageMobile {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      visibleForUserBrand
      region
      tags
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      hasAllowables
      hasPreapproveds
      hasRestricted
      isPublic
      isTop
      createdAt
      slug
      parentId
      rootId
      path
      status
      pathIds
      source
      trazoCategoryId
      nameExternal
      depth
      childrenCount
      isLeaf
      oldVersion
      productLine
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCategoriesQueryVariables,
  APITypes.ListCategoriesQuery
>;
export const getProductBrand = /* GraphQL */ `query GetProductBrand($id: ID!) {
  getProductBrand(id: $id) {
    id
    name
    status
    description
    route
    unspsc
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    region
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    hasAllowables
    hasPreapproveds
    hasRestricted
    isTop
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProductBrandQueryVariables,
  APITypes.GetProductBrandQuery
>;
export const listProductBrands = /* GraphQL */ `query ListProductBrands(
  $filter: ModelProductBrandFilterInput
  $limit: Int
  $nextToken: String
) {
  listProductBrands(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      status
      description
      route
      unspsc
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      region
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      hasAllowables
      hasPreapproveds
      hasRestricted
      isTop
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProductBrandsQueryVariables,
  APITypes.ListProductBrandsQuery
>;
export const getCart = /* GraphQL */ `query GetCart($id: ID!) {
  getCart(id: $id) {
    id
    requirement
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    products {
      product_id
      provider_id
      index
      print
      printPrice
      product_name
      description
      category
      unspsc
      price
      originalPrice
      sample_requested
      sample_request
      sample_authorize
      sample_authorized
      quality_requested
      quality_request
      uploadedSample
      quantity
      isExternal
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sku
      qualityForm {
        initiativeDescription
        targetUser
        retailBrandName
        itemCategory
        itemPicture
        originCountry
        quantityPerCountryOfDist
        initiativeDates
        isPartOfAnMSOCustOrSpecPack
        incluesClientLogo
        isAReorderWithinTwelveMonths
        isReorder
        PGPLContactName
        ulTracking
        PLContactName
        contactEmailAddress
        PGPurchaseOrderNumber
        EBBSorSupplierProvidedProjectNumber
        vendorCompanyName
        vendorContactName
        vendorEmailAddress
        vendorJobTitle
        vendorTelephone
        vendorMailingAddress
        vendorCity
        vendorState
        vendorCountry
        vendorPC
        physicalItemDescription
        SampleOrMaterialComponentSubmitted
        toWhom
        descriptionOfItemPackagingAndArtwork
        regulatoryAndLegislativeProductCertification
        dateFinalApprovalRequestedSubmittedToPG
        DateOfDeclarationOfConformity
        dateOfApprovalExpirationOfPremiumItem
        itemClasification
        PGRepresentativeMarketingDesign
        PGProjectLeaderRequestor
        PGRestrictedItemsLocalPGLegal
        PGLocalCategoryGM
        PGLocalCategoryJoanAbbinanteNissenNotPowered
        idProduct
        pathDocument
        __typename
      }
      fee
      increment
      discount
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      sellMode
      kitPieces
      __typename
    }
    creator
    contact {
      name
      tel
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetCartQueryVariables, APITypes.GetCartQuery>;
export const listCarts = /* GraphQL */ `query ListCarts(
  $filter: ModelCartFilterInput
  $limit: Int
  $nextToken: String
) {
  listCarts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      requirement
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      products {
        product_id
        provider_id
        index
        print
        printPrice
        product_name
        description
        category
        unspsc
        price
        originalPrice
        sample_requested
        sample_request
        sample_authorize
        sample_authorized
        quality_requested
        quality_request
        uploadedSample
        quantity
        isExternal
        variant {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        sku
        qualityForm {
          initiativeDescription
          targetUser
          retailBrandName
          itemCategory
          itemPicture
          originCountry
          quantityPerCountryOfDist
          initiativeDates
          isPartOfAnMSOCustOrSpecPack
          incluesClientLogo
          isAReorderWithinTwelveMonths
          isReorder
          PGPLContactName
          ulTracking
          PLContactName
          contactEmailAddress
          PGPurchaseOrderNumber
          EBBSorSupplierProvidedProjectNumber
          vendorCompanyName
          vendorContactName
          vendorEmailAddress
          vendorJobTitle
          vendorTelephone
          vendorMailingAddress
          vendorCity
          vendorState
          vendorCountry
          vendorPC
          physicalItemDescription
          SampleOrMaterialComponentSubmitted
          toWhom
          descriptionOfItemPackagingAndArtwork
          regulatoryAndLegislativeProductCertification
          dateFinalApprovalRequestedSubmittedToPG
          DateOfDeclarationOfConformity
          dateOfApprovalExpirationOfPremiumItem
          itemClasification
          PGRepresentativeMarketingDesign
          PGProjectLeaderRequestor
          PGRestrictedItemsLocalPGLegal
          PGLocalCategoryGM
          PGLocalCategoryJoanAbbinanteNissenNotPowered
          idProduct
          pathDocument
          __typename
        }
        fee
        increment
        discount
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        sellMode
        kitPieces
        __typename
      }
      creator
      contact {
        name
        tel
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListCartsQueryVariables, APITypes.ListCartsQuery>;
export const getUser = /* GraphQL */ `query GetUser($id: ID!) {
  getUser(id: $id) {
    id
    name
    role
    email
    jiraId
    phoneNumber
    avatar {
      key
      url
      color
      palette
      colorName
      __typename
    }
    companyId
    brandId
    failedLogins
    agents {
      id
      name
      email
      phoneNumber
      __typename
    }
    notificationsOf
    status
    isLogistic
    isCoupa
    isManagement
    isAdministration
    hasNotifications
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetUserQueryVariables, APITypes.GetUserQuery>;
export const listUsers = /* GraphQL */ `query ListUsers(
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      role
      email
      jiraId
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      companyId
      brandId
      failedLogins
      agents {
        id
        name
        email
        phoneNumber
        __typename
      }
      notificationsOf
      status
      isLogistic
      isCoupa
      isManagement
      isAdministration
      hasNotifications
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListUsersQueryVariables, APITypes.ListUsersQuery>;
export const getAutomobile = /* GraphQL */ `query GetAutomobile($id: ID!) {
  getAutomobile(id: $id) {
    id
    clientId
    status
    bought
    buyerId
    buyerName
    price
    brand
    brandId
    model
    version
    year
    color
    km
    transmission
    motor
    passengers
    state
    objeto
    placa
    serialNumber
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    star_time
    end_time
    usersInteresting {
      iduser
      nombre
      email
      fecha_compra
      veces_rechazo
      winner
      fecha_notificacion
      buyer
      process_buyer
      d_winner_date
      created
      __typename
    }
    comentario
    penalizacion
    haveWinner
    ppostulacion
    logsGanadoresAutos {
      items {
        id
        id_auto
        id_user
        fecha_rifa
        email
        nombre
        a_paterno
        a_materno
        status_buyer
        date_buyer
        winner
        refused
        since
        process_buyer
        reactive
        created
        updated
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAutomobileQueryVariables,
  APITypes.GetAutomobileQuery
>;
export const listAutomobiles = /* GraphQL */ `query ListAutomobiles(
  $filter: ModelAutomobileFilterInput
  $limit: Int
  $nextToken: String
) {
  listAutomobiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      clientId
      status
      bought
      buyerId
      buyerName
      price
      brand
      brandId
      model
      version
      year
      color
      km
      transmission
      motor
      passengers
      state
      objeto
      placa
      serialNumber
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      star_time
      end_time
      usersInteresting {
        iduser
        nombre
        email
        fecha_compra
        veces_rechazo
        winner
        fecha_notificacion
        buyer
        process_buyer
        d_winner_date
        created
        __typename
      }
      comentario
      penalizacion
      haveWinner
      ppostulacion
      logsGanadoresAutos {
        items {
          id
          id_auto
          id_user
          fecha_rifa
          email
          nombre
          a_paterno
          a_materno
          status_buyer
          date_buyer
          winner
          refused
          since
          process_buyer
          reactive
          created
          updated
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAutomobilesQueryVariables,
  APITypes.ListAutomobilesQuery
>;
export const getBrand = /* GraphQL */ `query GetBrand($id: ID!) {
  getBrand(id: $id) {
    id
    name
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetBrandQueryVariables, APITypes.GetBrandQuery>;
export const listBrands = /* GraphQL */ `query ListBrands(
  $filter: ModelBrandFilterInput
  $limit: Int
  $nextToken: String
) {
  listBrands(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBrandsQueryVariables,
  APITypes.ListBrandsQuery
>;
export const getRfq = /* GraphQL */ `query GetRfq($id: ID!) {
  getRfq(id: $id) {
    id
    nombre
    requerimiento
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    cantidad
    limit_time
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        priceUnit
        pieces
        price
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        multipleProducts
        hidden
        rfq {
          id
          nombre
          requerimiento
          cantidad
          limit_time
          creator
          clientId
          orderAgentIds
          premiumOrderId
          estatus
          orderId
          start_time
          delivery_time
          created
          saving
          saving_percentage
          saving_real
          createdAt
          updatedAt
          updated
          multipleProducts
          providers
          __typename
        }
        proposalsRfqId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    premiumOrderId
    estatus
    orderId
    start_time
    delivery_time
    created
    saving
    saving_percentage
    saving_real
    createdAt
    updatedAt
    updated
    multipleProducts
    providers
    productsRfq {
      name
      description
      pieces
      createdId
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<APITypes.GetRfqQueryVariables, APITypes.GetRfqQuery>;
export const listRfqs = /* GraphQL */ `query ListRfqs($filter: ModelRfqFilterInput, $limit: Int, $nextToken: String) {
  listRfqs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      proposals {
        items {
          id
          provider_id
          priceUnit
          pieces
          price
          validity_days
          description
          created
          updated
          multipleProducts
          hidden
          proposalsRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      premiumOrderId
      estatus
      orderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      multipleProducts
      providers
      productsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListRfqsQueryVariables, APITypes.ListRfqsQuery>;
export const getRfqAmazon = /* GraphQL */ `query GetRfqAmazon($id: ID!) {
  getRfqAmazon(id: $id) {
    id
    nombre
    requerimiento
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    cantidad
    limit_time
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        priceUnit
        pieces
        price
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        multipleProducts
        hidden
        rfq {
          id
          nombre
          requerimiento
          cantidad
          limit_time
          creator
          clientId
          estatus
          orderId
          start_time
          delivery_time
          created
          saving
          saving_percentage
          saving_real
          createdAt
          updatedAt
          updated
          multipleProducts
          providers
          __typename
        }
        proposalsRfqId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    estatus
    orderId
    start_time
    delivery_time
    created
    saving
    saving_percentage
    saving_real
    createdAt
    updatedAt
    updated
    multipleProducts
    providers
    productsRfq {
      name
      description
      pieces
      createdId
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRfqAmazonQueryVariables,
  APITypes.GetRfqAmazonQuery
>;
export const listRfqAmazons = /* GraphQL */ `query ListRfqAmazons(
  $filter: ModelRfqAmazonFilterInput
  $limit: Int
  $nextToken: String
) {
  listRfqAmazons(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      proposals {
        items {
          id
          provider_id
          priceUnit
          pieces
          price
          validity_days
          description
          created
          updated
          multipleProducts
          hidden
          proposalsRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      estatus
      orderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      multipleProducts
      providers
      productsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRfqAmazonsQueryVariables,
  APITypes.ListRfqAmazonsQuery
>;
export const getProposals = /* GraphQL */ `query GetProposals($id: ID!) {
  getProposals(id: $id) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    priceUnit
    pieces
    price
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    multipleProducts
    hidden
    rfq {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      proposals {
        items {
          id
          provider_id
          priceUnit
          pieces
          price
          validity_days
          description
          created
          updated
          multipleProducts
          hidden
          proposalsRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      premiumOrderId
      estatus
      orderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      multipleProducts
      providers
      productsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    proposalsRfqId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProposalsQueryVariables,
  APITypes.GetProposalsQuery
>;
export const listProposals = /* GraphQL */ `query ListProposals(
  $filter: ModelProposalsFilterInput
  $limit: Int
  $nextToken: String
) {
  listProposals(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      provider_id
      delivery_time {
        lower
        upper
        __typename
      }
      priceUnit
      pieces
      price
      validity_days
      description
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      created
      updated
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      products {
        productUnitRfqIndex
        selected
        name
        description
        priceUnit
        pieces
        total
        idProducto
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        __typename
      }
      multipleProducts
      hidden
      rfq {
        id
        nombre
        requerimiento
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        compras {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        cantidad
        limit_time
        proposals {
          nextToken
          __typename
        }
        creator
        creatorInfo {
          name
          email
          user_id
          __typename
        }
        clientId
        winner {
          proveeedor_id
          date
          __typename
        }
        logs {
          creatorId
          description
          date
          status
          provider_id
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        orderAgents {
          name
          email
          phoneNumber
          user_id
          __typename
        }
        orderAgentIds
        premiumOrderId
        estatus
        orderId
        start_time
        delivery_time
        created
        saving
        saving_percentage
        saving_real
        createdAt
        updatedAt
        updated
        multipleProducts
        providers
        productsRfq {
          name
          description
          pieces
          createdId
          __typename
        }
        __typename
      }
      proposalsRfqId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProposalsQueryVariables,
  APITypes.ListProposalsQuery
>;
export const getProposalsAmazon = /* GraphQL */ `query GetProposalsAmazon($id: ID!) {
  getProposalsAmazon(id: $id) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    priceUnit
    pieces
    price
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    multipleProducts
    hidden
    rfq {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      proposals {
        items {
          id
          provider_id
          priceUnit
          pieces
          price
          validity_days
          description
          created
          updated
          multipleProducts
          hidden
          proposalsRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      estatus
      orderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      multipleProducts
      providers
      productsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    proposalsRfqId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProposalsAmazonQueryVariables,
  APITypes.GetProposalsAmazonQuery
>;
export const listProposalsAmazons = /* GraphQL */ `query ListProposalsAmazons(
  $filter: ModelProposalsAmazonFilterInput
  $limit: Int
  $nextToken: String
) {
  listProposalsAmazons(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      provider_id
      delivery_time {
        lower
        upper
        __typename
      }
      priceUnit
      pieces
      price
      validity_days
      description
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      created
      updated
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      products {
        productUnitRfqIndex
        selected
        name
        description
        priceUnit
        pieces
        total
        idProducto
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        __typename
      }
      multipleProducts
      hidden
      rfq {
        id
        nombre
        requerimiento
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        compras {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        cantidad
        limit_time
        proposals {
          nextToken
          __typename
        }
        creator
        creatorInfo {
          name
          email
          user_id
          __typename
        }
        clientId
        winner {
          proveeedor_id
          date
          __typename
        }
        logs {
          creatorId
          description
          date
          status
          provider_id
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        estatus
        orderId
        start_time
        delivery_time
        created
        saving
        saving_percentage
        saving_real
        createdAt
        updatedAt
        updated
        multipleProducts
        providers
        productsRfq {
          name
          description
          pieces
          createdId
          __typename
        }
        __typename
      }
      proposalsRfqId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProposalsAmazonsQueryVariables,
  APITypes.ListProposalsAmazonsQuery
>;
export const getProductoRfq = /* GraphQL */ `query GetProductoRfq($id: ID!) {
  getProductoRfq(id: $id) {
    id
    name
    request
    category_id
    provider_id
    price
    category {
      id
      name
      description
      unspsc
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      imageMobile {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      visibleForUserBrand
      region
      tags
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      hasAllowables
      hasPreapproveds
      hasRestricted
      isPublic
      isTop
      createdAt
      slug
      parentId
      rootId
      path
      status
      pathIds
      source
      trazoCategoryId
      nameExternal
      depth
      childrenCount
      isLeaf
      oldVersion
      productLine
      updatedAt
      __typename
    }
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    estatus
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProductoRfqQueryVariables,
  APITypes.GetProductoRfqQuery
>;
export const listProductoRfqs = /* GraphQL */ `query ListProductoRfqs(
  $filter: ModelProductoRfqFilterInput
  $limit: Int
  $nextToken: String
) {
  listProductoRfqs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      request
      category_id
      provider_id
      price
      category {
        id
        name
        description
        unspsc
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        imageMobile {
          key
          url
          color
          palette
          colorName
          __typename
        }
        visibleFor
        visibleForUserBrand
        region
        tags
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        hasAllowables
        hasPreapproveds
        hasRestricted
        isPublic
        isTop
        createdAt
        slug
        parentId
        rootId
        path
        status
        pathIds
        source
        trazoCategoryId
        nameExternal
        depth
        childrenCount
        isLeaf
        oldVersion
        productLine
        updatedAt
        __typename
      }
      provider {
        id
        isApproved
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comertial_name
        bussiness_name {
          rfc
          name
          __typename
        }
        idProcter
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        biography
        constancia {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comprobante {
          key
          url
          color
          palette
          colorName
          __typename
        }
        experience
        pros
        cons
        cte_rating {
          name
          rating
          __typename
        }
        shopping_rating {
          name
          rating
          __typename
        }
        video
        tags
        money_filter_c
        money_filter_d
        users
        bank
        account
        clabe
        cuenta_correo
        edocuenta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        ife {
          key
          url
          color
          palette
          colorName
          __typename
        }
        poderes {
          key
          url
          color
          palette
          colorName
          __typename
        }
        acta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        isProvider
        sameAddress
        isPop
        isPrinted
        hasLogistic
        created
        updated
        addFiles {
          key
          url
          sign
          status
          __typename
        }
        signFiles {
          key
          url
          sign
          status
          __typename
        }
        representante_legal
        escritura_constitucion
        notario_a
        constituido_down_edo
        rrpp
        isPremium
        isTrustProvider
        createdAt
        updatedAt
        __typename
      }
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      estatus
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProductoRfqsQueryVariables,
  APITypes.ListProductoRfqsQuery
>;
export const getOrderProviders = /* GraphQL */ `query GetOrderProviders($id: ID!) {
  getOrderProviders(id: $id) {
    id
    provider_id
    clientId
    orderId
    orderProvidersPremiumOrderId
    payment_date
    gr_code
    invoice
    invoiceRequested
    uploadedGr
    uploadedBill
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOrderProvidersQueryVariables,
  APITypes.GetOrderProvidersQuery
>;
export const listOrderProviders = /* GraphQL */ `query ListOrderProviders(
  $filter: ModelOrderProvidersFilterInput
  $limit: Int
  $nextToken: String
) {
  listOrderProviders(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      provider_id
      clientId
      orderId
      orderProvidersPremiumOrderId
      payment_date
      gr_code
      invoice
      invoiceRequested
      uploadedGr
      uploadedBill
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOrderProvidersQueryVariables,
  APITypes.ListOrderProvidersQuery
>;
export const getPopMaterial = /* GraphQL */ `query GetPopMaterial($id: ID!) {
  getPopMaterial(id: $id) {
    id
    name
    route
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    year
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPopMaterialQueryVariables,
  APITypes.GetPopMaterialQuery
>;
export const listPopMaterials = /* GraphQL */ `query ListPopMaterials(
  $filter: ModelPopMaterialFilterInput
  $limit: Int
  $nextToken: String
) {
  listPopMaterials(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      route
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      year
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPopMaterialsQueryVariables,
  APITypes.ListPopMaterialsQuery
>;
export const getVehicleType = /* GraphQL */ `query GetVehicleType($id: ID!) {
  getVehicleType(id: $id) {
    id
    name
    popMaterialId
    visibleFor
    region
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    popMaterial {
      id
      name
      route
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      year
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetVehicleTypeQueryVariables,
  APITypes.GetVehicleTypeQuery
>;
export const listVehicleTypes = /* GraphQL */ `query ListVehicleTypes(
  $filter: ModelVehicleTypeFilterInput
  $limit: Int
  $nextToken: String
) {
  listVehicleTypes(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      popMaterialId
      visibleFor
      region
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      popMaterial {
        id
        name
        route
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        visibleFor
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        year
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListVehicleTypesQueryVariables,
  APITypes.ListVehicleTypesQuery
>;
export const getVehicle = /* GraphQL */ `query GetVehicle($id: ID!) {
  getVehicle(id: $id) {
    id
    status
    isSustainable
    multiProvider
    itemName
    bestSeller
    name
    brand
    channel
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    description
    size
    materialDetail
    print
    finish
    packaging
    quantity
    unitPrice
    prototypePrice
    productionTime
    vehicleTypeId
    popMaterialId
    popCategoryId
    providerId
    isRfq
    historicCost
    historicTime
    contact
    providerName
    variantsUnits {
      min_units
      max_units
      price
      production_time
      __typename
    }
    visibleFor
    filterColors
    providers
    massiveLayout
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetVehicleQueryVariables,
  APITypes.GetVehicleQuery
>;
export const listVehicles = /* GraphQL */ `query ListVehicles(
  $filter: ModelVehicleFilterInput
  $limit: Int
  $nextToken: String
) {
  listVehicles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      isSustainable
      multiProvider
      itemName
      bestSeller
      name
      brand
      channel
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      description
      size
      materialDetail
      print
      finish
      packaging
      quantity
      unitPrice
      prototypePrice
      productionTime
      vehicleTypeId
      popMaterialId
      popCategoryId
      providerId
      isRfq
      historicCost
      historicTime
      contact
      providerName
      variantsUnits {
        min_units
        max_units
        price
        production_time
        __typename
      }
      visibleFor
      filterColors
      providers
      massiveLayout
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListVehiclesQueryVariables,
  APITypes.ListVehiclesQuery
>;
export const getPopOrder = /* GraphQL */ `query GetPopOrder($id: ID!) {
  getPopOrder(id: $id) {
    id
    estatus
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    orderId
    requirement
    budget
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    delivery_cost
    delivery_time
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    contact {
      name
      tel
      __typename
    }
    subtotal
    total
    isCoupa
    sentToCoupa
    coupaOrder
    active
    vehicles {
      items {
        id
        orderId
        vehicleId
        providerId
        unitPrice
        prototypePrice
        quantity
        approved
        hasQrCode
        vehicle {
          id
          status
          isSustainable
          multiProvider
          itemName
          bestSeller
          name
          brand
          channel
          description
          size
          materialDetail
          print
          finish
          packaging
          quantity
          unitPrice
          prototypePrice
          productionTime
          vehicleTypeId
          popMaterialId
          popCategoryId
          providerId
          isRfq
          historicCost
          historicTime
          contact
          providerName
          visibleFor
          filterColors
          providers
          massiveLayout
          created
          updated
          createdAt
          updatedAt
          __typename
        }
        order {
          id
          estatus
          orderId
          requirement
          budget
          delivery_cost
          delivery_time
          subtotal
          total
          isCoupa
          sentToCoupa
          coupaOrder
          active
          createdAt
          updatedAt
          orderAgentIds
          gr
          orderCreatorId
          prequoteApproved
          quoteApproved
          prototypeApproved
          samplesDocsUploaded
          samplesApproved
          auditRequired
          drivePath
          auditDocsUploaded
          deliveryDateRequested
          deliveryDate
          deliveryCode
          deliveryFilesUploaded
          deliveryDocsApproved
          grUploaded
          grApproved
          grCode
          qrCode
          brandfactoryCheck
          step
          prototype
          dateKickoff
          paymentDate
          currentProcess
          currentSubprocess
          clientId
          __typename
        }
        provider {
          id
          isApproved
          comertial_name
          idProcter
          biography
          experience
          pros
          cons
          video
          tags
          money_filter_c
          money_filter_d
          users
          bank
          account
          clabe
          cuenta_correo
          isProvider
          sameAddress
          isPop
          isPrinted
          hasLogistic
          created
          updated
          representante_legal
          escritura_constitucion
          notario_a
          constituido_down_edo
          rrpp
          isPremium
          isTrustProvider
          createdAt
          updatedAt
          __typename
        }
        sampleTestDate
        sampleTestDateApproved
        prototypeDate
        prototypeDateApproved
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    gr
    orderCreatorId
    providers {
      items {
        id
        orderId
        providerId
        deliveryDateRequested
        grRequested
        invoiceUploaded
        order {
          id
          estatus
          orderId
          requirement
          budget
          delivery_cost
          delivery_time
          subtotal
          total
          isCoupa
          sentToCoupa
          coupaOrder
          active
          createdAt
          updatedAt
          orderAgentIds
          gr
          orderCreatorId
          prequoteApproved
          quoteApproved
          prototypeApproved
          samplesDocsUploaded
          samplesApproved
          auditRequired
          drivePath
          auditDocsUploaded
          deliveryDateRequested
          deliveryDate
          deliveryCode
          deliveryFilesUploaded
          deliveryDocsApproved
          grUploaded
          grApproved
          grCode
          qrCode
          brandfactoryCheck
          step
          prototype
          dateKickoff
          paymentDate
          currentProcess
          currentSubprocess
          clientId
          __typename
        }
        provider {
          id
          isApproved
          comertial_name
          idProcter
          biography
          experience
          pros
          cons
          video
          tags
          money_filter_c
          money_filter_d
          users
          bank
          account
          clabe
          cuenta_correo
          isProvider
          sameAddress
          isPop
          isPrinted
          hasLogistic
          created
          updated
          representante_legal
          escritura_constitucion
          notario_a
          constituido_down_edo
          rrpp
          isPremium
          isTrustProvider
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    prequoteApproved
    quoteApproved
    prototypeApproved
    samplesDocsUploaded
    samplesApproved
    auditRequired
    drivePath
    auditDocsUploaded
    deliveryDateRequested
    deliveryDate
    deliveryCode
    deliveryFilesUploaded
    deliveryDocsApproved
    grUploaded
    grApproved
    grCode
    qrCode
    brandfactoryCheck
    step
    prototype
    dateKickoff
    paymentDate
    currentProcess
    currentSubprocess
    clientId
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPopOrderQueryVariables,
  APITypes.GetPopOrderQuery
>;
export const listPopOrders = /* GraphQL */ `query ListPopOrders(
  $filter: ModelPopOrderFilterInput
  $limit: Int
  $nextToken: String
) {
  listPopOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPopOrdersQueryVariables,
  APITypes.ListPopOrdersQuery
>;
export const getOrderFile = /* GraphQL */ `query GetOrderFile($id: ID!) {
  getOrderFile(id: $id) {
    id
    createdAt
    creatorId
    orderId
    key
    url
    orderStatus
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOrderFileQueryVariables,
  APITypes.GetOrderFileQuery
>;
export const listOrderFiles = /* GraphQL */ `query ListOrderFiles(
  $filter: ModelOrderFileFilterInput
  $limit: Int
  $nextToken: String
) {
  listOrderFiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      createdAt
      creatorId
      orderId
      key
      url
      orderStatus
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOrderFilesQueryVariables,
  APITypes.ListOrderFilesQuery
>;
export const getPopOrderVehicle = /* GraphQL */ `query GetPopOrderVehicle($id: ID!) {
  getPopOrderVehicle(id: $id) {
    id
    orderId
    vehicleId
    providerId
    unitPrice
    prototypePrice
    quantity
    approved
    hasQrCode
    vehicle {
      id
      status
      isSustainable
      multiProvider
      itemName
      bestSeller
      name
      brand
      channel
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      description
      size
      materialDetail
      print
      finish
      packaging
      quantity
      unitPrice
      prototypePrice
      productionTime
      vehicleTypeId
      popMaterialId
      popCategoryId
      providerId
      isRfq
      historicCost
      historicTime
      contact
      providerName
      variantsUnits {
        min_units
        max_units
        price
        production_time
        __typename
      }
      visibleFor
      filterColors
      providers
      massiveLayout
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    order {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    sampleTestDate
    sampleTestDateApproved
    prototypeDate
    prototypeDateApproved
    logs {
      product_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPopOrderVehicleQueryVariables,
  APITypes.GetPopOrderVehicleQuery
>;
export const listPopOrderVehicles = /* GraphQL */ `query ListPopOrderVehicles(
  $filter: ModelPopOrderVehicleFilterInput
  $limit: Int
  $nextToken: String
) {
  listPopOrderVehicles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      orderId
      vehicleId
      providerId
      unitPrice
      prototypePrice
      quantity
      approved
      hasQrCode
      vehicle {
        id
        status
        isSustainable
        multiProvider
        itemName
        bestSeller
        name
        brand
        channel
        images {
          key
          url
          color
          palette
          colorName
          __typename
        }
        description
        size
        materialDetail
        print
        finish
        packaging
        quantity
        unitPrice
        prototypePrice
        productionTime
        vehicleTypeId
        popMaterialId
        popCategoryId
        providerId
        isRfq
        historicCost
        historicTime
        contact
        providerName
        variantsUnits {
          min_units
          max_units
          price
          production_time
          __typename
        }
        visibleFor
        filterColors
        providers
        massiveLayout
        created
        updated
        createdAt
        updatedAt
        __typename
      }
      order {
        id
        estatus
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        orderId
        requirement
        budget
        delivery_addresses {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        delivery_cost
        delivery_time
        files {
          created
          creator_id
          status
          statusFile
          name
          provider_id
          product_id
          tracking_code
          gr_code
          coupa_order
          description
          __typename
        }
        contact {
          name
          tel
          __typename
        }
        subtotal
        total
        isCoupa
        sentToCoupa
        coupaOrder
        active
        vehicles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        orderAgents {
          name
          email
          phoneNumber
          user_id
          __typename
        }
        orderAgentIds
        buyerInfo {
          name
          email
          authorized
          __typename
        }
        buyersInfo {
          name
          email
          authorized
          __typename
        }
        gr
        orderCreatorId
        providers {
          nextToken
          __typename
        }
        creator {
          name
          email
          user_id
          __typename
        }
        prequoteApproved
        quoteApproved
        prototypeApproved
        samplesDocsUploaded
        samplesApproved
        auditRequired
        drivePath
        auditDocsUploaded
        deliveryDateRequested
        deliveryDate
        deliveryCode
        deliveryFilesUploaded
        deliveryDocsApproved
        grUploaded
        grApproved
        grCode
        qrCode
        brandfactoryCheck
        step
        prototype
        dateKickoff
        paymentDate
        currentProcess
        currentSubprocess
        clientId
        __typename
      }
      provider {
        id
        isApproved
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comertial_name
        bussiness_name {
          rfc
          name
          __typename
        }
        idProcter
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        biography
        constancia {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comprobante {
          key
          url
          color
          palette
          colorName
          __typename
        }
        experience
        pros
        cons
        cte_rating {
          name
          rating
          __typename
        }
        shopping_rating {
          name
          rating
          __typename
        }
        video
        tags
        money_filter_c
        money_filter_d
        users
        bank
        account
        clabe
        cuenta_correo
        edocuenta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        ife {
          key
          url
          color
          palette
          colorName
          __typename
        }
        poderes {
          key
          url
          color
          palette
          colorName
          __typename
        }
        acta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        isProvider
        sameAddress
        isPop
        isPrinted
        hasLogistic
        created
        updated
        addFiles {
          key
          url
          sign
          status
          __typename
        }
        signFiles {
          key
          url
          sign
          status
          __typename
        }
        representante_legal
        escritura_constitucion
        notario_a
        constituido_down_edo
        rrpp
        isPremium
        isTrustProvider
        createdAt
        updatedAt
        __typename
      }
      sampleTestDate
      sampleTestDateApproved
      prototypeDate
      prototypeDateApproved
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPopOrderVehiclesQueryVariables,
  APITypes.ListPopOrderVehiclesQuery
>;
export const getPopOrderAuthorizer = /* GraphQL */ `query GetPopOrderAuthorizer($id: ID!) {
  getPopOrderAuthorizer(id: $id) {
    id
    userId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPopOrderAuthorizerQueryVariables,
  APITypes.GetPopOrderAuthorizerQuery
>;
export const listPopOrderAuthorizers = /* GraphQL */ `query ListPopOrderAuthorizers(
  $filter: ModelPopOrderAuthorizerFilterInput
  $limit: Int
  $nextToken: String
) {
  listPopOrderAuthorizers(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPopOrderAuthorizersQueryVariables,
  APITypes.ListPopOrderAuthorizersQuery
>;
export const getPopOrderProvider = /* GraphQL */ `query GetPopOrderProvider($id: ID!) {
  getPopOrderProvider(id: $id) {
    id
    orderId
    providerId
    deliveryDateRequested
    grRequested
    invoiceUploaded
    order {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    provider {
      id
      isApproved
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comertial_name
      bussiness_name {
        tax_residence {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        rfc
        name
        __typename
      }
      idProcter
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      biography
      constancia {
        key
        url
        color
        palette
        colorName
        __typename
      }
      comprobante {
        key
        url
        color
        palette
        colorName
        __typename
      }
      experience
      pros
      cons
      cte_rating {
        name
        rating
        __typename
      }
      shopping_rating {
        name
        rating
        __typename
      }
      video
      tags
      money_filter_c
      money_filter_d
      users
      bank
      account
      clabe
      cuenta_correo
      edocuenta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      ife {
        key
        url
        color
        palette
        colorName
        __typename
      }
      poderes {
        key
        url
        color
        palette
        colorName
        __typename
      }
      acta {
        key
        url
        color
        palette
        colorName
        __typename
      }
      isProvider
      sameAddress
      isPop
      isPrinted
      hasLogistic
      created
      updated
      addFiles {
        key
        url
        sign
        status
        __typename
      }
      signFiles {
        key
        url
        sign
        status
        __typename
      }
      representante_legal
      escritura_constitucion
      notario_a
      constituido_down_edo
      rrpp
      isPremium
      isTrustProvider
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPopOrderProviderQueryVariables,
  APITypes.GetPopOrderProviderQuery
>;
export const listPopOrderProviders = /* GraphQL */ `query ListPopOrderProviders(
  $filter: ModelPopOrderProviderFilterInput
  $limit: Int
  $nextToken: String
) {
  listPopOrderProviders(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      orderId
      providerId
      deliveryDateRequested
      grRequested
      invoiceUploaded
      order {
        id
        estatus
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        orderId
        requirement
        budget
        delivery_addresses {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        delivery_cost
        delivery_time
        files {
          created
          creator_id
          status
          statusFile
          name
          provider_id
          product_id
          tracking_code
          gr_code
          coupa_order
          description
          __typename
        }
        contact {
          name
          tel
          __typename
        }
        subtotal
        total
        isCoupa
        sentToCoupa
        coupaOrder
        active
        vehicles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        orderAgents {
          name
          email
          phoneNumber
          user_id
          __typename
        }
        orderAgentIds
        buyerInfo {
          name
          email
          authorized
          __typename
        }
        buyersInfo {
          name
          email
          authorized
          __typename
        }
        gr
        orderCreatorId
        providers {
          nextToken
          __typename
        }
        creator {
          name
          email
          user_id
          __typename
        }
        prequoteApproved
        quoteApproved
        prototypeApproved
        samplesDocsUploaded
        samplesApproved
        auditRequired
        drivePath
        auditDocsUploaded
        deliveryDateRequested
        deliveryDate
        deliveryCode
        deliveryFilesUploaded
        deliveryDocsApproved
        grUploaded
        grApproved
        grCode
        qrCode
        brandfactoryCheck
        step
        prototype
        dateKickoff
        paymentDate
        currentProcess
        currentSubprocess
        clientId
        __typename
      }
      provider {
        id
        isApproved
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comertial_name
        bussiness_name {
          rfc
          name
          __typename
        }
        idProcter
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        biography
        constancia {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comprobante {
          key
          url
          color
          palette
          colorName
          __typename
        }
        experience
        pros
        cons
        cte_rating {
          name
          rating
          __typename
        }
        shopping_rating {
          name
          rating
          __typename
        }
        video
        tags
        money_filter_c
        money_filter_d
        users
        bank
        account
        clabe
        cuenta_correo
        edocuenta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        ife {
          key
          url
          color
          palette
          colorName
          __typename
        }
        poderes {
          key
          url
          color
          palette
          colorName
          __typename
        }
        acta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        isProvider
        sameAddress
        isPop
        isPrinted
        hasLogistic
        created
        updated
        addFiles {
          key
          url
          sign
          status
          __typename
        }
        signFiles {
          key
          url
          sign
          status
          __typename
        }
        representante_legal
        escritura_constitucion
        notario_a
        constituido_down_edo
        rrpp
        isPremium
        isTrustProvider
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPopOrderProvidersQueryVariables,
  APITypes.ListPopOrderProvidersQuery
>;
export const getPopOrderLog = /* GraphQL */ `query GetPopOrderLog($id: ID!) {
  getPopOrderLog(id: $id) {
    id
    orderId
    creatorId
    order {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    createdAt
    text
    orderStatus
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPopOrderLogQueryVariables,
  APITypes.GetPopOrderLogQuery
>;
export const listPopOrderLogs = /* GraphQL */ `query ListPopOrderLogs(
  $filter: ModelPopOrderLogFilterInput
  $limit: Int
  $nextToken: String
) {
  listPopOrderLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      orderId
      creatorId
      order {
        id
        estatus
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        orderId
        requirement
        budget
        delivery_addresses {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        delivery_cost
        delivery_time
        files {
          created
          creator_id
          status
          statusFile
          name
          provider_id
          product_id
          tracking_code
          gr_code
          coupa_order
          description
          __typename
        }
        contact {
          name
          tel
          __typename
        }
        subtotal
        total
        isCoupa
        sentToCoupa
        coupaOrder
        active
        vehicles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        orderAgents {
          name
          email
          phoneNumber
          user_id
          __typename
        }
        orderAgentIds
        buyerInfo {
          name
          email
          authorized
          __typename
        }
        buyersInfo {
          name
          email
          authorized
          __typename
        }
        gr
        orderCreatorId
        providers {
          nextToken
          __typename
        }
        creator {
          name
          email
          user_id
          __typename
        }
        prequoteApproved
        quoteApproved
        prototypeApproved
        samplesDocsUploaded
        samplesApproved
        auditRequired
        drivePath
        auditDocsUploaded
        deliveryDateRequested
        deliveryDate
        deliveryCode
        deliveryFilesUploaded
        deliveryDocsApproved
        grUploaded
        grApproved
        grCode
        qrCode
        brandfactoryCheck
        step
        prototype
        dateKickoff
        paymentDate
        currentProcess
        currentSubprocess
        clientId
        __typename
      }
      createdAt
      text
      orderStatus
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPopOrderLogsQueryVariables,
  APITypes.ListPopOrderLogsQuery
>;
export const getRfqPop = /* GraphQL */ `query GetRfqPop($id: ID!) {
  getRfqPop(id: $id) {
    id
    nombre
    requerimiento
    vehicleTypeId
    popMaterialId
    vehiclesRfq {
      vehicleTypeId
      popMaterialId
      name
      description
      pieces
      createdId
      __typename
    }
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    cantidad
    limit_time
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        price
        created
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        vehicles {
          productUnitRfqIndex
          selected
          name
          popMaterialId
          vehicleTypeId
          brand
          size
          description
          quantity
          packaging
          materialDetail
          print
          unitPrice
          pieces
          priceUnit
          total
          idProducto
          __typename
        }
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        rfq {
          id
          nombre
          requerimiento
          vehicleTypeId
          popMaterialId
          cantidad
          limit_time
          creator
          clientId
          orderAgentIds
          popOrderId
          orderId
          estatus
          start_time
          delivery_time
          saving
          saving_percentage
          saving_real
          budget
          hasQrCode
          created
          createdAt
          updated
          updatedAt
          __typename
        }
        proposalsPopRfqId
        prototypePrice
        hidden
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    providers {
      idProvider
      __typename
    }
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    popOrderId
    orderId
    estatus
    start_time
    delivery_time
    saving
    saving_percentage
    saving_real
    budget
    hasQrCode
    created
    createdAt
    updated
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetRfqPopQueryVariables, APITypes.GetRfqPopQuery>;
export const listRfqPops = /* GraphQL */ `query ListRfqPops(
  $filter: ModelRfqPopFilterInput
  $limit: Int
  $nextToken: String
) {
  listRfqPops(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      nombre
      requerimiento
      vehicleTypeId
      popMaterialId
      vehiclesRfq {
        vehicleTypeId
        popMaterialId
        name
        description
        pieces
        createdId
        __typename
      }
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      proposals {
        items {
          id
          provider_id
          price
          created
          validity_days
          description
          updated
          proposalsPopRfqId
          prototypePrice
          hidden
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      providers {
        idProvider
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      popOrderId
      orderId
      estatus
      start_time
      delivery_time
      saving
      saving_percentage
      saving_real
      budget
      hasQrCode
      created
      createdAt
      updated
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRfqPopsQueryVariables,
  APITypes.ListRfqPopsQuery
>;
export const getProposalsPop = /* GraphQL */ `query GetProposalsPop($id: ID!) {
  getProposalsPop(id: $id) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    price
    created
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    vehicles {
      productUnitRfqIndex
      selected
      name
      popMaterialId
      vehicleTypeId
      brand
      size
      description
      quantity
      packaging
      materialDetail
      print
      unitPrice
      pieces
      priceUnit
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    rfq {
      id
      nombre
      requerimiento
      vehicleTypeId
      popMaterialId
      vehiclesRfq {
        vehicleTypeId
        popMaterialId
        name
        description
        pieces
        createdId
        __typename
      }
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      proposals {
        items {
          id
          provider_id
          price
          created
          validity_days
          description
          updated
          proposalsPopRfqId
          prototypePrice
          hidden
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      providers {
        idProvider
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      popOrderId
      orderId
      estatus
      start_time
      delivery_time
      saving
      saving_percentage
      saving_real
      budget
      hasQrCode
      created
      createdAt
      updated
      updatedAt
      __typename
    }
    proposalsPopRfqId
    prototypePrice
    hidden
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProposalsPopQueryVariables,
  APITypes.GetProposalsPopQuery
>;
export const listProposalsPops = /* GraphQL */ `query ListProposalsPops(
  $filter: ModelProposalsPopFilterInput
  $limit: Int
  $nextToken: String
) {
  listProposalsPops(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      provider_id
      delivery_time {
        lower
        upper
        __typename
      }
      price
      created
      validity_days
      description
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      vehicles {
        productUnitRfqIndex
        selected
        name
        popMaterialId
        vehicleTypeId
        brand
        size
        description
        quantity
        packaging
        materialDetail
        print
        unitPrice
        pieces
        priceUnit
        total
        idProducto
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        __typename
      }
      updated
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      rfq {
        id
        nombre
        requerimiento
        vehicleTypeId
        popMaterialId
        vehiclesRfq {
          vehicleTypeId
          popMaterialId
          name
          description
          pieces
          createdId
          __typename
        }
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        compras {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        cantidad
        limit_time
        creatorInfo {
          name
          email
          user_id
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        proposals {
          nextToken
          __typename
        }
        creator
        clientId
        winner {
          proveeedor_id
          date
          __typename
        }
        logs {
          creatorId
          description
          date
          status
          provider_id
          __typename
        }
        providers {
          idProvider
          __typename
        }
        orderAgents {
          name
          email
          phoneNumber
          user_id
          __typename
        }
        orderAgentIds
        popOrderId
        orderId
        estatus
        start_time
        delivery_time
        saving
        saving_percentage
        saving_real
        budget
        hasQrCode
        created
        createdAt
        updated
        updatedAt
        __typename
      }
      proposalsPopRfqId
      prototypePrice
      hidden
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProposalsPopsQueryVariables,
  APITypes.ListProposalsPopsQuery
>;
export const getUsersBrands = /* GraphQL */ `query GetUsersBrands($id: ID!) {
  getUsersBrands(id: $id) {
    id
    name
    description
    logo {
      key
      url
      color
      palette
      colorName
      __typename
    }
    status
    clientId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUsersBrandsQueryVariables,
  APITypes.GetUsersBrandsQuery
>;
export const listUsersBrands = /* GraphQL */ `query ListUsersBrands(
  $filter: ModelUsersBrandsFilterInput
  $limit: Int
  $nextToken: String
) {
  listUsersBrands(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      clientId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUsersBrandsQueryVariables,
  APITypes.ListUsersBrandsQuery
>;
export const getUserBrandSetting = /* GraphQL */ `query GetUserBrandSetting($id: ID!) {
  getUserBrandSetting(id: $id) {
    id
    categories
    subcategories
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserBrandSettingQueryVariables,
  APITypes.GetUserBrandSettingQuery
>;
export const listUserBrandSettings = /* GraphQL */ `query ListUserBrandSettings(
  $filter: ModelUserBrandSettingFilterInput
  $limit: Int
  $nextToken: String
) {
  listUserBrandSettings(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      categories
      subcategories
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListUserBrandSettingsQueryVariables,
  APITypes.ListUserBrandSettingsQuery
>;
export const getLogsPUsers = /* GraphQL */ `query GetLogsPUsers($id: ID!) {
  getLogsPUsers(id: $id) {
    id
    user
    keyword
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLogsPUsersQueryVariables,
  APITypes.GetLogsPUsersQuery
>;
export const listLogsPUsers = /* GraphQL */ `query ListLogsPUsers(
  $filter: ModelLogsPUsersFilterInput
  $limit: Int
  $nextToken: String
) {
  listLogsPUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      user
      keyword
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLogsPUsersQueryVariables,
  APITypes.ListLogsPUsersQuery
>;
export const getClipPayment = /* GraphQL */ `query GetClipPayment($id: ID!) {
  getClipPayment(id: $id) {
    id
    status
    requestsCount
    payment_request_id
    purchase_description
    orderId
    clientId
    userId
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetClipPaymentQueryVariables,
  APITypes.GetClipPaymentQuery
>;
export const listClipPayments = /* GraphQL */ `query ListClipPayments(
  $filter: ModelClipPaymentFilterInput
  $limit: Int
  $nextToken: String
) {
  listClipPayments(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      requestsCount
      payment_request_id
      purchase_description
      orderId
      clientId
      userId
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListClipPaymentsQueryVariables,
  APITypes.ListClipPaymentsQuery
>;
export const getOrderProcess = /* GraphQL */ `query GetOrderProcess($id: ID!) {
  getOrderProcess(id: $id) {
    id
    type
    status
    tcdPayment
    name
    duration
    descripcion
    position
    responsible
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    cards {
      id
      name
      permissions {
        idCard
        rol
        thirdContent
        visible
        __typename
      }
      __typename
    }
    subprocesses {
      items {
        id
        type
        status
        name
        position
        descripcion
        action
        process {
          id
          type
          status
          tcdPayment
          name
          duration
          descripcion
          position
          responsible
          clientId
          createdAt
          updatedAt
          __typename
        }
        processId
        clientId
        messages {
          description
          rol
          visibleAction
          __typename
        }
        notifications {
          group
          enabledEmail
          enabledPopUp
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    clientId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOrderProcessQueryVariables,
  APITypes.GetOrderProcessQuery
>;
export const listOrderProcesses = /* GraphQL */ `query ListOrderProcesses(
  $filter: ModelOrderProcessFilterInput
  $limit: Int
  $nextToken: String
) {
  listOrderProcesses(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      type
      status
      tcdPayment
      name
      duration
      descripcion
      position
      responsible
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      cards {
        id
        name
        permissions {
          idCard
          rol
          thirdContent
          visible
          __typename
        }
        __typename
      }
      subprocesses {
        items {
          id
          type
          status
          name
          position
          descripcion
          action
          processId
          clientId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      clientId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOrderProcessesQueryVariables,
  APITypes.ListOrderProcessesQuery
>;
export const getOrderSubprocess = /* GraphQL */ `query GetOrderSubprocess($id: ID!) {
  getOrderSubprocess(id: $id) {
    id
    type
    status
    name
    position
    descripcion
    action
    process {
      id
      type
      status
      tcdPayment
      name
      duration
      descripcion
      position
      responsible
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      cards {
        id
        name
        permissions {
          idCard
          rol
          thirdContent
          visible
          __typename
        }
        __typename
      }
      subprocesses {
        items {
          id
          type
          status
          name
          position
          descripcion
          action
          processId
          clientId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      clientId
      createdAt
      updatedAt
      __typename
    }
    processId
    clientId
    messages {
      description
      rol
      visibleAction
      __typename
    }
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOrderSubprocessQueryVariables,
  APITypes.GetOrderSubprocessQuery
>;
export const listOrderSubprocesses = /* GraphQL */ `query ListOrderSubprocesses(
  $filter: ModelOrderSubprocessFilterInput
  $limit: Int
  $nextToken: String
) {
  listOrderSubprocesses(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      type
      status
      name
      position
      descripcion
      action
      process {
        id
        type
        status
        tcdPayment
        name
        duration
        descripcion
        position
        responsible
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        cards {
          id
          name
          __typename
        }
        subprocesses {
          nextToken
          __typename
        }
        clientId
        createdAt
        updatedAt
        __typename
      }
      processId
      clientId
      messages {
        description
        rol
        visibleAction
        __typename
      }
      notifications {
        group
        enabledEmail
        enabledPopUp
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOrderSubprocessesQueryVariables,
  APITypes.ListOrderSubprocessesQuery
>;
export const getPremiumOrder = /* GraphQL */ `query GetPremiumOrder($id: ID!) {
  getPremiumOrder(id: $id) {
    id
    requirement
    bank_reference
    hasVat
    billingData {
      name
      rfc
      regimen
      cfdi_use
      cp
      email
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      __typename
    }
    orderId
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    logs {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      role
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    delivery_cost
    delivery_fee
    delivery_discount
    delivery_time
    delivery_date
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    taxSituationFile {
      key
      url
      color
      palette
      colorName
      __typename
    }
    clipUrl
    clipStatus
    listProviders {
      provider_id
      order_id
      payment_date
      gr_code
      order_confirmation
      invoice
      invoiceRequested
      uploadedGr
      uploadedBill
      delivered
      deliveredFormat
      __typename
    }
    providers {
      items {
        id
        provider_id
        clientId
        orderId
        orderProvidersPremiumOrderId
        payment_date
        gr_code
        invoice
        invoiceRequested
        uploadedGr
        uploadedBill
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    listsProducts {
      product_id
      provider_id
      index
      print
      printPrice
      product_name
      description
      category
      unspsc
      price
      originalPrice
      sample_requested
      sample_request
      sample_authorize
      sample_authorized
      quality_requested
      quality_request
      uploadedSample
      quantity
      isExternal
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sku
      qualityForm {
        initiativeDescription
        targetUser
        retailBrandName
        itemCategory
        itemPicture
        originCountry
        quantityPerCountryOfDist
        initiativeDates
        isPartOfAnMSOCustOrSpecPack
        incluesClientLogo
        isAReorderWithinTwelveMonths
        isReorder
        PGPLContactName
        ulTracking
        PLContactName
        contactEmailAddress
        PGPurchaseOrderNumber
        EBBSorSupplierProvidedProjectNumber
        vendorCompanyName
        vendorContactName
        vendorEmailAddress
        vendorJobTitle
        vendorTelephone
        vendorMailingAddress
        vendorCity
        vendorState
        vendorCountry
        vendorPC
        physicalItemDescription
        SampleOrMaterialComponentSubmitted
        toWhom
        descriptionOfItemPackagingAndArtwork
        regulatoryAndLegislativeProductCertification
        dateFinalApprovalRequestedSubmittedToPG
        DateOfDeclarationOfConformity
        dateOfApprovalExpirationOfPremiumItem
        itemClasification
        PGRepresentativeMarketingDesign
        PGProjectLeaderRequestor
        PGRestrictedItemsLocalPGLegal
        PGLocalCategoryGM
        PGLocalCategoryJoanAbbinanteNissenNotPowered
        idProduct
        pathDocument
        __typename
      }
      fee
      increment
      discount
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      sellMode
      kitPieces
      __typename
    }
    cotizationsList {
      id
      created
      createdBy
      products {
        product_id
        provider_id
        index
        print
        printPrice
        product_name
        description
        category
        unspsc
        price
        originalPrice
        sample_requested
        sample_request
        sample_authorize
        sample_authorized
        quality_requested
        quality_request
        uploadedSample
        quantity
        isExternal
        variant {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        sku
        qualityForm {
          initiativeDescription
          targetUser
          retailBrandName
          itemCategory
          itemPicture
          originCountry
          quantityPerCountryOfDist
          initiativeDates
          isPartOfAnMSOCustOrSpecPack
          incluesClientLogo
          isAReorderWithinTwelveMonths
          isReorder
          PGPLContactName
          ulTracking
          PLContactName
          contactEmailAddress
          PGPurchaseOrderNumber
          EBBSorSupplierProvidedProjectNumber
          vendorCompanyName
          vendorContactName
          vendorEmailAddress
          vendorJobTitle
          vendorTelephone
          vendorMailingAddress
          vendorCity
          vendorState
          vendorCountry
          vendorPC
          physicalItemDescription
          SampleOrMaterialComponentSubmitted
          toWhom
          descriptionOfItemPackagingAndArtwork
          regulatoryAndLegislativeProductCertification
          dateFinalApprovalRequestedSubmittedToPG
          DateOfDeclarationOfConformity
          dateOfApprovalExpirationOfPremiumItem
          itemClasification
          PGRepresentativeMarketingDesign
          PGProjectLeaderRequestor
          PGRestrictedItemsLocalPGLegal
          PGLocalCategoryGM
          PGLocalCategoryJoanAbbinanteNissenNotPowered
          idProduct
          pathDocument
          __typename
        }
        fee
        increment
        discount
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        sellMode
        kitPieces
        __typename
      }
      __typename
    }
    orderCreatorId
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    invoiceContact {
      name
      email
      authorized
      __typename
    }
    contact {
      name
      tel
      __typename
    }
    premiumOrderClientId
    client {
      id
      status
      business_name
      comertial_name
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      grayLogo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      contact {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      biography
      plan
      fee
      increment
      mercadoFee
      mercadoIncrement
      popFee
      popIncrement
      printedFee
      printedIncrement
      users
      restrictedUsers
      nonRestrictedUsers
      regions
      providers
      popProviders
      printedProviders
      logisticFrequency
      agents {
        id
        name
        email
        phoneNumber
        __typename
      }
      administrators {
        id
        name
        email
        phoneNumber
        __typename
      }
      signDocument {
        url
        enabled
        __typename
      }
      legal_representative
      legal_representative_email
      legal_representative_address
      tcdUsers
      billingUsers {
        id
        name
        email
        phoneNumber
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    userBrandId
    userBrand {
      id
      name
      description
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      clientId
      createdAt
      updatedAt
      __typename
    }
    subtotal
    fee
    printedPrice
    total
    discountAmount
    syncWithCrm
    crmIssueKey
    sentToAlendum
    alendumProjectId
    syncWithFms
    fmsInvoiceId
    syncWithWms
    wmsProjectId
    isCoupa
    sentToCoupa
    isRfq
    requireSamples
    requestedSamples
    approvedSamples
    authorizedQA
    active
    currentProcess
    currentSubprocess
    processes {
      id
      name
      descripcion
      duration
      position
      responsible
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      madeBy
      madeAt
      cards {
        id
        name
        permissions {
          idCard
          rol
          thirdContent
          visible
          __typename
        }
        __typename
      }
      subprocesses {
        id
        name
        position
        descripcion
        action
        process
        madeBy
        madeAt
        messages {
          description
          rol
          visibleAction
          __typename
        }
        notifications {
          group
          enabledEmail
          enabledPopUp
          __typename
        }
        __typename
      }
      __typename
    }
    updatedAt
    created
    updated
    logistic {
      premiumOrderId
      tracking_number
      destiny_latitude
      destiny_longitude
      status
      status_activity
      status_description
      origin_latitude
      origin_longitude
      carrier
      clave_sat
      customer_delivery_start_date
      customer_email
      customer_external_number
      customer_first_name
      customer_last_name
      customer_mobile_number
      customer_postcode
      customer_settlement
      customer_street
      descripcion_sat
      peligroso
      primary_client
      purchase_order_number
      shipping_method
      shipping_option
      created
      __typename
    }
    createdAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPremiumOrderQueryVariables,
  APITypes.GetPremiumOrderQuery
>;
export const listPremiumOrders = /* GraphQL */ `query ListPremiumOrders(
  $filter: ModelPremiumOrderFilterInput
  $limit: Int
  $nextToken: String
) {
  listPremiumOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      requirement
      bank_reference
      hasVat
      billingData {
        name
        rfc
        regimen
        cfdi_use
        cp
        email
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        __typename
      }
      orderId
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      logs {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        role
        __typename
      }
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_fee
      delivery_discount
      delivery_time
      delivery_date
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      taxSituationFile {
        key
        url
        color
        palette
        colorName
        __typename
      }
      clipUrl
      clipStatus
      listProviders {
        provider_id
        order_id
        payment_date
        gr_code
        order_confirmation
        invoice
        invoiceRequested
        uploadedGr
        uploadedBill
        delivered
        deliveredFormat
        __typename
      }
      providers {
        items {
          id
          provider_id
          clientId
          orderId
          orderProvidersPremiumOrderId
          payment_date
          gr_code
          invoice
          invoiceRequested
          uploadedGr
          uploadedBill
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      listsProducts {
        product_id
        provider_id
        index
        print
        printPrice
        product_name
        description
        category
        unspsc
        price
        originalPrice
        sample_requested
        sample_request
        sample_authorize
        sample_authorized
        quality_requested
        quality_request
        uploadedSample
        quantity
        isExternal
        variant {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        sku
        qualityForm {
          initiativeDescription
          targetUser
          retailBrandName
          itemCategory
          itemPicture
          originCountry
          quantityPerCountryOfDist
          initiativeDates
          isPartOfAnMSOCustOrSpecPack
          incluesClientLogo
          isAReorderWithinTwelveMonths
          isReorder
          PGPLContactName
          ulTracking
          PLContactName
          contactEmailAddress
          PGPurchaseOrderNumber
          EBBSorSupplierProvidedProjectNumber
          vendorCompanyName
          vendorContactName
          vendorEmailAddress
          vendorJobTitle
          vendorTelephone
          vendorMailingAddress
          vendorCity
          vendorState
          vendorCountry
          vendorPC
          physicalItemDescription
          SampleOrMaterialComponentSubmitted
          toWhom
          descriptionOfItemPackagingAndArtwork
          regulatoryAndLegislativeProductCertification
          dateFinalApprovalRequestedSubmittedToPG
          DateOfDeclarationOfConformity
          dateOfApprovalExpirationOfPremiumItem
          itemClasification
          PGRepresentativeMarketingDesign
          PGProjectLeaderRequestor
          PGRestrictedItemsLocalPGLegal
          PGLocalCategoryGM
          PGLocalCategoryJoanAbbinanteNissenNotPowered
          idProduct
          pathDocument
          __typename
        }
        fee
        increment
        discount
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        sellMode
        kitPieces
        __typename
      }
      cotizationsList {
        id
        created
        createdBy
        products {
          product_id
          provider_id
          index
          print
          printPrice
          product_name
          description
          category
          unspsc
          price
          originalPrice
          sample_requested
          sample_request
          sample_authorize
          sample_authorized
          quality_requested
          quality_request
          uploadedSample
          quantity
          isExternal
          sku
          fee
          increment
          discount
          sellMode
          kitPieces
          __typename
        }
        __typename
      }
      orderCreatorId
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      invoiceContact {
        name
        email
        authorized
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      premiumOrderClientId
      client {
        id
        status
        business_name
        comertial_name
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        buyerInfo {
          name
          email
          authorized
          __typename
        }
        buyersInfo {
          name
          email
          authorized
          __typename
        }
        biography
        plan
        fee
        increment
        mercadoFee
        mercadoIncrement
        popFee
        popIncrement
        printedFee
        printedIncrement
        users
        restrictedUsers
        nonRestrictedUsers
        regions
        providers
        popProviders
        printedProviders
        logisticFrequency
        agents {
          id
          name
          email
          phoneNumber
          __typename
        }
        administrators {
          id
          name
          email
          phoneNumber
          __typename
        }
        signDocument {
          url
          enabled
          __typename
        }
        legal_representative
        legal_representative_email
        legal_representative_address
        tcdUsers
        billingUsers {
          id
          name
          email
          phoneNumber
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      userBrandId
      userBrand {
        id
        name
        description
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        clientId
        createdAt
        updatedAt
        __typename
      }
      subtotal
      fee
      printedPrice
      total
      discountAmount
      syncWithCrm
      crmIssueKey
      sentToAlendum
      alendumProjectId
      syncWithFms
      fmsInvoiceId
      syncWithWms
      wmsProjectId
      isCoupa
      sentToCoupa
      isRfq
      requireSamples
      requestedSamples
      approvedSamples
      authorizedQA
      active
      currentProcess
      currentSubprocess
      processes {
        id
        name
        descripcion
        duration
        position
        responsible
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        madeBy
        madeAt
        cards {
          id
          name
          __typename
        }
        subprocesses {
          id
          name
          position
          descripcion
          action
          process
          madeBy
          madeAt
          __typename
        }
        __typename
      }
      updatedAt
      created
      updated
      logistic {
        premiumOrderId
        tracking_number
        destiny_latitude
        destiny_longitude
        status
        status_activity
        status_description
        origin_latitude
        origin_longitude
        carrier
        clave_sat
        customer_delivery_start_date
        customer_email
        customer_external_number
        customer_first_name
        customer_last_name
        customer_mobile_number
        customer_postcode
        customer_settlement
        customer_street
        descripcion_sat
        peligroso
        primary_client
        purchase_order_number
        shipping_method
        shipping_option
        created
        __typename
      }
      createdAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPremiumOrdersQueryVariables,
  APITypes.ListPremiumOrdersQuery
>;
export const getPrintedCart = /* GraphQL */ `query GetPrintedCart($id: ID!) {
  getPrintedCart(id: $id) {
    id
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      name
      type
      tracking_code
      provider_id
      product_id
      description
      __typename
    }
    printedProducts {
      product_id
      provider_id
      visible
      product_name
      price
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sample_requested
      sample_request
      uploadedSample
      quantity
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      __typename
    }
    creator
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPrintedCartQueryVariables,
  APITypes.GetPrintedCartQuery
>;
export const listPrintedCarts = /* GraphQL */ `query ListPrintedCarts(
  $filter: ModelPrintedCartFilterInput
  $limit: Int
  $nextToken: String
) {
  listPrintedCarts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        name
        type
        tracking_code
        provider_id
        product_id
        description
        __typename
      }
      printedProducts {
        product_id
        provider_id
        visible
        product_name
        price
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        sample_requested
        sample_request
        uploadedSample
        quantity
        variant {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        __typename
      }
      creator
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPrintedCartsQueryVariables,
  APITypes.ListPrintedCartsQuery
>;
export const getPrintedCategory = /* GraphQL */ `query GetPrintedCategory($id: ID!) {
  getPrintedCategory(id: $id) {
    id
    name
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    route
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    printedSubcategories {
      items {
        id
        name
        printedCategoryId
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        parent {
          id
          name
          route
          created
          visibleFor
          region
          createdAt
          updatedAt
          __typename
        }
        created
        printedProducts {
          nextToken
          __typename
        }
        visibleFor
        region
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    printedProducts {
      items {
        id
        status
        position
        name
        width
        height
        images {
          key
          url
          color
          palette
          colorName
          __typename
        }
        price
        long_description
        short_description
        creator
        providerId
        finalDimensions
        pagesNumber
        finishes
        inksFourByCero
        inksFourByFour
        paperKind
        grammage
        hasBarniz
        hasRebase
        orientation
        specialInstructions
        PrintedSubcategoryId
        printedCategoryId
        created
        variants {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        visibleFor
        filterColors
        regions
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    created
    visibleFor
    region
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPrintedCategoryQueryVariables,
  APITypes.GetPrintedCategoryQuery
>;
export const listPrintedCategories = /* GraphQL */ `query ListPrintedCategories(
  $filter: ModelPrintedCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listPrintedCategories(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      route
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      printedSubcategories {
        items {
          id
          name
          printedCategoryId
          created
          visibleFor
          region
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      printedProducts {
        items {
          id
          status
          position
          name
          width
          height
          price
          long_description
          short_description
          creator
          providerId
          finalDimensions
          pagesNumber
          finishes
          inksFourByCero
          inksFourByFour
          paperKind
          grammage
          hasBarniz
          hasRebase
          orientation
          specialInstructions
          PrintedSubcategoryId
          printedCategoryId
          created
          visibleFor
          filterColors
          regions
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      created
      visibleFor
      region
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPrintedCategoriesQueryVariables,
  APITypes.ListPrintedCategoriesQuery
>;
export const getPrintedSubcategory = /* GraphQL */ `query GetPrintedSubcategory($id: ID!) {
  getPrintedSubcategory(id: $id) {
    id
    name
    printedCategoryId
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    parent {
      id
      name
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      route
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      printedSubcategories {
        items {
          id
          name
          printedCategoryId
          created
          visibleFor
          region
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      printedProducts {
        items {
          id
          status
          position
          name
          width
          height
          price
          long_description
          short_description
          creator
          providerId
          finalDimensions
          pagesNumber
          finishes
          inksFourByCero
          inksFourByFour
          paperKind
          grammage
          hasBarniz
          hasRebase
          orientation
          specialInstructions
          PrintedSubcategoryId
          printedCategoryId
          created
          visibleFor
          filterColors
          regions
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      created
      visibleFor
      region
      createdAt
      updatedAt
      __typename
    }
    created
    printedProducts {
      items {
        id
        status
        position
        name
        width
        height
        images {
          key
          url
          color
          palette
          colorName
          __typename
        }
        price
        long_description
        short_description
        creator
        providerId
        finalDimensions
        pagesNumber
        finishes
        inksFourByCero
        inksFourByFour
        paperKind
        grammage
        hasBarniz
        hasRebase
        orientation
        specialInstructions
        PrintedSubcategoryId
        printedCategoryId
        created
        variants {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        visibleFor
        filterColors
        regions
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    visibleFor
    region
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPrintedSubcategoryQueryVariables,
  APITypes.GetPrintedSubcategoryQuery
>;
export const listPrintedSubcategories = /* GraphQL */ `query ListPrintedSubcategories(
  $filter: ModelPrintedSubcategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listPrintedSubcategories(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      printedCategoryId
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      parent {
        id
        name
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        route
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        printedSubcategories {
          nextToken
          __typename
        }
        printedProducts {
          nextToken
          __typename
        }
        created
        visibleFor
        region
        createdAt
        updatedAt
        __typename
      }
      created
      printedProducts {
        items {
          id
          status
          position
          name
          width
          height
          price
          long_description
          short_description
          creator
          providerId
          finalDimensions
          pagesNumber
          finishes
          inksFourByCero
          inksFourByFour
          paperKind
          grammage
          hasBarniz
          hasRebase
          orientation
          specialInstructions
          PrintedSubcategoryId
          printedCategoryId
          created
          visibleFor
          filterColors
          regions
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      visibleFor
      region
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPrintedSubcategoriesQueryVariables,
  APITypes.ListPrintedSubcategoriesQuery
>;
export const getPrintedProducts = /* GraphQL */ `query GetPrintedProducts($id: ID!) {
  getPrintedProducts(id: $id) {
    id
    status
    position
    name
    width
    height
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    price
    long_description
    short_description
    creator
    providerId
    finalDimensions
    pagesNumber
    finishes
    inksFourByCero
    inksFourByFour
    paperKind
    grammage
    hasBarniz
    hasRebase
    orientation
    specialInstructions
    PrintedSubcategoryId
    printedCategoryId
    created
    variants {
      sku
      name
      description
      colors
      filterColors
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      stock_available
      price
      size
      logoType
      __typename
    }
    visibleFor
    filterColors
    regions
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPrintedProductsQueryVariables,
  APITypes.GetPrintedProductsQuery
>;
export const listPrintedProducts = /* GraphQL */ `query ListPrintedProducts(
  $filter: ModelPrintedProductsFilterInput
  $limit: Int
  $nextToken: String
) {
  listPrintedProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      position
      name
      width
      height
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      price
      long_description
      short_description
      creator
      providerId
      finalDimensions
      pagesNumber
      finishes
      inksFourByCero
      inksFourByFour
      paperKind
      grammage
      hasBarniz
      hasRebase
      orientation
      specialInstructions
      PrintedSubcategoryId
      printedCategoryId
      created
      variants {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      visibleFor
      filterColors
      regions
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPrintedProductsQueryVariables,
  APITypes.ListPrintedProductsQuery
>;
export const getPrintedRfq = /* GraphQL */ `query GetPrintedRfq($id: ID!) {
  getPrintedRfq(id: $id) {
    id
    nombre
    requerimiento
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    limit_time
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        price
        validity_days
        description
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        hidden
        rfq {
          id
          nombre
          requerimiento
          limit_time
          creator
          clientId
          estatus
          printedOrderId
          start_time
          delivery_time
          created
          saving
          saving_percentage
          saving_real
          createdAt
          updatedAt
          updated
          __typename
        }
        printedProposalRfqId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    creator
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    clientId
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    estatus
    printedOrderId
    start_time
    delivery_time
    created
    saving
    saving_percentage
    saving_real
    createdAt
    updatedAt
    updated
    providers {
      idProvider
      __typename
    }
    printedProductsRfq {
      name
      description
      pieces
      createdId
      __typename
    }
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPrintedRfqQueryVariables,
  APITypes.GetPrintedRfqQuery
>;
export const listPrintedRfqs = /* GraphQL */ `query ListPrintedRfqs(
  $filter: ModelPrintedRfqFilterInput
  $limit: Int
  $nextToken: String
) {
  listPrintedRfqs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      limit_time
      proposals {
        items {
          id
          provider_id
          price
          validity_days
          description
          created
          updated
          hidden
          printedProposalRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      estatus
      printedOrderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      providers {
        idProvider
        __typename
      }
      printedProductsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPrintedRfqsQueryVariables,
  APITypes.ListPrintedRfqsQuery
>;
export const getPrintedProductoRfq = /* GraphQL */ `query GetPrintedProductoRfq($id: ID!) {
  getPrintedProductoRfq(id: $id) {
    id
    name
    description
    category_id
    provider_id
    price
    category
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    estatus
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPrintedProductoRfqQueryVariables,
  APITypes.GetPrintedProductoRfqQuery
>;
export const listPrintedProductoRfqs = /* GraphQL */ `query ListPrintedProductoRfqs(
  $filter: ModelPrintedProductoRfqFilterInput
  $limit: Int
  $nextToken: String
) {
  listPrintedProductoRfqs(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      description
      category_id
      provider_id
      price
      category
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      estatus
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPrintedProductoRfqsQueryVariables,
  APITypes.ListPrintedProductoRfqsQuery
>;
export const getPrintedProposal = /* GraphQL */ `query GetPrintedProposal($id: ID!) {
  getPrintedProposal(id: $id) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    price
    validity_days
    description
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    hidden
    rfq {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      limit_time
      proposals {
        items {
          id
          provider_id
          price
          validity_days
          description
          created
          updated
          hidden
          printedProposalRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      estatus
      printedOrderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      providers {
        idProvider
        __typename
      }
      printedProductsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    printedProposalRfqId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPrintedProposalQueryVariables,
  APITypes.GetPrintedProposalQuery
>;
export const listPrintedProposals = /* GraphQL */ `query ListPrintedProposals(
  $filter: ModelPrintedProposalFilterInput
  $limit: Int
  $nextToken: String
) {
  listPrintedProposals(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      provider_id
      delivery_time {
        lower
        upper
        __typename
      }
      price
      validity_days
      description
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      created
      updated
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      products {
        productUnitRfqIndex
        selected
        name
        description
        priceUnit
        pieces
        total
        idProducto
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        __typename
      }
      hidden
      rfq {
        id
        nombre
        requerimiento
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        compras {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        limit_time
        proposals {
          nextToken
          __typename
        }
        creator
        creatorInfo {
          name
          email
          user_id
          __typename
        }
        clientId
        winner {
          proveeedor_id
          date
          __typename
        }
        logs {
          creatorId
          description
          date
          status
          provider_id
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        estatus
        printedOrderId
        start_time
        delivery_time
        created
        saving
        saving_percentage
        saving_real
        createdAt
        updatedAt
        updated
        providers {
          idProvider
          __typename
        }
        printedProductsRfq {
          name
          description
          pieces
          createdId
          __typename
        }
        __typename
      }
      printedProposalRfqId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPrintedProposalsQueryVariables,
  APITypes.ListPrintedProposalsQuery
>;
export const getPrintedOrder = /* GraphQL */ `query GetPrintedOrder($id: ID!) {
  getPrintedOrder(id: $id) {
    id
    orderId
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    delivery_addresses {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    delivery_cost
    delivery_time
    files {
      created
      creator_id
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      statusFile
      name
      provider_id
      product_id
      tracking_code
      gr_code
      coupa_order
      description
      __typename
    }
    listProviders {
      provider_id
      order_id
      payment_date
      gr_code
      order_confirmation
      invoice
      invoiceRequested
      uploadedGr
      uploadedBill
      delivered
      deliveredFormat
      __typename
    }
    listProvidersKey
    orderAgents {
      name
      email
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    orderAgentIds
    listPrintedProducts {
      product_id
      provider_id
      visible
      product_name
      price
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      sample_requested
      sample_request
      uploadedSample
      quantity
      variant {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      __typename
    }
    cotizationsList {
      id
      created
      createdBy
      products {
        product_id
        provider_id
        visible
        product_name
        price
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        sample_requested
        sample_request
        uploadedSample
        quantity
        variant {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        __typename
      }
      __typename
    }
    orderCreatorId
    creator {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    buyerInfo {
      name
      email
      authorized
      __typename
    }
    buyersInfo {
      name
      email
      authorized
      __typename
    }
    contact {
      name
      tel
      __typename
    }
    printedOrderClientId
    subtotal
    total
    isCoupa
    sentToCoupa
    isRfq
    status
    currentProcess
    currentSubprocess
    updatedAt
    created
    updated
    createdAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPrintedOrderQueryVariables,
  APITypes.GetPrintedOrderQuery
>;
export const listPrintedOrders = /* GraphQL */ `query ListPrintedOrders(
  $filter: ModelPrintedOrderFilterInput
  $limit: Int
  $nextToken: String
) {
  listPrintedOrders(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      orderId
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      listProviders {
        provider_id
        order_id
        payment_date
        gr_code
        order_confirmation
        invoice
        invoiceRequested
        uploadedGr
        uploadedBill
        delivered
        deliveredFormat
        __typename
      }
      listProvidersKey
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      listPrintedProducts {
        product_id
        provider_id
        visible
        product_name
        price
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        sample_requested
        sample_request
        uploadedSample
        quantity
        variant {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        __typename
      }
      cotizationsList {
        id
        created
        createdBy
        products {
          product_id
          provider_id
          visible
          product_name
          price
          sample_requested
          sample_request
          uploadedSample
          quantity
          __typename
        }
        __typename
      }
      orderCreatorId
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      printedOrderClientId
      subtotal
      total
      isCoupa
      sentToCoupa
      isRfq
      status
      currentProcess
      currentSubprocess
      updatedAt
      created
      updated
      createdAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPrintedOrdersQueryVariables,
  APITypes.ListPrintedOrdersQuery
>;
export const getPrintedOrderProviders = /* GraphQL */ `query GetPrintedOrderProviders($id: ID!) {
  getPrintedOrderProviders(id: $id) {
    id
    provider_id
    orderId
    printedOrderProvidersPrintedOrderId
    payment_date
    gr_code
    invoice
    invoiceRequested
    uploadedGr
    uploadedBill
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPrintedOrderProvidersQueryVariables,
  APITypes.GetPrintedOrderProvidersQuery
>;
export const listPrintedOrderProviders = /* GraphQL */ `query ListPrintedOrderProviders(
  $filter: ModelPrintedOrderProvidersFilterInput
  $limit: Int
  $nextToken: String
) {
  listPrintedOrderProviders(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      provider_id
      orderId
      printedOrderProvidersPrintedOrderId
      payment_date
      gr_code
      invoice
      invoiceRequested
      uploadedGr
      uploadedBill
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPrintedOrderProvidersQueryVariables,
  APITypes.ListPrintedOrderProvidersQuery
>;
export const getPayOnBehalfRequests = /* GraphQL */ `query GetPayOnBehalfRequests($id: ID!) {
  getPayOnBehalfRequests(id: $id) {
    id
    clientId
    companyName
    purchaseOrder
    paymentTerms
    currency
    amount
    selectedVa
    iva
    vat
    total
    rfc {
      key
      url
      color
      palette
      colorName
      __typename
    }
    bankStatement {
      key
      url
      color
      palette
      colorName
      __typename
    }
    supplierQuote {
      key
      url
      color
      palette
      colorName
      __typename
    }
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPayOnBehalfRequestsQueryVariables,
  APITypes.GetPayOnBehalfRequestsQuery
>;
export const listPayOnBehalfRequests = /* GraphQL */ `query ListPayOnBehalfRequests(
  $filter: ModelPayOnBehalfRequestsFilterInput
  $limit: Int
  $nextToken: String
) {
  listPayOnBehalfRequests(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      clientId
      companyName
      purchaseOrder
      paymentTerms
      currency
      amount
      selectedVa
      iva
      vat
      total
      rfc {
        key
        url
        color
        palette
        colorName
        __typename
      }
      bankStatement {
        key
        url
        color
        palette
        colorName
        __typename
      }
      supplierQuote {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPayOnBehalfRequestsQueryVariables,
  APITypes.ListPayOnBehalfRequestsQuery
>;
export const getBuyerContactClient = /* GraphQL */ `query GetBuyerContactClient($id: ID!) {
  getBuyerContactClient(id: $id) {
    id
    companyId
    status
    defaultContact
    name
    email
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBuyerContactClientQueryVariables,
  APITypes.GetBuyerContactClientQuery
>;
export const listBuyerContactClients = /* GraphQL */ `query ListBuyerContactClients(
  $filter: ModelBuyerContactClientFilterInput
  $limit: Int
  $nextToken: String
) {
  listBuyerContactClients(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      companyId
      status
      defaultContact
      name
      email
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBuyerContactClientsQueryVariables,
  APITypes.ListBuyerContactClientsQuery
>;
export const getBrandFactoryRfqEmails = /* GraphQL */ `query GetBrandFactoryRfqEmails($id: ID!) {
  getBrandFactoryRfqEmails(id: $id) {
    id
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetBrandFactoryRfqEmailsQueryVariables,
  APITypes.GetBrandFactoryRfqEmailsQuery
>;
export const listBrandFactoryRfqEmails = /* GraphQL */ `query ListBrandFactoryRfqEmails(
  $filter: ModelBrandFactoryRfqEmailsFilterInput
  $limit: Int
  $nextToken: String
) {
  listBrandFactoryRfqEmails(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      name
      email
      created
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListBrandFactoryRfqEmailsQueryVariables,
  APITypes.ListBrandFactoryRfqEmailsQuery
>;
export const getAutomobilesEmails = /* GraphQL */ `query GetAutomobilesEmails($id: ID!) {
  getAutomobilesEmails(id: $id) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAutomobilesEmailsQueryVariables,
  APITypes.GetAutomobilesEmailsQuery
>;
export const listAutomobilesEmails = /* GraphQL */ `query ListAutomobilesEmails(
  $filter: ModelAutomobilesEmailsFilterInput
  $limit: Int
  $nextToken: String
) {
  listAutomobilesEmails(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      companyId
      status
      name
      email
      created
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAutomobilesEmailsQueryVariables,
  APITypes.ListAutomobilesEmailsQuery
>;
export const getQAEmails = /* GraphQL */ `query GetQAEmails($id: ID!) {
  getQAEmails(id: $id) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetQAEmailsQueryVariables,
  APITypes.GetQAEmailsQuery
>;
export const listQAEmails = /* GraphQL */ `query ListQAEmails(
  $filter: ModelQAEmailsFilterInput
  $limit: Int
  $nextToken: String
) {
  listQAEmails(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      companyId
      status
      name
      email
      created
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListQAEmailsQueryVariables,
  APITypes.ListQAEmailsQuery
>;
export const getOrderPopAdminEmails = /* GraphQL */ `query GetOrderPopAdminEmails($id: ID!) {
  getOrderPopAdminEmails(id: $id) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOrderPopAdminEmailsQueryVariables,
  APITypes.GetOrderPopAdminEmailsQuery
>;
export const listOrderPopAdminEmails = /* GraphQL */ `query ListOrderPopAdminEmails(
  $filter: ModelOrderPopAdminEmailsFilterInput
  $limit: Int
  $nextToken: String
) {
  listOrderPopAdminEmails(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      companyId
      status
      name
      email
      created
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOrderPopAdminEmailsQueryVariables,
  APITypes.ListOrderPopAdminEmailsQuery
>;
export const getOrderPopCheckoutEmails = /* GraphQL */ `query GetOrderPopCheckoutEmails($id: ID!) {
  getOrderPopCheckoutEmails(id: $id) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetOrderPopCheckoutEmailsQueryVariables,
  APITypes.GetOrderPopCheckoutEmailsQuery
>;
export const listOrderPopCheckoutEmails = /* GraphQL */ `query ListOrderPopCheckoutEmails(
  $filter: ModelOrderPopCheckoutEmailsFilterInput
  $limit: Int
  $nextToken: String
) {
  listOrderPopCheckoutEmails(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      companyId
      status
      name
      email
      created
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListOrderPopCheckoutEmailsQueryVariables,
  APITypes.ListOrderPopCheckoutEmailsQuery
>;
export const getGREmails = /* GraphQL */ `query GetGREmails($id: ID!) {
  getGREmails(id: $id) {
    id
    companyId
    status
    name
    email
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetGREmailsQueryVariables,
  APITypes.GetGREmailsQuery
>;
export const listGREmails = /* GraphQL */ `query ListGREmails(
  $filter: ModelGREmailsFilterInput
  $limit: Int
  $nextToken: String
) {
  listGREmails(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      companyId
      status
      name
      email
      created
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListGREmailsQueryVariables,
  APITypes.ListGREmailsQuery
>;
export const getRegions = /* GraphQL */ `query GetRegions($id: ID!) {
  getRegions(id: $id) {
    id
    status
    name
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRegionsQueryVariables,
  APITypes.GetRegionsQuery
>;
export const listRegions = /* GraphQL */ `query ListRegions(
  $filter: ModelRegionsFilterInput
  $limit: Int
  $nextToken: String
) {
  listRegions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      name
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRegionsQueryVariables,
  APITypes.ListRegionsQuery
>;
export const getDefaultAddress = /* GraphQL */ `query GetDefaultAddress($id: ID!) {
  getDefaultAddress(id: $id) {
    id
    companyId
    userId
    status
    address {
      street
      outdoor_number
      inside_number
      colony
      delegation
      state
      city
      postal_code
      chain
      name
      description
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDefaultAddressQueryVariables,
  APITypes.GetDefaultAddressQuery
>;
export const listDefaultAddresses = /* GraphQL */ `query ListDefaultAddresses(
  $filter: ModelDefaultAddressFilterInput
  $limit: Int
  $nextToken: String
) {
  listDefaultAddresses(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      companyId
      userId
      status
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDefaultAddressesQueryVariables,
  APITypes.ListDefaultAddressesQuery
>;
export const getDefaultDeliveryContact = /* GraphQL */ `query GetDefaultDeliveryContact($id: ID!) {
  getDefaultDeliveryContact(id: $id) {
    id
    companyId
    userId
    status
    name
    phoneNumber
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetDefaultDeliveryContactQueryVariables,
  APITypes.GetDefaultDeliveryContactQuery
>;
export const listDefaultDeliveryContacts = /* GraphQL */ `query ListDefaultDeliveryContacts(
  $filter: ModelDefaultDeliveryContactFilterInput
  $limit: Int
  $nextToken: String
) {
  listDefaultDeliveryContacts(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      companyId
      userId
      status
      name
      phoneNumber
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListDefaultDeliveryContactsQueryVariables,
  APITypes.ListDefaultDeliveryContactsQuery
>;
export const getPopCategories = /* GraphQL */ `query GetPopCategories($id: ID!) {
  getPopCategories(id: $id) {
    id
    materialId
    name
    visibleFor
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    created
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPopCategoriesQueryVariables,
  APITypes.GetPopCategoriesQuery
>;
export const listPopCategories = /* GraphQL */ `query ListPopCategories(
  $filter: ModelPopCategoriesFilterInput
  $limit: Int
  $nextToken: String
) {
  listPopCategories(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      materialId
      name
      visibleFor
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      created
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPopCategoriesQueryVariables,
  APITypes.ListPopCategoriesQuery
>;
export const getRfp = /* GraphQL */ `query GetRfp($id: ID!) {
  getRfp(id: $id) {
    id
    clientId
    status
    name
    nombre
    requerimiento
    estatus
    descripcion
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    url
    creatorInfo {
      name
      email
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      user_id
      __typename
    }
    proposals {
      items {
        id
        provider_id
        delivery_time {
          lower
          upper
          __typename
        }
        price
        name
        description
        validity_days
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        created
        updated
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        products {
          productUnitRfqIndex
          selected
          name
          description
          priceUnit
          pieces
          total
          idProducto
          __typename
        }
        multipleProducts
        hidden
        rfp {
          id
          clientId
          status
          name
          nombre
          requerimiento
          estatus
          descripcion
          url
          limit_time
          creator
          start_time
          delivery_time
          saving
          saving_percentage
          saving_real
          created
          createdAt
          updated
          updatedAt
          __typename
        }
        rfpProposalsRfpId
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    compras {
      first_name
      last_name
      email
      mobile_phone
      local_phone
      __typename
    }
    limit_time
    creator
    winner {
      proveeedor_id
      date
      __typename
    }
    logs {
      creatorId
      description
      date
      status
      provider_id
      __typename
    }
    providers {
      idProvider
      __typename
    }
    start_time
    delivery_time
    saving
    saving_percentage
    saving_real
    created
    createdAt
    updated
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetRfpQueryVariables, APITypes.GetRfpQuery>;
export const listRfps = /* GraphQL */ `query ListRfps($filter: ModelRfpFilterInput, $limit: Int, $nextToken: String) {
  listRfps(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      clientId
      status
      name
      nombre
      requerimiento
      estatus
      descripcion
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      url
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      proposals {
        items {
          id
          provider_id
          price
          name
          description
          validity_days
          created
          updated
          multipleProducts
          hidden
          rfpProposalsRfpId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      limit_time
      creator
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      providers {
        idProvider
        __typename
      }
      start_time
      delivery_time
      saving
      saving_percentage
      saving_real
      created
      createdAt
      updated
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<APITypes.ListRfpsQueryVariables, APITypes.ListRfpsQuery>;
export const getRfpProposals = /* GraphQL */ `query GetRfpProposals($id: ID!) {
  getRfpProposals(id: $id) {
    id
    provider_id
    delivery_time {
      lower
      upper
      __typename
    }
    price
    name
    description
    validity_days
    comments {
      text
      created
      creator_id
      creator_name
      creator_email
      isSourceDataUser
      creator_avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      company {
        comertial_name
        id
        __typename
      }
      replyTo
      role
      text_request
      nameUserReply
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      jiraKey
      __typename
    }
    chat {
      role
      is_reply
      to_user_id
      user_id
      text
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      created
      __typename
    }
    created
    updated
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    products {
      productUnitRfqIndex
      selected
      name
      description
      priceUnit
      pieces
      total
      idProducto
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      __typename
    }
    multipleProducts
    hidden
    rfp {
      id
      clientId
      status
      name
      nombre
      requerimiento
      estatus
      descripcion
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      url
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      proposals {
        items {
          id
          provider_id
          price
          name
          description
          validity_days
          created
          updated
          multipleProducts
          hidden
          rfpProposalsRfpId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      limit_time
      creator
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      providers {
        idProvider
        __typename
      }
      start_time
      delivery_time
      saving
      saving_percentage
      saving_real
      created
      createdAt
      updated
      updatedAt
      __typename
    }
    rfpProposalsRfpId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetRfpProposalsQueryVariables,
  APITypes.GetRfpProposalsQuery
>;
export const listRfpProposals = /* GraphQL */ `query ListRfpProposals(
  $filter: ModelRfpProposalsFilterInput
  $limit: Int
  $nextToken: String
) {
  listRfpProposals(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      provider_id
      delivery_time {
        lower
        upper
        __typename
      }
      price
      name
      description
      validity_days
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      created
      updated
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      products {
        productUnitRfqIndex
        selected
        name
        description
        priceUnit
        pieces
        total
        idProducto
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        __typename
      }
      multipleProducts
      hidden
      rfp {
        id
        clientId
        status
        name
        nombre
        requerimiento
        estatus
        descripcion
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        chat {
          role
          is_reply
          to_user_id
          user_id
          text
          created
          __typename
        }
        url
        creatorInfo {
          name
          email
          user_id
          __typename
        }
        proposals {
          nextToken
          __typename
        }
        compras {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        limit_time
        creator
        winner {
          proveeedor_id
          date
          __typename
        }
        logs {
          creatorId
          description
          date
          status
          provider_id
          __typename
        }
        providers {
          idProvider
          __typename
        }
        start_time
        delivery_time
        saving
        saving_percentage
        saving_real
        created
        createdAt
        updated
        updatedAt
        __typename
      }
      rfpProposalsRfpId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRfpProposalsQueryVariables,
  APITypes.ListRfpProposalsQuery
>;
export const getEvaluationProviders = /* GraphQL */ `query GetEvaluationProviders($id: ID!) {
  getEvaluationProviders(id: $id) {
    id
    providerId
    creratorId
    orderId
    time
    price
    quality
    att
    comments
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetEvaluationProvidersQueryVariables,
  APITypes.GetEvaluationProvidersQuery
>;
export const listEvaluationProviders = /* GraphQL */ `query ListEvaluationProviders(
  $filter: ModelEvaluationProvidersFilterInput
  $limit: Int
  $nextToken: String
) {
  listEvaluationProviders(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      providerId
      creratorId
      orderId
      time
      price
      quality
      att
      comments
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListEvaluationProvidersQueryVariables,
  APITypes.ListEvaluationProvidersQuery
>;
export const getLogProduct = /* GraphQL */ `query GetLogProduct($id: ID!) {
  getLogProduct(id: $id) {
    id
    status
    creator
    created
    productId
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLogProductQueryVariables,
  APITypes.GetLogProductQuery
>;
export const listLogProducts = /* GraphQL */ `query ListLogProducts(
  $filter: ModelLogProductFilterInput
  $limit: Int
  $nextToken: String
) {
  listLogProducts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      creator
      created
      productId
      description
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLogProductsQueryVariables,
  APITypes.ListLogProductsQuery
>;
export const getLogRfq = /* GraphQL */ `query GetLogRfq($id: ID!) {
  getLogRfq(id: $id) {
    id
    status
    creator
    rfqId
    description
    provider_id
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetLogRfqQueryVariables, APITypes.GetLogRfqQuery>;
export const listLogRfqs = /* GraphQL */ `query ListLogRfqs(
  $filter: ModelLogRfqFilterInput
  $limit: Int
  $nextToken: String
) {
  listLogRfqs(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      creator
      rfqId
      description
      provider_id
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLogRfqsQueryVariables,
  APITypes.ListLogRfqsQuery
>;
export const getLogProductLabel = /* GraphQL */ `query GetLogProductLabel($id: ID!) {
  getLogProductLabel(id: $id) {
    id
    status
    creator
    created
    productLabelId
    description
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLogProductLabelQueryVariables,
  APITypes.GetLogProductLabelQuery
>;
export const listLogProductLabels = /* GraphQL */ `query ListLogProductLabels(
  $filter: ModelLogProductLabelFilterInput
  $limit: Int
  $nextToken: String
) {
  listLogProductLabels(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      creator
      created
      productLabelId
      description
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLogProductLabelsQueryVariables,
  APITypes.ListLogProductLabelsQuery
>;
export const getLogGanadorAuto = /* GraphQL */ `query GetLogGanadorAuto($id: ID!) {
  getLogGanadorAuto(id: $id) {
    id
    id_auto
    id_user
    fecha_rifa
    email
    nombre
    a_paterno
    a_materno
    status_buyer
    date_buyer
    winner
    refused
    since
    process_buyer
    reactive
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLogGanadorAutoQueryVariables,
  APITypes.GetLogGanadorAutoQuery
>;
export const listLogGanadorAutos = /* GraphQL */ `query ListLogGanadorAutos(
  $filter: ModelLogGanadorAutoFilterInput
  $limit: Int
  $nextToken: String
) {
  listLogGanadorAutos(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      id_auto
      id_user
      fecha_rifa
      email
      nombre
      a_paterno
      a_materno
      status_buyer
      date_buyer
      winner
      refused
      since
      process_buyer
      reactive
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLogGanadorAutosQueryVariables,
  APITypes.ListLogGanadorAutosQuery
>;
export const getNotification = /* GraphQL */ `query GetNotification($id: ID!) {
  getNotification(id: $id) {
    id
    type
    remember
    stared
    important
    status
    isChat
    creatorName
    creatorEmail
    creatorRole
    creatorId
    receipentName
    receipentRole
    receipentEmail
    receipentId
    showPopUp
    sendEmail
    title
    subtitle
    description
    files {
      key
      url
      color
      palette
      colorName
      __typename
    }
    path
    idParent
    createdAt
    seenAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetNotificationQueryVariables,
  APITypes.GetNotificationQuery
>;
export const listNotifications = /* GraphQL */ `query ListNotifications(
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  listNotifications(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      type
      remember
      stared
      important
      status
      isChat
      creatorName
      creatorEmail
      creatorRole
      creatorId
      receipentName
      receipentRole
      receipentEmail
      receipentId
      showPopUp
      sendEmail
      title
      subtitle
      description
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      path
      idParent
      createdAt
      seenAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListNotificationsQueryVariables,
  APITypes.ListNotificationsQuery
>;
export const getMercadoCategories = /* GraphQL */ `query GetMercadoCategories($id: ID!) {
  getMercadoCategories(id: $id) {
    id
    idMercado
    status
    name
    rulesClients {
      clientID
      enabled
      isUnrestricted
      isRestricted
      increment
      fee
      __typename
    }
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    parentCategory
    childrenCategories
    items
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMercadoCategoriesQueryVariables,
  APITypes.GetMercadoCategoriesQuery
>;
export const listMercadoCategories = /* GraphQL */ `query ListMercadoCategories(
  $filter: ModelMercadoCategoriesFilterInput
  $limit: Int
  $nextToken: String
) {
  listMercadoCategories(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      idMercado
      status
      name
      rulesClients {
        clientID
        enabled
        isUnrestricted
        isRestricted
        increment
        fee
        __typename
      }
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      parentCategory
      childrenCategories
      items
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMercadoCategoriesQueryVariables,
  APITypes.ListMercadoCategoriesQuery
>;
export const getMercadoProductCategoryClient = /* GraphQL */ `query GetMercadoProductCategoryClient($id: ID!) {
  getMercadoProductCategoryClient(id: $id) {
    id
    idClient
    idMercadoCategory
    unrestrictedProducts
    restrictedProducts
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetMercadoProductCategoryClientQueryVariables,
  APITypes.GetMercadoProductCategoryClientQuery
>;
export const listMercadoProductCategoryClients = /* GraphQL */ `query ListMercadoProductCategoryClients(
  $filter: ModelMercadoProductCategoryClientFilterInput
  $limit: Int
  $nextToken: String
) {
  listMercadoProductCategoryClients(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      idClient
      idMercadoCategory
      unrestrictedProducts
      restrictedProducts
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListMercadoProductCategoryClientsQueryVariables,
  APITypes.ListMercadoProductCategoryClientsQuery
>;
export const getExternalApis = /* GraphQL */ `query GetExternalApis($id: ID!) {
  getExternalApis(id: $id) {
    id
    status
    name
    nameExternal
    region
    increment
    discount
    visibleFor
    clientDiscounts {
      index
      clientId
      minUnits
      maxUnits
      percent
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetExternalApisQueryVariables,
  APITypes.GetExternalApisQuery
>;
export const listExternalApis = /* GraphQL */ `query ListExternalApis(
  $filter: ModelExternalApisFilterInput
  $limit: Int
  $nextToken: String
) {
  listExternalApis(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      name
      nameExternal
      region
      increment
      discount
      visibleFor
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListExternalApisQueryVariables,
  APITypes.ListExternalApisQuery
>;
export const getPrintPrices = /* GraphQL */ `query GetPrintPrices($id: ID!) {
  getPrintPrices(id: $id) {
    id
    identifier
    status
    creator
    description
    price
    minUnits
    maxUnits
    ranges {
      price
      minUnits
      maxUnits
      __typename
    }
    clientPrintPrices {
      clientId
      price
      minUnits
      maxUnits
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPrintPricesQueryVariables,
  APITypes.GetPrintPricesQuery
>;
export const listPrintPrices = /* GraphQL */ `query ListPrintPrices(
  $filter: ModelPrintPricesFilterInput
  $limit: Int
  $nextToken: String
) {
  listPrintPrices(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      identifier
      status
      creator
      description
      price
      minUnits
      maxUnits
      ranges {
        price
        minUnits
        maxUnits
        __typename
      }
      clientPrintPrices {
        clientId
        price
        minUnits
        maxUnits
        __typename
      }
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPrintPricesQueryVariables,
  APITypes.ListPrintPricesQuery
>;
export const getPrintLogos = /* GraphQL */ `query GetPrintLogos($id: ID!) {
  getPrintLogos(id: $id) {
    id
    status
    creator
    description
    identifier
    clientId
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPrintLogosQueryVariables,
  APITypes.GetPrintLogosQuery
>;
export const listPrintLogos = /* GraphQL */ `query ListPrintLogos(
  $filter: ModelPrintLogosFilterInput
  $limit: Int
  $nextToken: String
) {
  listPrintLogos(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      creator
      description
      identifier
      clientId
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPrintLogosQueryVariables,
  APITypes.ListPrintLogosQuery
>;
export const getLogisticPostalCode = /* GraphQL */ `query GetLogisticPostalCode($id: ID!) {
  getLogisticPostalCode(id: $id) {
    id
    cpFrom
    cpTo
    zone
    state
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLogisticPostalCodeQueryVariables,
  APITypes.GetLogisticPostalCodeQuery
>;
export const listLogisticPostalCodes = /* GraphQL */ `query ListLogisticPostalCodes(
  $filter: ModelLogisticPostalCodeFilterInput
  $limit: Int
  $nextToken: String
) {
  listLogisticPostalCodes(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      cpFrom
      cpTo
      zone
      state
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLogisticPostalCodesQueryVariables,
  APITypes.ListLogisticPostalCodesQuery
>;
export const getLogisticPieceRange = /* GraphQL */ `query GetLogisticPieceRange($id: ID!) {
  getLogisticPieceRange(id: $id) {
    id
    piecesRange
    min
    max
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLogisticPieceRangeQueryVariables,
  APITypes.GetLogisticPieceRangeQuery
>;
export const listLogisticPieceRanges = /* GraphQL */ `query ListLogisticPieceRanges(
  $filter: ModelLogisticPieceRangeFilterInput
  $limit: Int
  $nextToken: String
) {
  listLogisticPieceRanges(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      piecesRange
      min
      max
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLogisticPieceRangesQueryVariables,
  APITypes.ListLogisticPieceRangesQuery
>;
export const getLogisticWeightRange = /* GraphQL */ `query GetLogisticWeightRange($id: ID!) {
  getLogisticWeightRange(id: $id) {
    id
    weightRange
    min
    max
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLogisticWeightRangeQueryVariables,
  APITypes.GetLogisticWeightRangeQuery
>;
export const listLogisticWeightRanges = /* GraphQL */ `query ListLogisticWeightRanges(
  $filter: ModelLogisticWeightRangeFilterInput
  $limit: Int
  $nextToken: String
) {
  listLogisticWeightRanges(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      weightRange
      min
      max
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLogisticWeightRangesQueryVariables,
  APITypes.ListLogisticWeightRangesQuery
>;
export const getLogisticWeightBox = /* GraphQL */ `query GetLogisticWeightBox($id: ID!) {
  getLogisticWeightBox(id: $id) {
    id
    boxId
    shippingPrices {
      weightRangeId
      price
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLogisticWeightBoxQueryVariables,
  APITypes.GetLogisticWeightBoxQuery
>;
export const listLogisticWeightBoxes = /* GraphQL */ `query ListLogisticWeightBoxes(
  $filter: ModelLogisticWeightBoxFilterInput
  $limit: Int
  $nextToken: String
) {
  listLogisticWeightBoxes(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      boxId
      shippingPrices {
        weightRangeId
        price
        __typename
      }
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLogisticWeightBoxesQueryVariables,
  APITypes.ListLogisticWeightBoxesQuery
>;
export const getLogisticZone = /* GraphQL */ `query GetLogisticZone($id: ID!) {
  getLogisticZone(id: $id) {
    id
    zoneName
    shippingPrices {
      piecesRangeId
      price
      __typename
    }
    clientsRanges {
      id
      clientId
      piecesRange
      price
      __typename
    }
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLogisticZoneQueryVariables,
  APITypes.GetLogisticZoneQuery
>;
export const listLogisticZones = /* GraphQL */ `query ListLogisticZones(
  $filter: ModelLogisticZoneFilterInput
  $limit: Int
  $nextToken: String
) {
  listLogisticZones(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      zoneName
      shippingPrices {
        piecesRangeId
        price
        __typename
      }
      clientsRanges {
        id
        clientId
        piecesRange
        price
        __typename
      }
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLogisticZonesQueryVariables,
  APITypes.ListLogisticZonesQuery
>;
export const getLogisticBox = /* GraphQL */ `query GetLogisticBox($id: ID!) {
  getLogisticBox(id: $id) {
    id
    status
    name
    description
    price
    width
    height
    depth
    volumetricWeight
    maxWeight
    maxPayload
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLogisticBoxQueryVariables,
  APITypes.GetLogisticBoxQuery
>;
export const listLogisticBoxes = /* GraphQL */ `query ListLogisticBoxes(
  $filter: ModelLogisticBoxFilterInput
  $limit: Int
  $nextToken: String
) {
  listLogisticBoxes(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      name
      description
      price
      width
      height
      depth
      volumetricWeight
      maxWeight
      maxPayload
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLogisticBoxesQueryVariables,
  APITypes.ListLogisticBoxesQuery
>;
export const getLogisticVehicles = /* GraphQL */ `query GetLogisticVehicles($id: ID!) {
  getLogisticVehicles(id: $id) {
    id
    status
    licensePlate
    hasInsurancePolicy
    fuelCapacity
    width
    height
    depth
    maxWeight
    created
    updated
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetLogisticVehiclesQueryVariables,
  APITypes.GetLogisticVehiclesQuery
>;
export const listLogisticVehicles = /* GraphQL */ `query ListLogisticVehicles(
  $filter: ModelLogisticVehiclesFilterInput
  $limit: Int
  $nextToken: String
) {
  listLogisticVehicles(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      licensePlate
      hasInsurancePolicy
      fuelCapacity
      width
      height
      depth
      maxWeight
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLogisticVehiclesQueryVariables,
  APITypes.ListLogisticVehiclesQuery
>;
export const getPakmailCarrier = /* GraphQL */ `query GetPakmailCarrier($id: ID!) {
  getPakmailCarrier(id: $id) {
    id
    status
    identifier
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    visibleFor
    region
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPakmailCarrierQueryVariables,
  APITypes.GetPakmailCarrierQuery
>;
export const listPakmailCarriers = /* GraphQL */ `query ListPakmailCarriers(
  $filter: ModelPakmailCarrierFilterInput
  $limit: Int
  $nextToken: String
) {
  listPakmailCarriers(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      identifier
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      visibleFor
      region
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPakmailCarriersQueryVariables,
  APITypes.ListPakmailCarriersQuery
>;
export const getPakmailService = /* GraphQL */ `query GetPakmailService($id: ID!) {
  getPakmailService(id: $id) {
    id
    status
    identifier
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    clientFeeIncrements {
      index
      clientId
      percent
      __typename
    }
    clientIncrements {
      index
      clientId
      percent
      __typename
    }
    visibleFor
    region
    isNational
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPakmailServiceQueryVariables,
  APITypes.GetPakmailServiceQuery
>;
export const listPakmailServices = /* GraphQL */ `query ListPakmailServices(
  $filter: ModelPakmailServiceFilterInput
  $limit: Int
  $nextToken: String
) {
  listPakmailServices(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      status
      identifier
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      visibleFor
      region
      isNational
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPakmailServicesQueryVariables,
  APITypes.ListPakmailServicesQuery
>;
export const getPakmailShipmentStatus = /* GraphQL */ `query GetPakmailShipmentStatus($id: ID!) {
  getPakmailShipmentStatus(id: $id) {
    id
    status
    identifier
    image {
      key
      url
      color
      palette
      colorName
      __typename
    }
    visibleFor
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPakmailShipmentStatusQueryVariables,
  APITypes.GetPakmailShipmentStatusQuery
>;
export const listPakmailShipmentStatuses = /* GraphQL */ `query ListPakmailShipmentStatuses(
  $filter: ModelPakmailShipmentStatusFilterInput
  $limit: Int
  $nextToken: String
) {
  listPakmailShipmentStatuses(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      identifier
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      notifications {
        group
        enabledEmail
        enabledPopUp
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPakmailShipmentStatusesQueryVariables,
  APITypes.ListPakmailShipmentStatusesQuery
>;
export const getPakmailShipmentEvent = /* GraphQL */ `query GetPakmailShipmentEvent($id: ID!) {
  getPakmailShipmentEvent(id: $id) {
    id
    status
    identifier
    visibleFor
    color
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPakmailShipmentEventQueryVariables,
  APITypes.GetPakmailShipmentEventQuery
>;
export const listPakmailShipmentEvents = /* GraphQL */ `query ListPakmailShipmentEvents(
  $filter: ModelPakmailShipmentEventFilterInput
  $limit: Int
  $nextToken: String
) {
  listPakmailShipmentEvents(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      identifier
      visibleFor
      color
      notifications {
        group
        enabledEmail
        enabledPopUp
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPakmailShipmentEventsQueryVariables,
  APITypes.ListPakmailShipmentEventsQuery
>;
export const getPakmailPickupStatus = /* GraphQL */ `query GetPakmailPickupStatus($id: ID!) {
  getPakmailPickupStatus(id: $id) {
    id
    status
    identifier
    visibleFor
    notifications {
      group
      enabledEmail
      enabledPopUp
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPakmailPickupStatusQueryVariables,
  APITypes.GetPakmailPickupStatusQuery
>;
export const listPakmailPickupStatuses = /* GraphQL */ `query ListPakmailPickupStatuses(
  $filter: ModelPakmailPickupStatusFilterInput
  $limit: Int
  $nextToken: String
) {
  listPakmailPickupStatuses(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      identifier
      visibleFor
      notifications {
        group
        enabledEmail
        enabledPopUp
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPakmailPickupStatusesQueryVariables,
  APITypes.ListPakmailPickupStatusesQuery
>;
export const getPremiumOrderLogisticGuide = /* GraphQL */ `query GetPremiumOrderLogisticGuide($id: ID!) {
  getPremiumOrderLogisticGuide(id: $id) {
    id
    type
    pakmailId
    premiumOrderId
    clientId
    creatorId
    originAddressId
    destinationAddressId
    originAddress
    destinationAddress
    products {
      indexProduct
      productId
      quantity
      unitWidth
      unitHeight
      unitDepth
      unitWeight
      __typename
    }
    price
    increment
    fee
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPremiumOrderLogisticGuideQueryVariables,
  APITypes.GetPremiumOrderLogisticGuideQuery
>;
export const listPremiumOrderLogisticGuides = /* GraphQL */ `query ListPremiumOrderLogisticGuides(
  $filter: ModelPremiumOrderLogisticGuideFilterInput
  $limit: Int
  $nextToken: String
) {
  listPremiumOrderLogisticGuides(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      pakmailId
      premiumOrderId
      clientId
      creatorId
      originAddressId
      destinationAddressId
      originAddress
      destinationAddress
      products {
        indexProduct
        productId
        quantity
        unitWidth
        unitHeight
        unitDepth
        unitWeight
        __typename
      }
      price
      increment
      fee
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPremiumOrderLogisticGuidesQueryVariables,
  APITypes.ListPremiumOrderLogisticGuidesQuery
>;
export const getProductLabelItem = /* GraphQL */ `query GetProductLabelItem($id: ID!) {
  getProductLabelItem(id: $id) {
    id
    productId
    productLabelId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProductLabelItemQueryVariables,
  APITypes.GetProductLabelItemQuery
>;
export const listProductLabelItems = /* GraphQL */ `query ListProductLabelItems(
  $filter: ModelProductLabelItemFilterInput
  $limit: Int
  $nextToken: String
) {
  listProductLabelItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      productId
      productLabelId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProductLabelItemsQueryVariables,
  APITypes.ListProductLabelItemsQuery
>;
export const getProductLabel = /* GraphQL */ `query GetProductLabel($id: ID!) {
  getProductLabel(id: $id) {
    id
    name
    translation
    status
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProductLabelQueryVariables,
  APITypes.GetProductLabelQuery
>;
export const listProductLabels = /* GraphQL */ `query ListProductLabels(
  $filter: ModelProductLabelFilterInput
  $limit: Int
  $nextToken: String
) {
  listProductLabels(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      translation
      status
      visibleFor
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProductLabelsQueryVariables,
  APITypes.ListProductLabelsQuery
>;
export const getProductTextItem = /* GraphQL */ `query GetProductTextItem($id: ID!) {
  getProductTextItem(id: $id) {
    id
    productId
    productTextId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProductTextItemQueryVariables,
  APITypes.GetProductTextItemQuery
>;
export const listProductTextItems = /* GraphQL */ `query ListProductTextItems(
  $filter: ModelProductTextItemFilterInput
  $limit: Int
  $nextToken: String
) {
  listProductTextItems(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      productId
      productTextId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProductTextItemsQueryVariables,
  APITypes.ListProductTextItemsQuery
>;
export const getProductText = /* GraphQL */ `query GetProductText($id: ID!) {
  getProductText(id: $id) {
    id
    name
    status
    visibleFor
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProductTextQueryVariables,
  APITypes.GetProductTextQuery
>;
export const listProductTexts = /* GraphQL */ `query ListProductTexts(
  $filter: ModelProductTextFilterInput
  $limit: Int
  $nextToken: String
) {
  listProductTexts(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      status
      visibleFor
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProductTextsQueryVariables,
  APITypes.ListProductTextsQuery
>;
export const getProductMask = /* GraphQL */ `query GetProductMask($id: ID!) {
  getProductMask(id: $id) {
    id
    name
    sku
    productId
    clientId
    filterColors
    mainImage {
      key
      url
      color
      palette
      colorName
      __typename
    }
    increment
    fee
    discount
    stock
    categoryId
    sellMode
    kitPieces
    kitIncrement
    kitFee
    stockMode
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProductMaskQueryVariables,
  APITypes.GetProductMaskQuery
>;
export const listProductMasks = /* GraphQL */ `query ListProductMasks(
  $filter: ModelProductMaskFilterInput
  $limit: Int
  $nextToken: String
) {
  listProductMasks(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      sku
      productId
      clientId
      filterColors
      mainImage {
        key
        url
        color
        palette
        colorName
        __typename
      }
      increment
      fee
      discount
      stock
      categoryId
      sellMode
      kitPieces
      kitIncrement
      kitFee
      stockMode
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProductMasksQueryVariables,
  APITypes.ListProductMasksQuery
>;
export const getVariantMask = /* GraphQL */ `query GetVariantMask($id: ID!) {
  getVariantMask(id: $id) {
    id
    filterColors
    images {
      key
      url
      color
      palette
      colorName
      __typename
    }
    stock
    stockMode
    productMaskId
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetVariantMaskQueryVariables,
  APITypes.GetVariantMaskQuery
>;
export const listVariantMasks = /* GraphQL */ `query ListVariantMasks(
  $filter: ModelVariantMaskFilterInput
  $limit: Int
  $nextToken: String
) {
  listVariantMasks(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      filterColors
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      stock
      stockMode
      productMaskId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListVariantMasksQueryVariables,
  APITypes.ListVariantMasksQuery
>;
export const getProductMaskDescription = /* GraphQL */ `query GetProductMaskDescription($id: ID!) {
  getProductMaskDescription(id: $id) {
    id
    long_description
    short_description
    productDescriptionItem {
      index
      status
      key
      description
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetProductMaskDescriptionQueryVariables,
  APITypes.GetProductMaskDescriptionQuery
>;
export const listProductMaskDescriptions = /* GraphQL */ `query ListProductMaskDescriptions(
  $filter: ModelProductMaskDescriptionFilterInput
  $limit: Int
  $nextToken: String
) {
  listProductMaskDescriptions(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      long_description
      short_description
      productDescriptionItem {
        index
        status
        key
        description
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProductMaskDescriptionsQueryVariables,
  APITypes.ListProductMaskDescriptionsQuery
>;
export const getCoupon = /* GraphQL */ `query GetCoupon($id: ID!) {
  getCoupon(id: $id) {
    id
    code
    name
    description
    discountAmount
    discountPercentage
    minAmount
    maxAmount
    startDate
    endDate
    maxRedemptions
    maxRedemptionsPerUser
    applicableProducts
    applicableCategories
    excludedProducts
    status
    createdBy
    redemptions {
      items {
        id
        couponId
        couponCode
        userId
        clientId
        orderId
        cartId
        discountApplied
        originalAmount
        finalAmount
        appliedAt
        ipAddress
        userAgent
        coupon {
          id
          code
          name
          description
          discountAmount
          discountPercentage
          minAmount
          maxAmount
          startDate
          endDate
          maxRedemptions
          maxRedemptionsPerUser
          applicableProducts
          applicableCategories
          excludedProducts
          status
          createdBy
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<APITypes.GetCouponQueryVariables, APITypes.GetCouponQuery>;
export const listCoupons = /* GraphQL */ `query ListCoupons(
  $filter: ModelCouponFilterInput
  $limit: Int
  $nextToken: String
) {
  listCoupons(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      code
      name
      description
      discountAmount
      discountPercentage
      minAmount
      maxAmount
      startDate
      endDate
      maxRedemptions
      maxRedemptionsPerUser
      applicableProducts
      applicableCategories
      excludedProducts
      status
      createdBy
      redemptions {
        items {
          id
          couponId
          couponCode
          userId
          clientId
          orderId
          cartId
          discountApplied
          originalAmount
          finalAmount
          appliedAt
          ipAddress
          userAgent
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCouponsQueryVariables,
  APITypes.ListCouponsQuery
>;
export const getCouponRedemption = /* GraphQL */ `query GetCouponRedemption($id: ID!) {
  getCouponRedemption(id: $id) {
    id
    couponId
    couponCode
    userId
    clientId
    orderId
    cartId
    discountApplied
    originalAmount
    finalAmount
    appliedAt
    ipAddress
    userAgent
    coupon {
      id
      code
      name
      description
      discountAmount
      discountPercentage
      minAmount
      maxAmount
      startDate
      endDate
      maxRedemptions
      maxRedemptionsPerUser
      applicableProducts
      applicableCategories
      excludedProducts
      status
      createdBy
      redemptions {
        items {
          id
          couponId
          couponCode
          userId
          clientId
          orderId
          cartId
          discountApplied
          originalAmount
          finalAmount
          appliedAt
          ipAddress
          userAgent
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetCouponRedemptionQueryVariables,
  APITypes.GetCouponRedemptionQuery
>;
export const listCouponRedemptions = /* GraphQL */ `query ListCouponRedemptions(
  $filter: ModelCouponRedemptionFilterInput
  $limit: Int
  $nextToken: String
) {
  listCouponRedemptions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      couponId
      couponCode
      userId
      clientId
      orderId
      cartId
      discountApplied
      originalAmount
      finalAmount
      appliedAt
      ipAddress
      userAgent
      coupon {
        id
        code
        name
        description
        discountAmount
        discountPercentage
        minAmount
        maxAmount
        startDate
        endDate
        maxRedemptions
        maxRedemptionsPerUser
        applicableProducts
        applicableCategories
        excludedProducts
        status
        createdBy
        redemptions {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCouponRedemptionsQueryVariables,
  APITypes.ListCouponRedemptionsQuery
>;
export const getPromotion = /* GraphQL */ `query GetPromotion($id: ID!) {
  getPromotion(id: $id) {
    id
    name
    description
    triggerProductIds
    minQuantity
    minAmount
    triggerRule
    giftProductId
    giftQuantity
    isStackable
    applicableClientIds
    startDate
    endDate
    maxRedemptions
    maxRedemptionsPerUser
    status
    createdBy
    redemptions {
      items {
        id
        promotionId
        userId
        clientId
        orderId
        cartId
        triggerQuantity
        giftQuantityApplied
        appliedAt
        ipAddress
        userAgent
        promotion {
          id
          name
          description
          triggerProductIds
          minQuantity
          minAmount
          triggerRule
          giftProductId
          giftQuantity
          isStackable
          applicableClientIds
          startDate
          endDate
          maxRedemptions
          maxRedemptionsPerUser
          status
          createdBy
          createdAt
          updatedAt
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPromotionQueryVariables,
  APITypes.GetPromotionQuery
>;
export const listPromotions = /* GraphQL */ `query ListPromotions(
  $filter: ModelPromotionFilterInput
  $limit: Int
  $nextToken: String
) {
  listPromotions(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      name
      description
      triggerProductIds
      minQuantity
      minAmount
      triggerRule
      giftProductId
      giftQuantity
      isStackable
      applicableClientIds
      startDate
      endDate
      maxRedemptions
      maxRedemptionsPerUser
      status
      createdBy
      redemptions {
        items {
          id
          promotionId
          userId
          clientId
          orderId
          cartId
          triggerQuantity
          giftQuantityApplied
          appliedAt
          ipAddress
          userAgent
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPromotionsQueryVariables,
  APITypes.ListPromotionsQuery
>;
export const getPromotionRedemption = /* GraphQL */ `query GetPromotionRedemption($id: ID!) {
  getPromotionRedemption(id: $id) {
    id
    promotionId
    userId
    clientId
    orderId
    cartId
    triggerQuantity
    giftQuantityApplied
    appliedAt
    ipAddress
    userAgent
    promotion {
      id
      name
      description
      triggerProductIds
      minQuantity
      minAmount
      triggerRule
      giftProductId
      giftQuantity
      isStackable
      applicableClientIds
      startDate
      endDate
      maxRedemptions
      maxRedemptionsPerUser
      status
      createdBy
      redemptions {
        items {
          id
          promotionId
          userId
          clientId
          orderId
          cartId
          triggerQuantity
          giftQuantityApplied
          appliedAt
          ipAddress
          userAgent
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetPromotionRedemptionQueryVariables,
  APITypes.GetPromotionRedemptionQuery
>;
export const listPromotionRedemptions = /* GraphQL */ `query ListPromotionRedemptions(
  $filter: ModelPromotionRedemptionFilterInput
  $limit: Int
  $nextToken: String
) {
  listPromotionRedemptions(
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      promotionId
      userId
      clientId
      orderId
      cartId
      triggerQuantity
      giftQuantityApplied
      appliedAt
      ipAddress
      userAgent
      promotion {
        id
        name
        description
        triggerProductIds
        minQuantity
        minAmount
        triggerRule
        giftProductId
        giftQuantity
        isStackable
        applicableClientIds
        startDate
        endDate
        maxRedemptions
        maxRedemptionsPerUser
        status
        createdBy
        redemptions {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPromotionRedemptionsQueryVariables,
  APITypes.ListPromotionRedemptionsQuery
>;
export const getWalletBalance = /* GraphQL */ `query GetWalletBalance($id: ID!) {
  getWalletBalance(id: $id) {
    id
    balance
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetWalletBalanceQueryVariables,
  APITypes.GetWalletBalanceQuery
>;
export const listWalletBalances = /* GraphQL */ `query ListWalletBalances(
  $filter: ModelWalletBalanceFilterInput
  $limit: Int
  $nextToken: String
) {
  listWalletBalances(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      balance
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListWalletBalancesQueryVariables,
  APITypes.ListWalletBalancesQuery
>;
export const getWalletMovement = /* GraphQL */ `query GetWalletMovement($id: ID!) {
  getWalletMovement(id: $id) {
    id
    userId
    type
    amount
    orderId
    createdByUserId
    couponId
    couponCode
    availableUntil
    isValidated
    validatedAt
    validatedBy
    createdAt
    updatedAt
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetWalletMovementQueryVariables,
  APITypes.GetWalletMovementQuery
>;
export const listWalletMovements = /* GraphQL */ `query ListWalletMovements(
  $filter: ModelWalletMovementFilterInput
  $limit: Int
  $nextToken: String
) {
  listWalletMovements(filter: $filter, limit: $limit, nextToken: $nextToken) {
    items {
      id
      userId
      type
      amount
      orderId
      createdByUserId
      couponId
      couponCode
      availableUntil
      isValidated
      validatedAt
      validatedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListWalletMovementsQueryVariables,
  APITypes.ListWalletMovementsQuery
>;
export const ListClientSettingsByDomain = /* GraphQL */ `query ListClientSettingsByDomain(
  $domain: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelClientSettingFilterInput
  $limit: Int
  $nextToken: String
) {
  ListClientSettingsByDomain(
    domain: $domain
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      crmJiraId
      orderBudget
      domain
      filterColors
      primaryColors
      accentColors
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListClientSettingsByDomainQueryVariables,
  APITypes.ListClientSettingsByDomainQuery
>;
export const ListColorsPosition = /* GraphQL */ `query ListColorsPosition(
  $status: String!
  $position: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelColorsFilterInput
  $limit: Int
  $nextToken: String
) {
  ListColorsPosition(
    status: $status
    position: $position
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      name
      rgb
      hex
      position
      variantNames
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListColorsPositionQueryVariables,
  APITypes.ListColorsPositionQuery
>;
export const productsByProviderStatus = /* GraphQL */ `query ProductsByProviderStatus(
  $providerId: ID!
  $status: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductoFilterInput
  $limit: Int
  $nextToken: String
) {
  productsByProviderStatus(
    providerId: $providerId
    status: $status
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      providerId
      categoryId
      name
      status
      bestSeller
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      order
      sku
      brand
      colors
      pgClasitication
      delivery_time
      delivery_time_units
      stock
      minRequest
      maxRequest
      article_of_clothing
      size
      price
      long_description
      short_description
      creator
      provider {
        id
        isApproved
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comertial_name
        bussiness_name {
          rfc
          name
          __typename
        }
        idProcter
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        biography
        constancia {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comprobante {
          key
          url
          color
          palette
          colorName
          __typename
        }
        experience
        pros
        cons
        cte_rating {
          name
          rating
          __typename
        }
        shopping_rating {
          name
          rating
          __typename
        }
        video
        tags
        money_filter_c
        money_filter_d
        users
        bank
        account
        clabe
        cuenta_correo
        edocuenta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        ife {
          key
          url
          color
          palette
          colorName
          __typename
        }
        poderes {
          key
          url
          color
          palette
          colorName
          __typename
        }
        acta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        isProvider
        sameAddress
        isPop
        isPrinted
        hasLogistic
        created
        updated
        addFiles {
          key
          url
          sign
          status
          __typename
        }
        signFiles {
          key
          url
          sign
          status
          __typename
        }
        representante_legal
        escritura_constitucion
        notario_a
        constituido_down_edo
        rrpp
        isPremium
        isTrustProvider
        createdAt
        updatedAt
        __typename
      }
      category {
        id
        name
        description
        unspsc
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        imageMobile {
          key
          url
          color
          palette
          colorName
          __typename
        }
        visibleFor
        visibleForUserBrand
        region
        tags
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        hasAllowables
        hasPreapproveds
        hasRestricted
        isPublic
        isTop
        createdAt
        slug
        parentId
        rootId
        path
        status
        pathIds
        source
        trazoCategoryId
        nameExternal
        depth
        childrenCount
        isLeaf
        oldVersion
        productLine
        updatedAt
        __typename
      }
      isExternal
      isAllowable
      isRestricted
      isAutoSkipped
      isAutoAllowed
      isPurse
      massiveLayout
      hasBaseAmmount
      isFreeAmmount
      isCard
      isByRequest
      isMultiPrice
      cardBaseAmmount
      minCardBaseAmmount
      maxCardBaseAmmount
      nameExternal
      unspsc
      variants {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      visibleFor
      filterColors
      regions
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      productDescriptionItem {
        index
        status
        key
        description
        __typename
      }
      source
      trazoProductId
      trazoCategoryId
      stockUpdatedAt
      priceUpdatedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductsByProviderStatusQueryVariables,
  APITypes.ProductsByProviderStatusQuery
>;
export const productsByProviderCategory = /* GraphQL */ `query ProductsByProviderCategory(
  $providerId: ID!
  $categoryId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductoFilterInput
  $limit: Int
  $nextToken: String
) {
  productsByProviderCategory(
    providerId: $providerId
    categoryId: $categoryId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      providerId
      categoryId
      name
      status
      bestSeller
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      order
      sku
      brand
      colors
      pgClasitication
      delivery_time
      delivery_time_units
      stock
      minRequest
      maxRequest
      article_of_clothing
      size
      price
      long_description
      short_description
      creator
      provider {
        id
        isApproved
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comertial_name
        bussiness_name {
          rfc
          name
          __typename
        }
        idProcter
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        biography
        constancia {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comprobante {
          key
          url
          color
          palette
          colorName
          __typename
        }
        experience
        pros
        cons
        cte_rating {
          name
          rating
          __typename
        }
        shopping_rating {
          name
          rating
          __typename
        }
        video
        tags
        money_filter_c
        money_filter_d
        users
        bank
        account
        clabe
        cuenta_correo
        edocuenta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        ife {
          key
          url
          color
          palette
          colorName
          __typename
        }
        poderes {
          key
          url
          color
          palette
          colorName
          __typename
        }
        acta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        isProvider
        sameAddress
        isPop
        isPrinted
        hasLogistic
        created
        updated
        addFiles {
          key
          url
          sign
          status
          __typename
        }
        signFiles {
          key
          url
          sign
          status
          __typename
        }
        representante_legal
        escritura_constitucion
        notario_a
        constituido_down_edo
        rrpp
        isPremium
        isTrustProvider
        createdAt
        updatedAt
        __typename
      }
      category {
        id
        name
        description
        unspsc
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        imageMobile {
          key
          url
          color
          palette
          colorName
          __typename
        }
        visibleFor
        visibleForUserBrand
        region
        tags
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        hasAllowables
        hasPreapproveds
        hasRestricted
        isPublic
        isTop
        createdAt
        slug
        parentId
        rootId
        path
        status
        pathIds
        source
        trazoCategoryId
        nameExternal
        depth
        childrenCount
        isLeaf
        oldVersion
        productLine
        updatedAt
        __typename
      }
      isExternal
      isAllowable
      isRestricted
      isAutoSkipped
      isAutoAllowed
      isPurse
      massiveLayout
      hasBaseAmmount
      isFreeAmmount
      isCard
      isByRequest
      isMultiPrice
      cardBaseAmmount
      minCardBaseAmmount
      maxCardBaseAmmount
      nameExternal
      unspsc
      variants {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      visibleFor
      filterColors
      regions
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      productDescriptionItem {
        index
        status
        key
        description
        __typename
      }
      source
      trazoProductId
      trazoCategoryId
      stockUpdatedAt
      priceUpdatedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductsByProviderCategoryQueryVariables,
  APITypes.ProductsByProviderCategoryQuery
>;
export const ProductsByCategoryProviderPrice = /* GraphQL */ `query ProductsByCategoryProviderPrice(
  $categoryId: ID!
  $providerIdPrice: ModelProductoByCategoryProviderPriceCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductoFilterInput
  $limit: Int
  $nextToken: String
) {
  ProductsByCategoryProviderPrice(
    categoryId: $categoryId
    providerIdPrice: $providerIdPrice
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      providerId
      categoryId
      name
      status
      bestSeller
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      order
      sku
      brand
      colors
      pgClasitication
      delivery_time
      delivery_time_units
      stock
      minRequest
      maxRequest
      article_of_clothing
      size
      price
      long_description
      short_description
      creator
      provider {
        id
        isApproved
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comertial_name
        bussiness_name {
          rfc
          name
          __typename
        }
        idProcter
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        biography
        constancia {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comprobante {
          key
          url
          color
          palette
          colorName
          __typename
        }
        experience
        pros
        cons
        cte_rating {
          name
          rating
          __typename
        }
        shopping_rating {
          name
          rating
          __typename
        }
        video
        tags
        money_filter_c
        money_filter_d
        users
        bank
        account
        clabe
        cuenta_correo
        edocuenta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        ife {
          key
          url
          color
          palette
          colorName
          __typename
        }
        poderes {
          key
          url
          color
          palette
          colorName
          __typename
        }
        acta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        isProvider
        sameAddress
        isPop
        isPrinted
        hasLogistic
        created
        updated
        addFiles {
          key
          url
          sign
          status
          __typename
        }
        signFiles {
          key
          url
          sign
          status
          __typename
        }
        representante_legal
        escritura_constitucion
        notario_a
        constituido_down_edo
        rrpp
        isPremium
        isTrustProvider
        createdAt
        updatedAt
        __typename
      }
      category {
        id
        name
        description
        unspsc
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        imageMobile {
          key
          url
          color
          palette
          colorName
          __typename
        }
        visibleFor
        visibleForUserBrand
        region
        tags
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        hasAllowables
        hasPreapproveds
        hasRestricted
        isPublic
        isTop
        createdAt
        slug
        parentId
        rootId
        path
        status
        pathIds
        source
        trazoCategoryId
        nameExternal
        depth
        childrenCount
        isLeaf
        oldVersion
        productLine
        updatedAt
        __typename
      }
      isExternal
      isAllowable
      isRestricted
      isAutoSkipped
      isAutoAllowed
      isPurse
      massiveLayout
      hasBaseAmmount
      isFreeAmmount
      isCard
      isByRequest
      isMultiPrice
      cardBaseAmmount
      minCardBaseAmmount
      maxCardBaseAmmount
      nameExternal
      unspsc
      variants {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      visibleFor
      filterColors
      regions
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      productDescriptionItem {
        index
        status
        key
        description
        __typename
      }
      source
      trazoProductId
      trazoCategoryId
      stockUpdatedAt
      priceUpdatedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductsByCategoryProviderPriceQueryVariables,
  APITypes.ProductsByCategoryProviderPriceQuery
>;
export const productsByCategoryPrice = /* GraphQL */ `query ProductsByCategoryPrice(
  $categoryId: ID!
  $price: ModelFloatKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductoFilterInput
  $limit: Int
  $nextToken: String
) {
  productsByCategoryPrice(
    categoryId: $categoryId
    price: $price
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      providerId
      categoryId
      name
      status
      bestSeller
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      order
      sku
      brand
      colors
      pgClasitication
      delivery_time
      delivery_time_units
      stock
      minRequest
      maxRequest
      article_of_clothing
      size
      price
      long_description
      short_description
      creator
      provider {
        id
        isApproved
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comertial_name
        bussiness_name {
          rfc
          name
          __typename
        }
        idProcter
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        biography
        constancia {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comprobante {
          key
          url
          color
          palette
          colorName
          __typename
        }
        experience
        pros
        cons
        cte_rating {
          name
          rating
          __typename
        }
        shopping_rating {
          name
          rating
          __typename
        }
        video
        tags
        money_filter_c
        money_filter_d
        users
        bank
        account
        clabe
        cuenta_correo
        edocuenta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        ife {
          key
          url
          color
          palette
          colorName
          __typename
        }
        poderes {
          key
          url
          color
          palette
          colorName
          __typename
        }
        acta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        isProvider
        sameAddress
        isPop
        isPrinted
        hasLogistic
        created
        updated
        addFiles {
          key
          url
          sign
          status
          __typename
        }
        signFiles {
          key
          url
          sign
          status
          __typename
        }
        representante_legal
        escritura_constitucion
        notario_a
        constituido_down_edo
        rrpp
        isPremium
        isTrustProvider
        createdAt
        updatedAt
        __typename
      }
      category {
        id
        name
        description
        unspsc
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        imageMobile {
          key
          url
          color
          palette
          colorName
          __typename
        }
        visibleFor
        visibleForUserBrand
        region
        tags
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        hasAllowables
        hasPreapproveds
        hasRestricted
        isPublic
        isTop
        createdAt
        slug
        parentId
        rootId
        path
        status
        pathIds
        source
        trazoCategoryId
        nameExternal
        depth
        childrenCount
        isLeaf
        oldVersion
        productLine
        updatedAt
        __typename
      }
      isExternal
      isAllowable
      isRestricted
      isAutoSkipped
      isAutoAllowed
      isPurse
      massiveLayout
      hasBaseAmmount
      isFreeAmmount
      isCard
      isByRequest
      isMultiPrice
      cardBaseAmmount
      minCardBaseAmmount
      maxCardBaseAmmount
      nameExternal
      unspsc
      variants {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      visibleFor
      filterColors
      regions
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      productDescriptionItem {
        index
        status
        key
        description
        __typename
      }
      source
      trazoProductId
      trazoCategoryId
      stockUpdatedAt
      priceUpdatedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductsByCategoryPriceQueryVariables,
  APITypes.ProductsByCategoryPriceQuery
>;
export const productsByCategory = /* GraphQL */ `query ProductsByCategory(
  $categoryId: ID!
  $order: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductoFilterInput
  $limit: Int
  $nextToken: String
) {
  productsByCategory(
    categoryId: $categoryId
    order: $order
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      providerId
      categoryId
      name
      status
      bestSeller
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      order
      sku
      brand
      colors
      pgClasitication
      delivery_time
      delivery_time_units
      stock
      minRequest
      maxRequest
      article_of_clothing
      size
      price
      long_description
      short_description
      creator
      provider {
        id
        isApproved
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comertial_name
        bussiness_name {
          rfc
          name
          __typename
        }
        idProcter
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        biography
        constancia {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comprobante {
          key
          url
          color
          palette
          colorName
          __typename
        }
        experience
        pros
        cons
        cte_rating {
          name
          rating
          __typename
        }
        shopping_rating {
          name
          rating
          __typename
        }
        video
        tags
        money_filter_c
        money_filter_d
        users
        bank
        account
        clabe
        cuenta_correo
        edocuenta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        ife {
          key
          url
          color
          palette
          colorName
          __typename
        }
        poderes {
          key
          url
          color
          palette
          colorName
          __typename
        }
        acta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        isProvider
        sameAddress
        isPop
        isPrinted
        hasLogistic
        created
        updated
        addFiles {
          key
          url
          sign
          status
          __typename
        }
        signFiles {
          key
          url
          sign
          status
          __typename
        }
        representante_legal
        escritura_constitucion
        notario_a
        constituido_down_edo
        rrpp
        isPremium
        isTrustProvider
        createdAt
        updatedAt
        __typename
      }
      category {
        id
        name
        description
        unspsc
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        imageMobile {
          key
          url
          color
          palette
          colorName
          __typename
        }
        visibleFor
        visibleForUserBrand
        region
        tags
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        hasAllowables
        hasPreapproveds
        hasRestricted
        isPublic
        isTop
        createdAt
        slug
        parentId
        rootId
        path
        status
        pathIds
        source
        trazoCategoryId
        nameExternal
        depth
        childrenCount
        isLeaf
        oldVersion
        productLine
        updatedAt
        __typename
      }
      isExternal
      isAllowable
      isRestricted
      isAutoSkipped
      isAutoAllowed
      isPurse
      massiveLayout
      hasBaseAmmount
      isFreeAmmount
      isCard
      isByRequest
      isMultiPrice
      cardBaseAmmount
      minCardBaseAmmount
      maxCardBaseAmmount
      nameExternal
      unspsc
      variants {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      visibleFor
      filterColors
      regions
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      productDescriptionItem {
        index
        status
        key
        description
        __typename
      }
      source
      trazoProductId
      trazoCategoryId
      stockUpdatedAt
      priceUpdatedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductsByCategoryQueryVariables,
  APITypes.ProductsByCategoryQuery
>;
export const ProductsByName = /* GraphQL */ `query ProductsByName(
  $name: String!
  $price: ModelFloatKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductoFilterInput
  $limit: Int
  $nextToken: String
) {
  ProductsByName(
    name: $name
    price: $price
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      providerId
      categoryId
      name
      status
      bestSeller
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      order
      sku
      brand
      colors
      pgClasitication
      delivery_time
      delivery_time_units
      stock
      minRequest
      maxRequest
      article_of_clothing
      size
      price
      long_description
      short_description
      creator
      provider {
        id
        isApproved
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comertial_name
        bussiness_name {
          rfc
          name
          __typename
        }
        idProcter
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        biography
        constancia {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comprobante {
          key
          url
          color
          palette
          colorName
          __typename
        }
        experience
        pros
        cons
        cte_rating {
          name
          rating
          __typename
        }
        shopping_rating {
          name
          rating
          __typename
        }
        video
        tags
        money_filter_c
        money_filter_d
        users
        bank
        account
        clabe
        cuenta_correo
        edocuenta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        ife {
          key
          url
          color
          palette
          colorName
          __typename
        }
        poderes {
          key
          url
          color
          palette
          colorName
          __typename
        }
        acta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        isProvider
        sameAddress
        isPop
        isPrinted
        hasLogistic
        created
        updated
        addFiles {
          key
          url
          sign
          status
          __typename
        }
        signFiles {
          key
          url
          sign
          status
          __typename
        }
        representante_legal
        escritura_constitucion
        notario_a
        constituido_down_edo
        rrpp
        isPremium
        isTrustProvider
        createdAt
        updatedAt
        __typename
      }
      category {
        id
        name
        description
        unspsc
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        imageMobile {
          key
          url
          color
          palette
          colorName
          __typename
        }
        visibleFor
        visibleForUserBrand
        region
        tags
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        hasAllowables
        hasPreapproveds
        hasRestricted
        isPublic
        isTop
        createdAt
        slug
        parentId
        rootId
        path
        status
        pathIds
        source
        trazoCategoryId
        nameExternal
        depth
        childrenCount
        isLeaf
        oldVersion
        productLine
        updatedAt
        __typename
      }
      isExternal
      isAllowable
      isRestricted
      isAutoSkipped
      isAutoAllowed
      isPurse
      massiveLayout
      hasBaseAmmount
      isFreeAmmount
      isCard
      isByRequest
      isMultiPrice
      cardBaseAmmount
      minCardBaseAmmount
      maxCardBaseAmmount
      nameExternal
      unspsc
      variants {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      visibleFor
      filterColors
      regions
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      productDescriptionItem {
        index
        status
        key
        description
        __typename
      }
      source
      trazoProductId
      trazoCategoryId
      stockUpdatedAt
      priceUpdatedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductsByNameQueryVariables,
  APITypes.ProductsByNameQuery
>;
export const productsByBestSellers = /* GraphQL */ `query ProductsByBestSellers(
  $bestSeller: String!
  $price: ModelFloatKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductoFilterInput
  $limit: Int
  $nextToken: String
) {
  productsByBestSellers(
    bestSeller: $bestSeller
    price: $price
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      providerId
      categoryId
      name
      status
      bestSeller
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      order
      sku
      brand
      colors
      pgClasitication
      delivery_time
      delivery_time_units
      stock
      minRequest
      maxRequest
      article_of_clothing
      size
      price
      long_description
      short_description
      creator
      provider {
        id
        isApproved
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comertial_name
        bussiness_name {
          rfc
          name
          __typename
        }
        idProcter
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        biography
        constancia {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comprobante {
          key
          url
          color
          palette
          colorName
          __typename
        }
        experience
        pros
        cons
        cte_rating {
          name
          rating
          __typename
        }
        shopping_rating {
          name
          rating
          __typename
        }
        video
        tags
        money_filter_c
        money_filter_d
        users
        bank
        account
        clabe
        cuenta_correo
        edocuenta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        ife {
          key
          url
          color
          palette
          colorName
          __typename
        }
        poderes {
          key
          url
          color
          palette
          colorName
          __typename
        }
        acta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        isProvider
        sameAddress
        isPop
        isPrinted
        hasLogistic
        created
        updated
        addFiles {
          key
          url
          sign
          status
          __typename
        }
        signFiles {
          key
          url
          sign
          status
          __typename
        }
        representante_legal
        escritura_constitucion
        notario_a
        constituido_down_edo
        rrpp
        isPremium
        isTrustProvider
        createdAt
        updatedAt
        __typename
      }
      category {
        id
        name
        description
        unspsc
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        imageMobile {
          key
          url
          color
          palette
          colorName
          __typename
        }
        visibleFor
        visibleForUserBrand
        region
        tags
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        hasAllowables
        hasPreapproveds
        hasRestricted
        isPublic
        isTop
        createdAt
        slug
        parentId
        rootId
        path
        status
        pathIds
        source
        trazoCategoryId
        nameExternal
        depth
        childrenCount
        isLeaf
        oldVersion
        productLine
        updatedAt
        __typename
      }
      isExternal
      isAllowable
      isRestricted
      isAutoSkipped
      isAutoAllowed
      isPurse
      massiveLayout
      hasBaseAmmount
      isFreeAmmount
      isCard
      isByRequest
      isMultiPrice
      cardBaseAmmount
      minCardBaseAmmount
      maxCardBaseAmmount
      nameExternal
      unspsc
      variants {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      visibleFor
      filterColors
      regions
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      productDescriptionItem {
        index
        status
        key
        description
        __typename
      }
      source
      trazoProductId
      trazoCategoryId
      stockUpdatedAt
      priceUpdatedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductsByBestSellersQueryVariables,
  APITypes.ProductsByBestSellersQuery
>;
export const productBySku = /* GraphQL */ `query ProductBySku(
  $sku: String!
  $order: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductoFilterInput
  $limit: Int
  $nextToken: String
) {
  productBySku(
    sku: $sku
    order: $order
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      providerId
      categoryId
      name
      status
      bestSeller
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      order
      sku
      brand
      colors
      pgClasitication
      delivery_time
      delivery_time_units
      stock
      minRequest
      maxRequest
      article_of_clothing
      size
      price
      long_description
      short_description
      creator
      provider {
        id
        isApproved
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comertial_name
        bussiness_name {
          rfc
          name
          __typename
        }
        idProcter
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        biography
        constancia {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comprobante {
          key
          url
          color
          palette
          colorName
          __typename
        }
        experience
        pros
        cons
        cte_rating {
          name
          rating
          __typename
        }
        shopping_rating {
          name
          rating
          __typename
        }
        video
        tags
        money_filter_c
        money_filter_d
        users
        bank
        account
        clabe
        cuenta_correo
        edocuenta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        ife {
          key
          url
          color
          palette
          colorName
          __typename
        }
        poderes {
          key
          url
          color
          palette
          colorName
          __typename
        }
        acta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        isProvider
        sameAddress
        isPop
        isPrinted
        hasLogistic
        created
        updated
        addFiles {
          key
          url
          sign
          status
          __typename
        }
        signFiles {
          key
          url
          sign
          status
          __typename
        }
        representante_legal
        escritura_constitucion
        notario_a
        constituido_down_edo
        rrpp
        isPremium
        isTrustProvider
        createdAt
        updatedAt
        __typename
      }
      category {
        id
        name
        description
        unspsc
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        imageMobile {
          key
          url
          color
          palette
          colorName
          __typename
        }
        visibleFor
        visibleForUserBrand
        region
        tags
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        hasAllowables
        hasPreapproveds
        hasRestricted
        isPublic
        isTop
        createdAt
        slug
        parentId
        rootId
        path
        status
        pathIds
        source
        trazoCategoryId
        nameExternal
        depth
        childrenCount
        isLeaf
        oldVersion
        productLine
        updatedAt
        __typename
      }
      isExternal
      isAllowable
      isRestricted
      isAutoSkipped
      isAutoAllowed
      isPurse
      massiveLayout
      hasBaseAmmount
      isFreeAmmount
      isCard
      isByRequest
      isMultiPrice
      cardBaseAmmount
      minCardBaseAmmount
      maxCardBaseAmmount
      nameExternal
      unspsc
      variants {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      visibleFor
      filterColors
      regions
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      productDescriptionItem {
        index
        status
        key
        description
        __typename
      }
      source
      trazoProductId
      trazoCategoryId
      stockUpdatedAt
      priceUpdatedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductBySkuQueryVariables,
  APITypes.ProductBySkuQuery
>;
export const productsByAutoSkipped = /* GraphQL */ `query ProductsByAutoSkipped(
  $isAutoSkipped: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductoFilterInput
  $limit: Int
  $nextToken: String
) {
  productsByAutoSkipped(
    isAutoSkipped: $isAutoSkipped
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      providerId
      categoryId
      name
      status
      bestSeller
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      order
      sku
      brand
      colors
      pgClasitication
      delivery_time
      delivery_time_units
      stock
      minRequest
      maxRequest
      article_of_clothing
      size
      price
      long_description
      short_description
      creator
      provider {
        id
        isApproved
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comertial_name
        bussiness_name {
          rfc
          name
          __typename
        }
        idProcter
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        biography
        constancia {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comprobante {
          key
          url
          color
          palette
          colorName
          __typename
        }
        experience
        pros
        cons
        cte_rating {
          name
          rating
          __typename
        }
        shopping_rating {
          name
          rating
          __typename
        }
        video
        tags
        money_filter_c
        money_filter_d
        users
        bank
        account
        clabe
        cuenta_correo
        edocuenta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        ife {
          key
          url
          color
          palette
          colorName
          __typename
        }
        poderes {
          key
          url
          color
          palette
          colorName
          __typename
        }
        acta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        isProvider
        sameAddress
        isPop
        isPrinted
        hasLogistic
        created
        updated
        addFiles {
          key
          url
          sign
          status
          __typename
        }
        signFiles {
          key
          url
          sign
          status
          __typename
        }
        representante_legal
        escritura_constitucion
        notario_a
        constituido_down_edo
        rrpp
        isPremium
        isTrustProvider
        createdAt
        updatedAt
        __typename
      }
      category {
        id
        name
        description
        unspsc
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        imageMobile {
          key
          url
          color
          palette
          colorName
          __typename
        }
        visibleFor
        visibleForUserBrand
        region
        tags
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        hasAllowables
        hasPreapproveds
        hasRestricted
        isPublic
        isTop
        createdAt
        slug
        parentId
        rootId
        path
        status
        pathIds
        source
        trazoCategoryId
        nameExternal
        depth
        childrenCount
        isLeaf
        oldVersion
        productLine
        updatedAt
        __typename
      }
      isExternal
      isAllowable
      isRestricted
      isAutoSkipped
      isAutoAllowed
      isPurse
      massiveLayout
      hasBaseAmmount
      isFreeAmmount
      isCard
      isByRequest
      isMultiPrice
      cardBaseAmmount
      minCardBaseAmmount
      maxCardBaseAmmount
      nameExternal
      unspsc
      variants {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      visibleFor
      filterColors
      regions
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      productDescriptionItem {
        index
        status
        key
        description
        __typename
      }
      source
      trazoProductId
      trazoCategoryId
      stockUpdatedAt
      priceUpdatedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductsByAutoSkippedQueryVariables,
  APITypes.ProductsByAutoSkippedQuery
>;
export const productsByAutoAllowed = /* GraphQL */ `query ProductsByAutoAllowed(
  $isAutoAllowed: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductoFilterInput
  $limit: Int
  $nextToken: String
) {
  productsByAutoAllowed(
    isAutoAllowed: $isAutoAllowed
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      providerId
      categoryId
      name
      status
      bestSeller
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      order
      sku
      brand
      colors
      pgClasitication
      delivery_time
      delivery_time_units
      stock
      minRequest
      maxRequest
      article_of_clothing
      size
      price
      long_description
      short_description
      creator
      provider {
        id
        isApproved
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comertial_name
        bussiness_name {
          rfc
          name
          __typename
        }
        idProcter
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        biography
        constancia {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comprobante {
          key
          url
          color
          palette
          colorName
          __typename
        }
        experience
        pros
        cons
        cte_rating {
          name
          rating
          __typename
        }
        shopping_rating {
          name
          rating
          __typename
        }
        video
        tags
        money_filter_c
        money_filter_d
        users
        bank
        account
        clabe
        cuenta_correo
        edocuenta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        ife {
          key
          url
          color
          palette
          colorName
          __typename
        }
        poderes {
          key
          url
          color
          palette
          colorName
          __typename
        }
        acta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        isProvider
        sameAddress
        isPop
        isPrinted
        hasLogistic
        created
        updated
        addFiles {
          key
          url
          sign
          status
          __typename
        }
        signFiles {
          key
          url
          sign
          status
          __typename
        }
        representante_legal
        escritura_constitucion
        notario_a
        constituido_down_edo
        rrpp
        isPremium
        isTrustProvider
        createdAt
        updatedAt
        __typename
      }
      category {
        id
        name
        description
        unspsc
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        imageMobile {
          key
          url
          color
          palette
          colorName
          __typename
        }
        visibleFor
        visibleForUserBrand
        region
        tags
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        hasAllowables
        hasPreapproveds
        hasRestricted
        isPublic
        isTop
        createdAt
        slug
        parentId
        rootId
        path
        status
        pathIds
        source
        trazoCategoryId
        nameExternal
        depth
        childrenCount
        isLeaf
        oldVersion
        productLine
        updatedAt
        __typename
      }
      isExternal
      isAllowable
      isRestricted
      isAutoSkipped
      isAutoAllowed
      isPurse
      massiveLayout
      hasBaseAmmount
      isFreeAmmount
      isCard
      isByRequest
      isMultiPrice
      cardBaseAmmount
      minCardBaseAmmount
      maxCardBaseAmmount
      nameExternal
      unspsc
      variants {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      visibleFor
      filterColors
      regions
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      productDescriptionItem {
        index
        status
        key
        description
        __typename
      }
      source
      trazoProductId
      trazoCategoryId
      stockUpdatedAt
      priceUpdatedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductsByAutoAllowedQueryVariables,
  APITypes.ProductsByAutoAllowedQuery
>;
export const ProductsByMassiveLayout = /* GraphQL */ `query ProductsByMassiveLayout(
  $massiveLayout: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductoFilterInput
  $limit: Int
  $nextToken: String
) {
  ProductsByMassiveLayout(
    massiveLayout: $massiveLayout
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      providerId
      categoryId
      name
      status
      bestSeller
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      order
      sku
      brand
      colors
      pgClasitication
      delivery_time
      delivery_time_units
      stock
      minRequest
      maxRequest
      article_of_clothing
      size
      price
      long_description
      short_description
      creator
      provider {
        id
        isApproved
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comertial_name
        bussiness_name {
          rfc
          name
          __typename
        }
        idProcter
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        biography
        constancia {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comprobante {
          key
          url
          color
          palette
          colorName
          __typename
        }
        experience
        pros
        cons
        cte_rating {
          name
          rating
          __typename
        }
        shopping_rating {
          name
          rating
          __typename
        }
        video
        tags
        money_filter_c
        money_filter_d
        users
        bank
        account
        clabe
        cuenta_correo
        edocuenta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        ife {
          key
          url
          color
          palette
          colorName
          __typename
        }
        poderes {
          key
          url
          color
          palette
          colorName
          __typename
        }
        acta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        isProvider
        sameAddress
        isPop
        isPrinted
        hasLogistic
        created
        updated
        addFiles {
          key
          url
          sign
          status
          __typename
        }
        signFiles {
          key
          url
          sign
          status
          __typename
        }
        representante_legal
        escritura_constitucion
        notario_a
        constituido_down_edo
        rrpp
        isPremium
        isTrustProvider
        createdAt
        updatedAt
        __typename
      }
      category {
        id
        name
        description
        unspsc
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        imageMobile {
          key
          url
          color
          palette
          colorName
          __typename
        }
        visibleFor
        visibleForUserBrand
        region
        tags
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        hasAllowables
        hasPreapproveds
        hasRestricted
        isPublic
        isTop
        createdAt
        slug
        parentId
        rootId
        path
        status
        pathIds
        source
        trazoCategoryId
        nameExternal
        depth
        childrenCount
        isLeaf
        oldVersion
        productLine
        updatedAt
        __typename
      }
      isExternal
      isAllowable
      isRestricted
      isAutoSkipped
      isAutoAllowed
      isPurse
      massiveLayout
      hasBaseAmmount
      isFreeAmmount
      isCard
      isByRequest
      isMultiPrice
      cardBaseAmmount
      minCardBaseAmmount
      maxCardBaseAmmount
      nameExternal
      unspsc
      variants {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      visibleFor
      filterColors
      regions
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      productDescriptionItem {
        index
        status
        key
        description
        __typename
      }
      source
      trazoProductId
      trazoCategoryId
      stockUpdatedAt
      priceUpdatedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductsByMassiveLayoutQueryVariables,
  APITypes.ProductsByMassiveLayoutQuery
>;
export const ProductsByNameExternal = /* GraphQL */ `query ProductsByNameExternal(
  $nameExternal: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductoFilterInput
  $limit: Int
  $nextToken: String
) {
  ProductsByNameExternal(
    nameExternal: $nameExternal
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      providerId
      categoryId
      name
      status
      bestSeller
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      order
      sku
      brand
      colors
      pgClasitication
      delivery_time
      delivery_time_units
      stock
      minRequest
      maxRequest
      article_of_clothing
      size
      price
      long_description
      short_description
      creator
      provider {
        id
        isApproved
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comertial_name
        bussiness_name {
          rfc
          name
          __typename
        }
        idProcter
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        biography
        constancia {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comprobante {
          key
          url
          color
          palette
          colorName
          __typename
        }
        experience
        pros
        cons
        cte_rating {
          name
          rating
          __typename
        }
        shopping_rating {
          name
          rating
          __typename
        }
        video
        tags
        money_filter_c
        money_filter_d
        users
        bank
        account
        clabe
        cuenta_correo
        edocuenta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        ife {
          key
          url
          color
          palette
          colorName
          __typename
        }
        poderes {
          key
          url
          color
          palette
          colorName
          __typename
        }
        acta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        isProvider
        sameAddress
        isPop
        isPrinted
        hasLogistic
        created
        updated
        addFiles {
          key
          url
          sign
          status
          __typename
        }
        signFiles {
          key
          url
          sign
          status
          __typename
        }
        representante_legal
        escritura_constitucion
        notario_a
        constituido_down_edo
        rrpp
        isPremium
        isTrustProvider
        createdAt
        updatedAt
        __typename
      }
      category {
        id
        name
        description
        unspsc
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        imageMobile {
          key
          url
          color
          palette
          colorName
          __typename
        }
        visibleFor
        visibleForUserBrand
        region
        tags
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        hasAllowables
        hasPreapproveds
        hasRestricted
        isPublic
        isTop
        createdAt
        slug
        parentId
        rootId
        path
        status
        pathIds
        source
        trazoCategoryId
        nameExternal
        depth
        childrenCount
        isLeaf
        oldVersion
        productLine
        updatedAt
        __typename
      }
      isExternal
      isAllowable
      isRestricted
      isAutoSkipped
      isAutoAllowed
      isPurse
      massiveLayout
      hasBaseAmmount
      isFreeAmmount
      isCard
      isByRequest
      isMultiPrice
      cardBaseAmmount
      minCardBaseAmmount
      maxCardBaseAmmount
      nameExternal
      unspsc
      variants {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      visibleFor
      filterColors
      regions
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      productDescriptionItem {
        index
        status
        key
        description
        __typename
      }
      source
      trazoProductId
      trazoCategoryId
      stockUpdatedAt
      priceUpdatedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductsByNameExternalQueryVariables,
  APITypes.ProductsByNameExternalQuery
>;
export const productsBySource = /* GraphQL */ `query ProductsBySource(
  $source: String!
  $updatedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductoFilterInput
  $limit: Int
  $nextToken: String
) {
  productsBySource(
    source: $source
    updatedAt: $updatedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      providerId
      categoryId
      name
      status
      bestSeller
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      order
      sku
      brand
      colors
      pgClasitication
      delivery_time
      delivery_time_units
      stock
      minRequest
      maxRequest
      article_of_clothing
      size
      price
      long_description
      short_description
      creator
      provider {
        id
        isApproved
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comertial_name
        bussiness_name {
          rfc
          name
          __typename
        }
        idProcter
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        biography
        constancia {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comprobante {
          key
          url
          color
          palette
          colorName
          __typename
        }
        experience
        pros
        cons
        cte_rating {
          name
          rating
          __typename
        }
        shopping_rating {
          name
          rating
          __typename
        }
        video
        tags
        money_filter_c
        money_filter_d
        users
        bank
        account
        clabe
        cuenta_correo
        edocuenta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        ife {
          key
          url
          color
          palette
          colorName
          __typename
        }
        poderes {
          key
          url
          color
          palette
          colorName
          __typename
        }
        acta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        isProvider
        sameAddress
        isPop
        isPrinted
        hasLogistic
        created
        updated
        addFiles {
          key
          url
          sign
          status
          __typename
        }
        signFiles {
          key
          url
          sign
          status
          __typename
        }
        representante_legal
        escritura_constitucion
        notario_a
        constituido_down_edo
        rrpp
        isPremium
        isTrustProvider
        createdAt
        updatedAt
        __typename
      }
      category {
        id
        name
        description
        unspsc
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        imageMobile {
          key
          url
          color
          palette
          colorName
          __typename
        }
        visibleFor
        visibleForUserBrand
        region
        tags
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        hasAllowables
        hasPreapproveds
        hasRestricted
        isPublic
        isTop
        createdAt
        slug
        parentId
        rootId
        path
        status
        pathIds
        source
        trazoCategoryId
        nameExternal
        depth
        childrenCount
        isLeaf
        oldVersion
        productLine
        updatedAt
        __typename
      }
      isExternal
      isAllowable
      isRestricted
      isAutoSkipped
      isAutoAllowed
      isPurse
      massiveLayout
      hasBaseAmmount
      isFreeAmmount
      isCard
      isByRequest
      isMultiPrice
      cardBaseAmmount
      minCardBaseAmmount
      maxCardBaseAmmount
      nameExternal
      unspsc
      variants {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      visibleFor
      filterColors
      regions
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      productDescriptionItem {
        index
        status
        key
        description
        __typename
      }
      source
      trazoProductId
      trazoCategoryId
      stockUpdatedAt
      priceUpdatedAt
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductsBySourceQueryVariables,
  APITypes.ProductsBySourceQuery
>;
export const ProductVariantsByProductId = /* GraphQL */ `query ProductVariantsByProductId(
  $productId: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductVariantFilterInput
  $limit: Int
  $nextToken: String
) {
  ProductVariantsByProductId(
    productId: $productId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      productId
      sku
      name
      description
      colors
      filterColors
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      stock_available
      price
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductVariantsByProductIdQueryVariables,
  APITypes.ProductVariantsByProductIdQuery
>;
export const ProductOptionsByOwnOrder = /* GraphQL */ `query ProductOptionsByOwnOrder(
  $ownOrder: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductOptionFilterInput
  $limit: Int
  $nextToken: String
) {
  ProductOptionsByOwnOrder(
    ownOrder: $ownOrder
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      ownOrder
      isPangga
      volumetricWeight
      isEvaluated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductOptionsByOwnOrderQueryVariables,
  APITypes.ProductOptionsByOwnOrderQuery
>;
export const ListPanggaProducts = /* GraphQL */ `query ListPanggaProducts(
  $isPangga: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductOptionFilterInput
  $limit: Int
  $nextToken: String
) {
  ListPanggaProducts(
    isPangga: $isPangga
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      ownOrder
      isPangga
      volumetricWeight
      isEvaluated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPanggaProductsQueryVariables,
  APITypes.ListPanggaProductsQuery
>;
export const ListVolumetricWeightProducts = /* GraphQL */ `query ListVolumetricWeightProducts(
  $volumetricWeight: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductOptionFilterInput
  $limit: Int
  $nextToken: String
) {
  ListVolumetricWeightProducts(
    volumetricWeight: $volumetricWeight
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      ownOrder
      isPangga
      volumetricWeight
      isEvaluated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListVolumetricWeightProductsQueryVariables,
  APITypes.ListVolumetricWeightProductsQuery
>;
export const ListAIEvaluatedProducts = /* GraphQL */ `query ListAIEvaluatedProducts(
  $isEvaluated: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductOptionFilterInput
  $limit: Int
  $nextToken: String
) {
  ListAIEvaluatedProducts(
    isEvaluated: $isEvaluated
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      ownOrder
      isPangga
      volumetricWeight
      isEvaluated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListAIEvaluatedProductsQueryVariables,
  APITypes.ListAIEvaluatedProductsQuery
>;
export const MassiveLayoutsByType = /* GraphQL */ `query MassiveLayoutsByType(
  $type: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelMassiveChangeLayoutsFilterInput
  $limit: Int
  $nextToken: String
) {
  MassiveLayoutsByType(
    type: $type
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      status
      providerId
      creatorId
      creatorRole
      productsNumber
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MassiveLayoutsByTypeQueryVariables,
  APITypes.MassiveLayoutsByTypeQuery
>;
export const MassiveLayoutsByStatus = /* GraphQL */ `query MassiveLayoutsByStatus(
  $status: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelMassiveChangeLayoutsFilterInput
  $limit: Int
  $nextToken: String
) {
  MassiveLayoutsByStatus(
    status: $status
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      status
      providerId
      creatorId
      creatorRole
      productsNumber
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MassiveLayoutsByStatusQueryVariables,
  APITypes.MassiveLayoutsByStatusQuery
>;
export const MassiveLayoutsByProvider = /* GraphQL */ `query MassiveLayoutsByProvider(
  $providerId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelMassiveChangeLayoutsFilterInput
  $limit: Int
  $nextToken: String
) {
  MassiveLayoutsByProvider(
    providerId: $providerId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      status
      providerId
      creatorId
      creatorRole
      productsNumber
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MassiveLayoutsByProviderQueryVariables,
  APITypes.MassiveLayoutsByProviderQuery
>;
export const MassiveLayoutsByCreator = /* GraphQL */ `query MassiveLayoutsByCreator(
  $creatorId: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelMassiveChangeLayoutsFilterInput
  $limit: Int
  $nextToken: String
) {
  MassiveLayoutsByCreator(
    creatorId: $creatorId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      status
      providerId
      creatorId
      creatorRole
      productsNumber
      file {
        key
        url
        color
        palette
        colorName
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MassiveLayoutsByCreatorQueryVariables,
  APITypes.MassiveLayoutsByCreatorQuery
>;
export const listCategoriesByParentCategory = /* GraphQL */ `query ListCategoriesByParentCategory(
  $parentId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listCategoriesByParentCategory(
    parentId: $parentId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      description
      unspsc
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      imageMobile {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      visibleForUserBrand
      region
      tags
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      hasAllowables
      hasPreapproveds
      hasRestricted
      isPublic
      isTop
      createdAt
      slug
      parentId
      rootId
      path
      status
      pathIds
      source
      trazoCategoryId
      nameExternal
      depth
      childrenCount
      isLeaf
      oldVersion
      productLine
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCategoriesByParentCategoryQueryVariables,
  APITypes.ListCategoriesByParentCategoryQuery
>;
export const listCategoriesByRootAndPath = /* GraphQL */ `query ListCategoriesByRootAndPath(
  $rootId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listCategoriesByRootAndPath(
    rootId: $rootId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      description
      unspsc
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      imageMobile {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      visibleForUserBrand
      region
      tags
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      hasAllowables
      hasPreapproveds
      hasRestricted
      isPublic
      isTop
      createdAt
      slug
      parentId
      rootId
      path
      status
      pathIds
      source
      trazoCategoryId
      nameExternal
      depth
      childrenCount
      isLeaf
      oldVersion
      productLine
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCategoriesByRootAndPathQueryVariables,
  APITypes.ListCategoriesByRootAndPathQuery
>;
export const listCategoriesByPath = /* GraphQL */ `query ListCategoriesByPath(
  $path: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listCategoriesByPath(
    path: $path
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      description
      unspsc
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      imageMobile {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      visibleForUserBrand
      region
      tags
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      hasAllowables
      hasPreapproveds
      hasRestricted
      isPublic
      isTop
      createdAt
      slug
      parentId
      rootId
      path
      status
      pathIds
      source
      trazoCategoryId
      nameExternal
      depth
      childrenCount
      isLeaf
      oldVersion
      productLine
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCategoriesByPathQueryVariables,
  APITypes.ListCategoriesByPathQuery
>;
export const listCategoriesByNameExternal = /* GraphQL */ `query ListCategoriesByNameExternal(
  $nameExternal: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  listCategoriesByNameExternal(
    nameExternal: $nameExternal
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      description
      unspsc
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      imageMobile {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      visibleForUserBrand
      region
      tags
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      hasAllowables
      hasPreapproveds
      hasRestricted
      isPublic
      isTop
      createdAt
      slug
      parentId
      rootId
      path
      status
      pathIds
      source
      trazoCategoryId
      nameExternal
      depth
      childrenCount
      isLeaf
      oldVersion
      productLine
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCategoriesByNameExternalQueryVariables,
  APITypes.ListCategoriesByNameExternalQuery
>;
export const ListCategoriesByProductLine = /* GraphQL */ `query ListCategoriesByProductLine(
  $productLine: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  ListCategoriesByProductLine(
    productLine: $productLine
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      description
      unspsc
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      imageMobile {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      visibleForUserBrand
      region
      tags
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      hasAllowables
      hasPreapproveds
      hasRestricted
      isPublic
      isTop
      createdAt
      slug
      parentId
      rootId
      path
      status
      pathIds
      source
      trazoCategoryId
      nameExternal
      depth
      childrenCount
      isLeaf
      oldVersion
      productLine
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListCategoriesByProductLineQueryVariables,
  APITypes.ListCategoriesByProductLineQuery
>;
export const ProductBrandsByStatus = /* GraphQL */ `query ProductBrandsByStatus(
  $status: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductBrandFilterInput
  $limit: Int
  $nextToken: String
) {
  ProductBrandsByStatus(
    status: $status
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      status
      description
      route
      unspsc
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      region
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      hasAllowables
      hasPreapproveds
      hasRestricted
      isTop
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductBrandsByStatusQueryVariables,
  APITypes.ProductBrandsByStatusQuery
>;
export const GetUserByRol = /* GraphQL */ `query GetUserByRol(
  $role: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  GetUserByRol(
    role: $role
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      role
      email
      jiraId
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      companyId
      brandId
      failedLogins
      agents {
        id
        name
        email
        phoneNumber
        __typename
      }
      notificationsOf
      status
      isLogistic
      isCoupa
      isManagement
      isAdministration
      hasNotifications
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserByRolQueryVariables,
  APITypes.GetUserByRolQuery
>;
export const GetUserByEmail = /* GraphQL */ `query GetUserByEmail(
  $email: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  GetUserByEmail(
    email: $email
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      role
      email
      jiraId
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      companyId
      brandId
      failedLogins
      agents {
        id
        name
        email
        phoneNumber
        __typename
      }
      notificationsOf
      status
      isLogistic
      isCoupa
      isManagement
      isAdministration
      hasNotifications
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserByEmailQueryVariables,
  APITypes.GetUserByEmailQuery
>;
export const GetUserByJiraId = /* GraphQL */ `query GetUserByJiraId(
  $jiraId: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  GetUserByJiraId(
    jiraId: $jiraId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      role
      email
      jiraId
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      companyId
      brandId
      failedLogins
      agents {
        id
        name
        email
        phoneNumber
        __typename
      }
      notificationsOf
      status
      isLogistic
      isCoupa
      isManagement
      isAdministration
      hasNotifications
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserByJiraIdQueryVariables,
  APITypes.GetUserByJiraIdQuery
>;
export const GetUserByCompanyId = /* GraphQL */ `query GetUserByCompanyId(
  $companyId: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  GetUserByCompanyId(
    companyId: $companyId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      role
      email
      jiraId
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      companyId
      brandId
      failedLogins
      agents {
        id
        name
        email
        phoneNumber
        __typename
      }
      notificationsOf
      status
      isLogistic
      isCoupa
      isManagement
      isAdministration
      hasNotifications
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUserByCompanyIdQueryVariables,
  APITypes.GetUserByCompanyIdQuery
>;
export const GetUsersByBrandId = /* GraphQL */ `query GetUsersByBrandId(
  $brandId: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelUserFilterInput
  $limit: Int
  $nextToken: String
) {
  GetUsersByBrandId(
    brandId: $brandId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      role
      email
      jiraId
      phoneNumber
      avatar {
        key
        url
        color
        palette
        colorName
        __typename
      }
      companyId
      brandId
      failedLogins
      agents {
        id
        name
        email
        phoneNumber
        __typename
      }
      notificationsOf
      status
      isLogistic
      isCoupa
      isManagement
      isAdministration
      hasNotifications
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUsersByBrandIdQueryVariables,
  APITypes.GetUsersByBrandIdQuery
>;
export const getAutosByCreated = /* GraphQL */ `query GetAutosByCreated(
  $id: ID!
  $created: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAutomobileFilterInput
  $limit: Int
  $nextToken: String
) {
  getAutosByCreated(
    id: $id
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      clientId
      status
      bought
      buyerId
      buyerName
      price
      brand
      brandId
      model
      version
      year
      color
      km
      transmission
      motor
      passengers
      state
      objeto
      placa
      serialNumber
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      star_time
      end_time
      usersInteresting {
        iduser
        nombre
        email
        fecha_compra
        veces_rechazo
        winner
        fecha_notificacion
        buyer
        process_buyer
        d_winner_date
        created
        __typename
      }
      comentario
      penalizacion
      haveWinner
      ppostulacion
      logsGanadoresAutos {
        items {
          id
          id_auto
          id_user
          fecha_rifa
          email
          nombre
          a_paterno
          a_materno
          status_buyer
          date_buyer
          winner
          refused
          since
          process_buyer
          reactive
          created
          updated
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAutosByCreatedQueryVariables,
  APITypes.GetAutosByCreatedQuery
>;
export const getAutosByClientId = /* GraphQL */ `query GetAutosByClientId(
  $clientId: ID!
  $created: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAutomobileFilterInput
  $limit: Int
  $nextToken: String
) {
  getAutosByClientId(
    clientId: $clientId
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      clientId
      status
      bought
      buyerId
      buyerName
      price
      brand
      brandId
      model
      version
      year
      color
      km
      transmission
      motor
      passengers
      state
      objeto
      placa
      serialNumber
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      star_time
      end_time
      usersInteresting {
        iduser
        nombre
        email
        fecha_compra
        veces_rechazo
        winner
        fecha_notificacion
        buyer
        process_buyer
        d_winner_date
        created
        __typename
      }
      comentario
      penalizacion
      haveWinner
      ppostulacion
      logsGanadoresAutos {
        items {
          id
          id_auto
          id_user
          fecha_rifa
          email
          nombre
          a_paterno
          a_materno
          status_buyer
          date_buyer
          winner
          refused
          since
          process_buyer
          reactive
          created
          updated
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetAutosByClientIdQueryVariables,
  APITypes.GetAutosByClientIdQuery
>;
export const listRfqsByCreated = /* GraphQL */ `query ListRfqsByCreated(
  $estatus: String!
  $created: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRfqFilterInput
  $limit: Int
  $nextToken: String
) {
  listRfqsByCreated(
    estatus: $estatus
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      proposals {
        items {
          id
          provider_id
          priceUnit
          pieces
          price
          validity_days
          description
          created
          updated
          multipleProducts
          hidden
          proposalsRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      premiumOrderId
      estatus
      orderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      multipleProducts
      providers
      productsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRfqsByCreatedQueryVariables,
  APITypes.ListRfqsByCreatedQuery
>;
export const listRfqsByClient = /* GraphQL */ `query ListRfqsByClient(
  $estatus: String!
  $clientId: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRfqFilterInput
  $limit: Int
  $nextToken: String
) {
  listRfqsByClient(
    estatus: $estatus
    clientId: $clientId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      proposals {
        items {
          id
          provider_id
          priceUnit
          pieces
          price
          validity_days
          description
          created
          updated
          multipleProducts
          hidden
          proposalsRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      premiumOrderId
      estatus
      orderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      multipleProducts
      providers
      productsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRfqsByClientQueryVariables,
  APITypes.ListRfqsByClientQuery
>;
export const listRfqsByClientCreated = /* GraphQL */ `query ListRfqsByClientCreated(
  $estatus: String!
  $clientIdCreated: ModelRfqByEstatusClientCreatedCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRfqFilterInput
  $limit: Int
  $nextToken: String
) {
  listRfqsByClientCreated(
    estatus: $estatus
    clientIdCreated: $clientIdCreated
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      proposals {
        items {
          id
          provider_id
          priceUnit
          pieces
          price
          validity_days
          description
          created
          updated
          multipleProducts
          hidden
          proposalsRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      premiumOrderId
      estatus
      orderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      multipleProducts
      providers
      productsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRfqsByClientCreatedQueryVariables,
  APITypes.ListRfqsByClientCreatedQuery
>;
export const listRfqsAmazonByCreated = /* GraphQL */ `query ListRfqsAmazonByCreated(
  $estatus: String!
  $created: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRfqAmazonFilterInput
  $limit: Int
  $nextToken: String
) {
  listRfqsAmazonByCreated(
    estatus: $estatus
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      proposals {
        items {
          id
          provider_id
          priceUnit
          pieces
          price
          validity_days
          description
          created
          updated
          multipleProducts
          hidden
          proposalsRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      estatus
      orderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      multipleProducts
      providers
      productsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRfqsAmazonByCreatedQueryVariables,
  APITypes.ListRfqsAmazonByCreatedQuery
>;
export const listRfqsByAmazonByClient = /* GraphQL */ `query ListRfqsByAmazonByClient(
  $estatus: String!
  $clientId: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRfqAmazonFilterInput
  $limit: Int
  $nextToken: String
) {
  listRfqsByAmazonByClient(
    estatus: $estatus
    clientId: $clientId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      proposals {
        items {
          id
          provider_id
          priceUnit
          pieces
          price
          validity_days
          description
          created
          updated
          multipleProducts
          hidden
          proposalsRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      estatus
      orderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      multipleProducts
      providers
      productsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRfqsByAmazonByClientQueryVariables,
  APITypes.ListRfqsByAmazonByClientQuery
>;
export const listRfqsAmazonByClientC = /* GraphQL */ `query ListRfqsAmazonByClientC(
  $estatus: String!
  $clientIdCreated: ModelRfqAmazonByEstatusClientACreatedCompositeKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRfqAmazonFilterInput
  $limit: Int
  $nextToken: String
) {
  listRfqsAmazonByClientC(
    estatus: $estatus
    clientIdCreated: $clientIdCreated
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      proposals {
        items {
          id
          provider_id
          priceUnit
          pieces
          price
          validity_days
          description
          created
          updated
          multipleProducts
          hidden
          proposalsRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      estatus
      orderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      multipleProducts
      providers
      productsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRfqsAmazonByClientCQueryVariables,
  APITypes.ListRfqsAmazonByClientCQuery
>;
export const listProductosRfqPrice = /* GraphQL */ `query ListProductosRfqPrice(
  $category_id: ID!
  $price: ModelFloatKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductoRfqFilterInput
  $limit: Int
  $nextToken: String
) {
  listProductosRfqPrice(
    category_id: $category_id
    price: $price
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      request
      category_id
      provider_id
      price
      category {
        id
        name
        description
        unspsc
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        imageMobile {
          key
          url
          color
          palette
          colorName
          __typename
        }
        visibleFor
        visibleForUserBrand
        region
        tags
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        hasAllowables
        hasPreapproveds
        hasRestricted
        isPublic
        isTop
        createdAt
        slug
        parentId
        rootId
        path
        status
        pathIds
        source
        trazoCategoryId
        nameExternal
        depth
        childrenCount
        isLeaf
        oldVersion
        productLine
        updatedAt
        __typename
      }
      provider {
        id
        isApproved
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comertial_name
        bussiness_name {
          rfc
          name
          __typename
        }
        idProcter
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        biography
        constancia {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comprobante {
          key
          url
          color
          palette
          colorName
          __typename
        }
        experience
        pros
        cons
        cte_rating {
          name
          rating
          __typename
        }
        shopping_rating {
          name
          rating
          __typename
        }
        video
        tags
        money_filter_c
        money_filter_d
        users
        bank
        account
        clabe
        cuenta_correo
        edocuenta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        ife {
          key
          url
          color
          palette
          colorName
          __typename
        }
        poderes {
          key
          url
          color
          palette
          colorName
          __typename
        }
        acta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        isProvider
        sameAddress
        isPop
        isPrinted
        hasLogistic
        created
        updated
        addFiles {
          key
          url
          sign
          status
          __typename
        }
        signFiles {
          key
          url
          sign
          status
          __typename
        }
        representante_legal
        escritura_constitucion
        notario_a
        constituido_down_edo
        rrpp
        isPremium
        isTrustProvider
        createdAt
        updatedAt
        __typename
      }
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      estatus
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListProductosRfqPriceQueryVariables,
  APITypes.ListProductosRfqPriceQuery
>;
export const ordersByProvider = /* GraphQL */ `query OrdersByProvider(
  $provider_id: String!
  $orderId: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelOrderProvidersFilterInput
  $limit: Int
  $nextToken: String
) {
  ordersByProvider(
    provider_id: $provider_id
    orderId: $orderId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      provider_id
      clientId
      orderId
      orderProvidersPremiumOrderId
      payment_date
      gr_code
      invoice
      invoiceRequested
      uploadedGr
      uploadedBill
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OrdersByProviderQueryVariables,
  APITypes.OrdersByProviderQuery
>;
export const OrdersProvidersByClientId = /* GraphQL */ `query OrdersProvidersByClientId(
  $clientId: String!
  $orderId: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelOrderProvidersFilterInput
  $limit: Int
  $nextToken: String
) {
  OrdersProvidersByClientId(
    clientId: $clientId
    orderId: $orderId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      provider_id
      clientId
      orderId
      orderProvidersPremiumOrderId
      payment_date
      gr_code
      invoice
      invoiceRequested
      uploadedGr
      uploadedBill
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OrdersProvidersByClientIdQueryVariables,
  APITypes.OrdersProvidersByClientIdQuery
>;
export const OrderProviderByPremiumOrderId = /* GraphQL */ `query OrderProviderByPremiumOrderId(
  $orderProvidersPremiumOrderId: ID!
  $orderId: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelOrderProvidersFilterInput
  $limit: Int
  $nextToken: String
) {
  OrderProviderByPremiumOrderId(
    orderProvidersPremiumOrderId: $orderProvidersPremiumOrderId
    orderId: $orderId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      provider_id
      clientId
      orderId
      orderProvidersPremiumOrderId
      payment_date
      gr_code
      invoice
      invoiceRequested
      uploadedGr
      uploadedBill
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OrderProviderByPremiumOrderIdQueryVariables,
  APITypes.OrderProviderByPremiumOrderIdQuery
>;
export const VehicleTypesByPopMaterialId = /* GraphQL */ `query VehicleTypesByPopMaterialId(
  $popMaterialId: ID!
  $id: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelVehicleTypeFilterInput
  $limit: Int
  $nextToken: String
) {
  VehicleTypesByPopMaterialId(
    popMaterialId: $popMaterialId
    id: $id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      popMaterialId
      visibleFor
      region
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      popMaterial {
        id
        name
        route
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        visibleFor
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        year
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.VehicleTypesByPopMaterialIdQueryVariables,
  APITypes.VehicleTypesByPopMaterialIdQuery
>;
export const VehiclesByBestSellers = /* GraphQL */ `query VehiclesByBestSellers(
  $bestSeller: String!
  $unitPrice: ModelFloatKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelVehicleFilterInput
  $limit: Int
  $nextToken: String
) {
  VehiclesByBestSellers(
    bestSeller: $bestSeller
    unitPrice: $unitPrice
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      isSustainable
      multiProvider
      itemName
      bestSeller
      name
      brand
      channel
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      description
      size
      materialDetail
      print
      finish
      packaging
      quantity
      unitPrice
      prototypePrice
      productionTime
      vehicleTypeId
      popMaterialId
      popCategoryId
      providerId
      isRfq
      historicCost
      historicTime
      contact
      providerName
      variantsUnits {
        min_units
        max_units
        price
        production_time
        __typename
      }
      visibleFor
      filterColors
      providers
      massiveLayout
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.VehiclesByBestSellersQueryVariables,
  APITypes.VehiclesByBestSellersQuery
>;
export const vehiclesByType = /* GraphQL */ `query VehiclesByType(
  $vehicleTypeId: ID!
  $id: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelVehicleFilterInput
  $limit: Int
  $nextToken: String
) {
  vehiclesByType(
    vehicleTypeId: $vehicleTypeId
    id: $id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      isSustainable
      multiProvider
      itemName
      bestSeller
      name
      brand
      channel
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      description
      size
      materialDetail
      print
      finish
      packaging
      quantity
      unitPrice
      prototypePrice
      productionTime
      vehicleTypeId
      popMaterialId
      popCategoryId
      providerId
      isRfq
      historicCost
      historicTime
      contact
      providerName
      variantsUnits {
        min_units
        max_units
        price
        production_time
        __typename
      }
      visibleFor
      filterColors
      providers
      massiveLayout
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.VehiclesByTypeQueryVariables,
  APITypes.VehiclesByTypeQuery
>;
export const vehiclesByMaterial = /* GraphQL */ `query VehiclesByMaterial(
  $popMaterialId: ID!
  $id: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelVehicleFilterInput
  $limit: Int
  $nextToken: String
) {
  vehiclesByMaterial(
    popMaterialId: $popMaterialId
    id: $id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      isSustainable
      multiProvider
      itemName
      bestSeller
      name
      brand
      channel
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      description
      size
      materialDetail
      print
      finish
      packaging
      quantity
      unitPrice
      prototypePrice
      productionTime
      vehicleTypeId
      popMaterialId
      popCategoryId
      providerId
      isRfq
      historicCost
      historicTime
      contact
      providerName
      variantsUnits {
        min_units
        max_units
        price
        production_time
        __typename
      }
      visibleFor
      filterColors
      providers
      massiveLayout
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.VehiclesByMaterialQueryVariables,
  APITypes.VehiclesByMaterialQuery
>;
export const VehiclesbyChanel = /* GraphQL */ `query VehiclesbyChanel(
  $popMaterialId: ID!
  $channel: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelVehicleFilterInput
  $limit: Int
  $nextToken: String
) {
  VehiclesbyChanel(
    popMaterialId: $popMaterialId
    channel: $channel
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      isSustainable
      multiProvider
      itemName
      bestSeller
      name
      brand
      channel
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      description
      size
      materialDetail
      print
      finish
      packaging
      quantity
      unitPrice
      prototypePrice
      productionTime
      vehicleTypeId
      popMaterialId
      popCategoryId
      providerId
      isRfq
      historicCost
      historicTime
      contact
      providerName
      variantsUnits {
        min_units
        max_units
        price
        production_time
        __typename
      }
      visibleFor
      filterColors
      providers
      massiveLayout
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.VehiclesbyChanelQueryVariables,
  APITypes.VehiclesbyChanelQuery
>;
export const VehiclesbyPopCategory = /* GraphQL */ `query VehiclesbyPopCategory(
  $popCategoryId: ID!
  $id: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelVehicleFilterInput
  $limit: Int
  $nextToken: String
) {
  VehiclesbyPopCategory(
    popCategoryId: $popCategoryId
    id: $id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      isSustainable
      multiProvider
      itemName
      bestSeller
      name
      brand
      channel
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      description
      size
      materialDetail
      print
      finish
      packaging
      quantity
      unitPrice
      prototypePrice
      productionTime
      vehicleTypeId
      popMaterialId
      popCategoryId
      providerId
      isRfq
      historicCost
      historicTime
      contact
      providerName
      variantsUnits {
        min_units
        max_units
        price
        production_time
        __typename
      }
      visibleFor
      filterColors
      providers
      massiveLayout
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.VehiclesbyPopCategoryQueryVariables,
  APITypes.VehiclesbyPopCategoryQuery
>;
export const vehiclesByProvider = /* GraphQL */ `query VehiclesByProvider(
  $providerId: ID!
  $id: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelVehicleFilterInput
  $limit: Int
  $nextToken: String
) {
  vehiclesByProvider(
    providerId: $providerId
    id: $id
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      isSustainable
      multiProvider
      itemName
      bestSeller
      name
      brand
      channel
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      description
      size
      materialDetail
      print
      finish
      packaging
      quantity
      unitPrice
      prototypePrice
      productionTime
      vehicleTypeId
      popMaterialId
      popCategoryId
      providerId
      isRfq
      historicCost
      historicTime
      contact
      providerName
      variantsUnits {
        min_units
        max_units
        price
        production_time
        __typename
      }
      visibleFor
      filterColors
      providers
      massiveLayout
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.VehiclesByProviderQueryVariables,
  APITypes.VehiclesByProviderQuery
>;
export const VehiclesByMassiveLayout = /* GraphQL */ `query VehiclesByMassiveLayout(
  $massiveLayout: String!
  $created: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelVehicleFilterInput
  $limit: Int
  $nextToken: String
) {
  VehiclesByMassiveLayout(
    massiveLayout: $massiveLayout
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      isSustainable
      multiProvider
      itemName
      bestSeller
      name
      brand
      channel
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      description
      size
      materialDetail
      print
      finish
      packaging
      quantity
      unitPrice
      prototypePrice
      productionTime
      vehicleTypeId
      popMaterialId
      popCategoryId
      providerId
      isRfq
      historicCost
      historicTime
      contact
      providerName
      variantsUnits {
        min_units
        max_units
        price
        production_time
        __typename
      }
      visibleFor
      filterColors
      providers
      massiveLayout
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.VehiclesByMassiveLayoutQueryVariables,
  APITypes.VehiclesByMassiveLayoutQuery
>;
export const popOrderByCreatedAt = /* GraphQL */ `query PopOrderByCreatedAt(
  $estatus: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPopOrderFilterInput
  $limit: Int
  $nextToken: String
) {
  popOrderByCreatedAt(
    estatus: $estatus
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PopOrderByCreatedAtQueryVariables,
  APITypes.PopOrderByCreatedAtQuery
>;
export const popOrdersByCreatedAt = /* GraphQL */ `query PopOrdersByCreatedAt(
  $active: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPopOrderFilterInput
  $limit: Int
  $nextToken: String
) {
  popOrdersByCreatedAt(
    active: $active
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PopOrdersByCreatedAtQueryVariables,
  APITypes.PopOrdersByCreatedAtQuery
>;
export const PopOrdersByBuyer = /* GraphQL */ `query PopOrdersByBuyer(
  $orderCreatorId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPopOrderFilterInput
  $limit: Int
  $nextToken: String
) {
  PopOrdersByBuyer(
    orderCreatorId: $orderCreatorId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PopOrdersByBuyerQueryVariables,
  APITypes.PopOrdersByBuyerQuery
>;
export const popOrdersByClient = /* GraphQL */ `query PopOrdersByClient(
  $clientId: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPopOrderFilterInput
  $limit: Int
  $nextToken: String
) {
  popOrdersByClient(
    clientId: $clientId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      estatus
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      orderId
      requirement
      budget
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      subtotal
      total
      isCoupa
      sentToCoupa
      coupaOrder
      active
      vehicles {
        items {
          id
          orderId
          vehicleId
          providerId
          unitPrice
          prototypePrice
          quantity
          approved
          hasQrCode
          sampleTestDate
          sampleTestDateApproved
          prototypeDate
          prototypeDateApproved
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      gr
      orderCreatorId
      providers {
        items {
          id
          orderId
          providerId
          deliveryDateRequested
          grRequested
          invoiceUploaded
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      prequoteApproved
      quoteApproved
      prototypeApproved
      samplesDocsUploaded
      samplesApproved
      auditRequired
      drivePath
      auditDocsUploaded
      deliveryDateRequested
      deliveryDate
      deliveryCode
      deliveryFilesUploaded
      deliveryDocsApproved
      grUploaded
      grApproved
      grCode
      qrCode
      brandfactoryCheck
      step
      prototype
      dateKickoff
      paymentDate
      currentProcess
      currentSubprocess
      clientId
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PopOrdersByClientQueryVariables,
  APITypes.PopOrdersByClientQuery
>;
export const PopOrderVehiclesByPopOrder = /* GraphQL */ `query PopOrderVehiclesByPopOrder(
  $orderId: ID!
  $vehicleId: ModelIDKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPopOrderVehicleFilterInput
  $limit: Int
  $nextToken: String
) {
  PopOrderVehiclesByPopOrder(
    orderId: $orderId
    vehicleId: $vehicleId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      orderId
      vehicleId
      providerId
      unitPrice
      prototypePrice
      quantity
      approved
      hasQrCode
      vehicle {
        id
        status
        isSustainable
        multiProvider
        itemName
        bestSeller
        name
        brand
        channel
        images {
          key
          url
          color
          palette
          colorName
          __typename
        }
        description
        size
        materialDetail
        print
        finish
        packaging
        quantity
        unitPrice
        prototypePrice
        productionTime
        vehicleTypeId
        popMaterialId
        popCategoryId
        providerId
        isRfq
        historicCost
        historicTime
        contact
        providerName
        variantsUnits {
          min_units
          max_units
          price
          production_time
          __typename
        }
        visibleFor
        filterColors
        providers
        massiveLayout
        created
        updated
        createdAt
        updatedAt
        __typename
      }
      order {
        id
        estatus
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        orderId
        requirement
        budget
        delivery_addresses {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        delivery_cost
        delivery_time
        files {
          created
          creator_id
          status
          statusFile
          name
          provider_id
          product_id
          tracking_code
          gr_code
          coupa_order
          description
          __typename
        }
        contact {
          name
          tel
          __typename
        }
        subtotal
        total
        isCoupa
        sentToCoupa
        coupaOrder
        active
        vehicles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        orderAgents {
          name
          email
          phoneNumber
          user_id
          __typename
        }
        orderAgentIds
        buyerInfo {
          name
          email
          authorized
          __typename
        }
        buyersInfo {
          name
          email
          authorized
          __typename
        }
        gr
        orderCreatorId
        providers {
          nextToken
          __typename
        }
        creator {
          name
          email
          user_id
          __typename
        }
        prequoteApproved
        quoteApproved
        prototypeApproved
        samplesDocsUploaded
        samplesApproved
        auditRequired
        drivePath
        auditDocsUploaded
        deliveryDateRequested
        deliveryDate
        deliveryCode
        deliveryFilesUploaded
        deliveryDocsApproved
        grUploaded
        grApproved
        grCode
        qrCode
        brandfactoryCheck
        step
        prototype
        dateKickoff
        paymentDate
        currentProcess
        currentSubprocess
        clientId
        __typename
      }
      provider {
        id
        isApproved
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comertial_name
        bussiness_name {
          rfc
          name
          __typename
        }
        idProcter
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        biography
        constancia {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comprobante {
          key
          url
          color
          palette
          colorName
          __typename
        }
        experience
        pros
        cons
        cte_rating {
          name
          rating
          __typename
        }
        shopping_rating {
          name
          rating
          __typename
        }
        video
        tags
        money_filter_c
        money_filter_d
        users
        bank
        account
        clabe
        cuenta_correo
        edocuenta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        ife {
          key
          url
          color
          palette
          colorName
          __typename
        }
        poderes {
          key
          url
          color
          palette
          colorName
          __typename
        }
        acta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        isProvider
        sameAddress
        isPop
        isPrinted
        hasLogistic
        created
        updated
        addFiles {
          key
          url
          sign
          status
          __typename
        }
        signFiles {
          key
          url
          sign
          status
          __typename
        }
        representante_legal
        escritura_constitucion
        notario_a
        constituido_down_edo
        rrpp
        isPremium
        isTrustProvider
        createdAt
        updatedAt
        __typename
      }
      sampleTestDate
      sampleTestDateApproved
      prototypeDate
      prototypeDateApproved
      logs {
        product_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PopOrderVehiclesByPopOrderQueryVariables,
  APITypes.PopOrderVehiclesByPopOrderQuery
>;
export const popOrderProviderByPopOrder = /* GraphQL */ `query PopOrderProviderByPopOrder(
  $orderId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPopOrderProviderFilterInput
  $limit: Int
  $nextToken: String
) {
  popOrderProviderByPopOrder(
    orderId: $orderId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      orderId
      providerId
      deliveryDateRequested
      grRequested
      invoiceUploaded
      order {
        id
        estatus
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        orderId
        requirement
        budget
        delivery_addresses {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        delivery_cost
        delivery_time
        files {
          created
          creator_id
          status
          statusFile
          name
          provider_id
          product_id
          tracking_code
          gr_code
          coupa_order
          description
          __typename
        }
        contact {
          name
          tel
          __typename
        }
        subtotal
        total
        isCoupa
        sentToCoupa
        coupaOrder
        active
        vehicles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        orderAgents {
          name
          email
          phoneNumber
          user_id
          __typename
        }
        orderAgentIds
        buyerInfo {
          name
          email
          authorized
          __typename
        }
        buyersInfo {
          name
          email
          authorized
          __typename
        }
        gr
        orderCreatorId
        providers {
          nextToken
          __typename
        }
        creator {
          name
          email
          user_id
          __typename
        }
        prequoteApproved
        quoteApproved
        prototypeApproved
        samplesDocsUploaded
        samplesApproved
        auditRequired
        drivePath
        auditDocsUploaded
        deliveryDateRequested
        deliveryDate
        deliveryCode
        deliveryFilesUploaded
        deliveryDocsApproved
        grUploaded
        grApproved
        grCode
        qrCode
        brandfactoryCheck
        step
        prototype
        dateKickoff
        paymentDate
        currentProcess
        currentSubprocess
        clientId
        __typename
      }
      provider {
        id
        isApproved
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comertial_name
        bussiness_name {
          rfc
          name
          __typename
        }
        idProcter
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        biography
        constancia {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comprobante {
          key
          url
          color
          palette
          colorName
          __typename
        }
        experience
        pros
        cons
        cte_rating {
          name
          rating
          __typename
        }
        shopping_rating {
          name
          rating
          __typename
        }
        video
        tags
        money_filter_c
        money_filter_d
        users
        bank
        account
        clabe
        cuenta_correo
        edocuenta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        ife {
          key
          url
          color
          palette
          colorName
          __typename
        }
        poderes {
          key
          url
          color
          palette
          colorName
          __typename
        }
        acta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        isProvider
        sameAddress
        isPop
        isPrinted
        hasLogistic
        created
        updated
        addFiles {
          key
          url
          sign
          status
          __typename
        }
        signFiles {
          key
          url
          sign
          status
          __typename
        }
        representante_legal
        escritura_constitucion
        notario_a
        constituido_down_edo
        rrpp
        isPremium
        isTrustProvider
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PopOrderProviderByPopOrderQueryVariables,
  APITypes.PopOrderProviderByPopOrderQuery
>;
export const popOrderProviderByCreatedAt = /* GraphQL */ `query PopOrderProviderByCreatedAt(
  $providerId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPopOrderProviderFilterInput
  $limit: Int
  $nextToken: String
) {
  popOrderProviderByCreatedAt(
    providerId: $providerId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      orderId
      providerId
      deliveryDateRequested
      grRequested
      invoiceUploaded
      order {
        id
        estatus
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        orderId
        requirement
        budget
        delivery_addresses {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        delivery_cost
        delivery_time
        files {
          created
          creator_id
          status
          statusFile
          name
          provider_id
          product_id
          tracking_code
          gr_code
          coupa_order
          description
          __typename
        }
        contact {
          name
          tel
          __typename
        }
        subtotal
        total
        isCoupa
        sentToCoupa
        coupaOrder
        active
        vehicles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        orderAgents {
          name
          email
          phoneNumber
          user_id
          __typename
        }
        orderAgentIds
        buyerInfo {
          name
          email
          authorized
          __typename
        }
        buyersInfo {
          name
          email
          authorized
          __typename
        }
        gr
        orderCreatorId
        providers {
          nextToken
          __typename
        }
        creator {
          name
          email
          user_id
          __typename
        }
        prequoteApproved
        quoteApproved
        prototypeApproved
        samplesDocsUploaded
        samplesApproved
        auditRequired
        drivePath
        auditDocsUploaded
        deliveryDateRequested
        deliveryDate
        deliveryCode
        deliveryFilesUploaded
        deliveryDocsApproved
        grUploaded
        grApproved
        grCode
        qrCode
        brandfactoryCheck
        step
        prototype
        dateKickoff
        paymentDate
        currentProcess
        currentSubprocess
        clientId
        __typename
      }
      provider {
        id
        isApproved
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comertial_name
        bussiness_name {
          rfc
          name
          __typename
        }
        idProcter
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        biography
        constancia {
          key
          url
          color
          palette
          colorName
          __typename
        }
        comprobante {
          key
          url
          color
          palette
          colorName
          __typename
        }
        experience
        pros
        cons
        cte_rating {
          name
          rating
          __typename
        }
        shopping_rating {
          name
          rating
          __typename
        }
        video
        tags
        money_filter_c
        money_filter_d
        users
        bank
        account
        clabe
        cuenta_correo
        edocuenta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        ife {
          key
          url
          color
          palette
          colorName
          __typename
        }
        poderes {
          key
          url
          color
          palette
          colorName
          __typename
        }
        acta {
          key
          url
          color
          palette
          colorName
          __typename
        }
        isProvider
        sameAddress
        isPop
        isPrinted
        hasLogistic
        created
        updated
        addFiles {
          key
          url
          sign
          status
          __typename
        }
        signFiles {
          key
          url
          sign
          status
          __typename
        }
        representante_legal
        escritura_constitucion
        notario_a
        constituido_down_edo
        rrpp
        isPremium
        isTrustProvider
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PopOrderProviderByCreatedAtQueryVariables,
  APITypes.PopOrderProviderByCreatedAtQuery
>;
export const PopOrderLogsByOrder = /* GraphQL */ `query PopOrderLogsByOrder(
  $orderId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPopOrderLogFilterInput
  $limit: Int
  $nextToken: String
) {
  PopOrderLogsByOrder(
    orderId: $orderId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      orderId
      creatorId
      order {
        id
        estatus
        comments {
          text
          created
          creator_id
          creator_name
          creator_email
          isSourceDataUser
          replyTo
          role
          text_request
          nameUserReply
          jiraKey
          __typename
        }
        orderId
        requirement
        budget
        delivery_addresses {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        delivery_cost
        delivery_time
        files {
          created
          creator_id
          status
          statusFile
          name
          provider_id
          product_id
          tracking_code
          gr_code
          coupa_order
          description
          __typename
        }
        contact {
          name
          tel
          __typename
        }
        subtotal
        total
        isCoupa
        sentToCoupa
        coupaOrder
        active
        vehicles {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        orderAgents {
          name
          email
          phoneNumber
          user_id
          __typename
        }
        orderAgentIds
        buyerInfo {
          name
          email
          authorized
          __typename
        }
        buyersInfo {
          name
          email
          authorized
          __typename
        }
        gr
        orderCreatorId
        providers {
          nextToken
          __typename
        }
        creator {
          name
          email
          user_id
          __typename
        }
        prequoteApproved
        quoteApproved
        prototypeApproved
        samplesDocsUploaded
        samplesApproved
        auditRequired
        drivePath
        auditDocsUploaded
        deliveryDateRequested
        deliveryDate
        deliveryCode
        deliveryFilesUploaded
        deliveryDocsApproved
        grUploaded
        grApproved
        grCode
        qrCode
        brandfactoryCheck
        step
        prototype
        dateKickoff
        paymentDate
        currentProcess
        currentSubprocess
        clientId
        __typename
      }
      createdAt
      text
      orderStatus
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PopOrderLogsByOrderQueryVariables,
  APITypes.PopOrderLogsByOrderQuery
>;
export const listRfqsPopByCreated = /* GraphQL */ `query ListRfqsPopByCreated(
  $estatus: String!
  $created: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRfqPopFilterInput
  $limit: Int
  $nextToken: String
) {
  listRfqsPopByCreated(
    estatus: $estatus
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      nombre
      requerimiento
      vehicleTypeId
      popMaterialId
      vehiclesRfq {
        vehicleTypeId
        popMaterialId
        name
        description
        pieces
        createdId
        __typename
      }
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      proposals {
        items {
          id
          provider_id
          price
          created
          validity_days
          description
          updated
          proposalsPopRfqId
          prototypePrice
          hidden
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      providers {
        idProvider
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      popOrderId
      orderId
      estatus
      start_time
      delivery_time
      saving
      saving_percentage
      saving_real
      budget
      hasQrCode
      created
      createdAt
      updated
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRfqsPopByCreatedQueryVariables,
  APITypes.ListRfqsPopByCreatedQuery
>;
export const ListPopRfqsByClient = /* GraphQL */ `query ListPopRfqsByClient(
  $estatus: String!
  $clientId: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRfqPopFilterInput
  $limit: Int
  $nextToken: String
) {
  ListPopRfqsByClient(
    estatus: $estatus
    clientId: $clientId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      nombre
      requerimiento
      vehicleTypeId
      popMaterialId
      vehiclesRfq {
        vehicleTypeId
        popMaterialId
        name
        description
        pieces
        createdId
        __typename
      }
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      proposals {
        items {
          id
          provider_id
          price
          created
          validity_days
          description
          updated
          proposalsPopRfqId
          prototypePrice
          hidden
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      providers {
        idProvider
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      popOrderId
      orderId
      estatus
      start_time
      delivery_time
      saving
      saving_percentage
      saving_real
      budget
      hasQrCode
      created
      createdAt
      updated
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPopRfqsByClientQueryVariables,
  APITypes.ListPopRfqsByClientQuery
>;
export const ListRfqsPopByCreator = /* GraphQL */ `query ListRfqsPopByCreator(
  $estatus: String!
  $created: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRfqPopFilterInput
  $limit: Int
  $nextToken: String
) {
  ListRfqsPopByCreator(
    estatus: $estatus
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      nombre
      requerimiento
      vehicleTypeId
      popMaterialId
      vehiclesRfq {
        vehicleTypeId
        popMaterialId
        name
        description
        pieces
        createdId
        __typename
      }
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      cantidad
      limit_time
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      proposals {
        items {
          id
          provider_id
          price
          created
          validity_days
          description
          updated
          proposalsPopRfqId
          prototypePrice
          hidden
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      providers {
        idProvider
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      popOrderId
      orderId
      estatus
      start_time
      delivery_time
      saving
      saving_percentage
      saving_real
      budget
      hasQrCode
      created
      createdAt
      updated
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRfqsPopByCreatorQueryVariables,
  APITypes.ListRfqsPopByCreatorQuery
>;
export const GetUsersBrandByClientId = /* GraphQL */ `query GetUsersBrandByClientId(
  $clientId: ID!
  $status: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelUsersBrandsFilterInput
  $limit: Int
  $nextToken: String
) {
  GetUsersBrandByClientId(
    clientId: $clientId
    status: $status
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      description
      logo {
        key
        url
        color
        palette
        colorName
        __typename
      }
      status
      clientId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GetUsersBrandByClientIdQueryVariables,
  APITypes.GetUsersBrandByClientIdQuery
>;
export const LogsPUserByUserEmail = /* GraphQL */ `query LogsPUserByUserEmail(
  $user: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLogsPUsersFilterInput
  $limit: Int
  $nextToken: String
) {
  LogsPUserByUserEmail(
    user: $user
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      user
      keyword
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LogsPUserByUserEmailQueryVariables,
  APITypes.LogsPUserByUserEmailQuery
>;
export const ClipPaymentsByPremiumOrder = /* GraphQL */ `query ClipPaymentsByPremiumOrder(
  $orderId: ID!
  $created: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelClipPaymentFilterInput
  $limit: Int
  $nextToken: String
) {
  ClipPaymentsByPremiumOrder(
    orderId: $orderId
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      requestsCount
      payment_request_id
      purchase_description
      orderId
      clientId
      userId
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ClipPaymentsByPremiumOrderQueryVariables,
  APITypes.ClipPaymentsByPremiumOrderQuery
>;
export const ClipPaymentsByClient = /* GraphQL */ `query ClipPaymentsByClient(
  $clientId: ID!
  $created: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelClipPaymentFilterInput
  $limit: Int
  $nextToken: String
) {
  ClipPaymentsByClient(
    clientId: $clientId
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      requestsCount
      payment_request_id
      purchase_description
      orderId
      clientId
      userId
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ClipPaymentsByClientQueryVariables,
  APITypes.ClipPaymentsByClientQuery
>;
export const ClipPaymentsByUser = /* GraphQL */ `query ClipPaymentsByUser(
  $userId: ID!
  $created: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelClipPaymentFilterInput
  $limit: Int
  $nextToken: String
) {
  ClipPaymentsByUser(
    userId: $userId
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      requestsCount
      payment_request_id
      purchase_description
      orderId
      clientId
      userId
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ClipPaymentsByUserQueryVariables,
  APITypes.ClipPaymentsByUserQuery
>;
export const OrderProcessesByType = /* GraphQL */ `query OrderProcessesByType(
  $type: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelOrderProcessFilterInput
  $limit: Int
  $nextToken: String
) {
  OrderProcessesByType(
    type: $type
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      status
      tcdPayment
      name
      duration
      descripcion
      position
      responsible
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      cards {
        id
        name
        permissions {
          idCard
          rol
          thirdContent
          visible
          __typename
        }
        __typename
      }
      subprocesses {
        items {
          id
          type
          status
          name
          position
          descripcion
          action
          processId
          clientId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      clientId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OrderProcessesByTypeQueryVariables,
  APITypes.OrderProcessesByTypeQuery
>;
export const OrderProcessByClient = /* GraphQL */ `query OrderProcessByClient(
  $clientId: ID!
  $position: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelOrderProcessFilterInput
  $limit: Int
  $nextToken: String
) {
  OrderProcessByClient(
    clientId: $clientId
    position: $position
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      status
      tcdPayment
      name
      duration
      descripcion
      position
      responsible
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      cards {
        id
        name
        permissions {
          idCard
          rol
          thirdContent
          visible
          __typename
        }
        __typename
      }
      subprocesses {
        items {
          id
          type
          status
          name
          position
          descripcion
          action
          processId
          clientId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      clientId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OrderProcessByClientQueryVariables,
  APITypes.OrderProcessByClientQuery
>;
export const OrderSubprocessesByType = /* GraphQL */ `query OrderSubprocessesByType(
  $type: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelOrderSubprocessFilterInput
  $limit: Int
  $nextToken: String
) {
  OrderSubprocessesByType(
    type: $type
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      status
      name
      position
      descripcion
      action
      process {
        id
        type
        status
        tcdPayment
        name
        duration
        descripcion
        position
        responsible
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        cards {
          id
          name
          __typename
        }
        subprocesses {
          nextToken
          __typename
        }
        clientId
        createdAt
        updatedAt
        __typename
      }
      processId
      clientId
      messages {
        description
        rol
        visibleAction
        __typename
      }
      notifications {
        group
        enabledEmail
        enabledPopUp
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OrderSubprocessesByTypeQueryVariables,
  APITypes.OrderSubprocessesByTypeQuery
>;
export const OrderSubprocessesByProcess = /* GraphQL */ `query OrderSubprocessesByProcess(
  $processId: ID!
  $position: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelOrderSubprocessFilterInput
  $limit: Int
  $nextToken: String
) {
  OrderSubprocessesByProcess(
    processId: $processId
    position: $position
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      status
      name
      position
      descripcion
      action
      process {
        id
        type
        status
        tcdPayment
        name
        duration
        descripcion
        position
        responsible
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        cards {
          id
          name
          __typename
        }
        subprocesses {
          nextToken
          __typename
        }
        clientId
        createdAt
        updatedAt
        __typename
      }
      processId
      clientId
      messages {
        description
        rol
        visibleAction
        __typename
      }
      notifications {
        group
        enabledEmail
        enabledPopUp
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OrderSubprocessesByProcessQueryVariables,
  APITypes.OrderSubprocessesByProcessQuery
>;
export const OrderSubprocessesByClient = /* GraphQL */ `query OrderSubprocessesByClient(
  $clientId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelOrderSubprocessFilterInput
  $limit: Int
  $nextToken: String
) {
  OrderSubprocessesByClient(
    clientId: $clientId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      status
      name
      position
      descripcion
      action
      process {
        id
        type
        status
        tcdPayment
        name
        duration
        descripcion
        position
        responsible
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        cards {
          id
          name
          __typename
        }
        subprocesses {
          nextToken
          __typename
        }
        clientId
        createdAt
        updatedAt
        __typename
      }
      processId
      clientId
      messages {
        description
        rol
        visibleAction
        __typename
      }
      notifications {
        group
        enabledEmail
        enabledPopUp
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OrderSubprocessesByClientQueryVariables,
  APITypes.OrderSubprocessesByClientQuery
>;
export const PremiumOrdersByBuyer = /* GraphQL */ `query PremiumOrdersByBuyer(
  $orderCreatorId: String!
  $orderId: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPremiumOrderFilterInput
  $limit: Int
  $nextToken: String
) {
  PremiumOrdersByBuyer(
    orderCreatorId: $orderCreatorId
    orderId: $orderId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      requirement
      bank_reference
      hasVat
      billingData {
        name
        rfc
        regimen
        cfdi_use
        cp
        email
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        __typename
      }
      orderId
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      logs {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        role
        __typename
      }
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_fee
      delivery_discount
      delivery_time
      delivery_date
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      taxSituationFile {
        key
        url
        color
        palette
        colorName
        __typename
      }
      clipUrl
      clipStatus
      listProviders {
        provider_id
        order_id
        payment_date
        gr_code
        order_confirmation
        invoice
        invoiceRequested
        uploadedGr
        uploadedBill
        delivered
        deliveredFormat
        __typename
      }
      providers {
        items {
          id
          provider_id
          clientId
          orderId
          orderProvidersPremiumOrderId
          payment_date
          gr_code
          invoice
          invoiceRequested
          uploadedGr
          uploadedBill
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      listsProducts {
        product_id
        provider_id
        index
        print
        printPrice
        product_name
        description
        category
        unspsc
        price
        originalPrice
        sample_requested
        sample_request
        sample_authorize
        sample_authorized
        quality_requested
        quality_request
        uploadedSample
        quantity
        isExternal
        variant {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        sku
        qualityForm {
          initiativeDescription
          targetUser
          retailBrandName
          itemCategory
          itemPicture
          originCountry
          quantityPerCountryOfDist
          initiativeDates
          isPartOfAnMSOCustOrSpecPack
          incluesClientLogo
          isAReorderWithinTwelveMonths
          isReorder
          PGPLContactName
          ulTracking
          PLContactName
          contactEmailAddress
          PGPurchaseOrderNumber
          EBBSorSupplierProvidedProjectNumber
          vendorCompanyName
          vendorContactName
          vendorEmailAddress
          vendorJobTitle
          vendorTelephone
          vendorMailingAddress
          vendorCity
          vendorState
          vendorCountry
          vendorPC
          physicalItemDescription
          SampleOrMaterialComponentSubmitted
          toWhom
          descriptionOfItemPackagingAndArtwork
          regulatoryAndLegislativeProductCertification
          dateFinalApprovalRequestedSubmittedToPG
          DateOfDeclarationOfConformity
          dateOfApprovalExpirationOfPremiumItem
          itemClasification
          PGRepresentativeMarketingDesign
          PGProjectLeaderRequestor
          PGRestrictedItemsLocalPGLegal
          PGLocalCategoryGM
          PGLocalCategoryJoanAbbinanteNissenNotPowered
          idProduct
          pathDocument
          __typename
        }
        fee
        increment
        discount
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        sellMode
        kitPieces
        __typename
      }
      cotizationsList {
        id
        created
        createdBy
        products {
          product_id
          provider_id
          index
          print
          printPrice
          product_name
          description
          category
          unspsc
          price
          originalPrice
          sample_requested
          sample_request
          sample_authorize
          sample_authorized
          quality_requested
          quality_request
          uploadedSample
          quantity
          isExternal
          sku
          fee
          increment
          discount
          sellMode
          kitPieces
          __typename
        }
        __typename
      }
      orderCreatorId
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      invoiceContact {
        name
        email
        authorized
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      premiumOrderClientId
      client {
        id
        status
        business_name
        comertial_name
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        buyerInfo {
          name
          email
          authorized
          __typename
        }
        buyersInfo {
          name
          email
          authorized
          __typename
        }
        biography
        plan
        fee
        increment
        mercadoFee
        mercadoIncrement
        popFee
        popIncrement
        printedFee
        printedIncrement
        users
        restrictedUsers
        nonRestrictedUsers
        regions
        providers
        popProviders
        printedProviders
        logisticFrequency
        agents {
          id
          name
          email
          phoneNumber
          __typename
        }
        administrators {
          id
          name
          email
          phoneNumber
          __typename
        }
        signDocument {
          url
          enabled
          __typename
        }
        legal_representative
        legal_representative_email
        legal_representative_address
        tcdUsers
        billingUsers {
          id
          name
          email
          phoneNumber
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      userBrandId
      userBrand {
        id
        name
        description
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        clientId
        createdAt
        updatedAt
        __typename
      }
      subtotal
      fee
      printedPrice
      total
      discountAmount
      syncWithCrm
      crmIssueKey
      sentToAlendum
      alendumProjectId
      syncWithFms
      fmsInvoiceId
      syncWithWms
      wmsProjectId
      isCoupa
      sentToCoupa
      isRfq
      requireSamples
      requestedSamples
      approvedSamples
      authorizedQA
      active
      currentProcess
      currentSubprocess
      processes {
        id
        name
        descripcion
        duration
        position
        responsible
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        madeBy
        madeAt
        cards {
          id
          name
          __typename
        }
        subprocesses {
          id
          name
          position
          descripcion
          action
          process
          madeBy
          madeAt
          __typename
        }
        __typename
      }
      updatedAt
      created
      updated
      logistic {
        premiumOrderId
        tracking_number
        destiny_latitude
        destiny_longitude
        status
        status_activity
        status_description
        origin_latitude
        origin_longitude
        carrier
        clave_sat
        customer_delivery_start_date
        customer_email
        customer_external_number
        customer_first_name
        customer_last_name
        customer_mobile_number
        customer_postcode
        customer_settlement
        customer_street
        descripcion_sat
        peligroso
        primary_client
        purchase_order_number
        shipping_method
        shipping_option
        created
        __typename
      }
      createdAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PremiumOrdersByBuyerQueryVariables,
  APITypes.PremiumOrdersByBuyerQuery
>;
export const PremiumOrdersByClient = /* GraphQL */ `query PremiumOrdersByClient(
  $premiumOrderClientId: ID!
  $orderId: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPremiumOrderFilterInput
  $limit: Int
  $nextToken: String
) {
  PremiumOrdersByClient(
    premiumOrderClientId: $premiumOrderClientId
    orderId: $orderId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      requirement
      bank_reference
      hasVat
      billingData {
        name
        rfc
        regimen
        cfdi_use
        cp
        email
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        __typename
      }
      orderId
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      logs {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        role
        __typename
      }
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_fee
      delivery_discount
      delivery_time
      delivery_date
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      taxSituationFile {
        key
        url
        color
        palette
        colorName
        __typename
      }
      clipUrl
      clipStatus
      listProviders {
        provider_id
        order_id
        payment_date
        gr_code
        order_confirmation
        invoice
        invoiceRequested
        uploadedGr
        uploadedBill
        delivered
        deliveredFormat
        __typename
      }
      providers {
        items {
          id
          provider_id
          clientId
          orderId
          orderProvidersPremiumOrderId
          payment_date
          gr_code
          invoice
          invoiceRequested
          uploadedGr
          uploadedBill
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      listsProducts {
        product_id
        provider_id
        index
        print
        printPrice
        product_name
        description
        category
        unspsc
        price
        originalPrice
        sample_requested
        sample_request
        sample_authorize
        sample_authorized
        quality_requested
        quality_request
        uploadedSample
        quantity
        isExternal
        variant {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        sku
        qualityForm {
          initiativeDescription
          targetUser
          retailBrandName
          itemCategory
          itemPicture
          originCountry
          quantityPerCountryOfDist
          initiativeDates
          isPartOfAnMSOCustOrSpecPack
          incluesClientLogo
          isAReorderWithinTwelveMonths
          isReorder
          PGPLContactName
          ulTracking
          PLContactName
          contactEmailAddress
          PGPurchaseOrderNumber
          EBBSorSupplierProvidedProjectNumber
          vendorCompanyName
          vendorContactName
          vendorEmailAddress
          vendorJobTitle
          vendorTelephone
          vendorMailingAddress
          vendorCity
          vendorState
          vendorCountry
          vendorPC
          physicalItemDescription
          SampleOrMaterialComponentSubmitted
          toWhom
          descriptionOfItemPackagingAndArtwork
          regulatoryAndLegislativeProductCertification
          dateFinalApprovalRequestedSubmittedToPG
          DateOfDeclarationOfConformity
          dateOfApprovalExpirationOfPremiumItem
          itemClasification
          PGRepresentativeMarketingDesign
          PGProjectLeaderRequestor
          PGRestrictedItemsLocalPGLegal
          PGLocalCategoryGM
          PGLocalCategoryJoanAbbinanteNissenNotPowered
          idProduct
          pathDocument
          __typename
        }
        fee
        increment
        discount
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        sellMode
        kitPieces
        __typename
      }
      cotizationsList {
        id
        created
        createdBy
        products {
          product_id
          provider_id
          index
          print
          printPrice
          product_name
          description
          category
          unspsc
          price
          originalPrice
          sample_requested
          sample_request
          sample_authorize
          sample_authorized
          quality_requested
          quality_request
          uploadedSample
          quantity
          isExternal
          sku
          fee
          increment
          discount
          sellMode
          kitPieces
          __typename
        }
        __typename
      }
      orderCreatorId
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      invoiceContact {
        name
        email
        authorized
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      premiumOrderClientId
      client {
        id
        status
        business_name
        comertial_name
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        buyerInfo {
          name
          email
          authorized
          __typename
        }
        buyersInfo {
          name
          email
          authorized
          __typename
        }
        biography
        plan
        fee
        increment
        mercadoFee
        mercadoIncrement
        popFee
        popIncrement
        printedFee
        printedIncrement
        users
        restrictedUsers
        nonRestrictedUsers
        regions
        providers
        popProviders
        printedProviders
        logisticFrequency
        agents {
          id
          name
          email
          phoneNumber
          __typename
        }
        administrators {
          id
          name
          email
          phoneNumber
          __typename
        }
        signDocument {
          url
          enabled
          __typename
        }
        legal_representative
        legal_representative_email
        legal_representative_address
        tcdUsers
        billingUsers {
          id
          name
          email
          phoneNumber
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      userBrandId
      userBrand {
        id
        name
        description
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        clientId
        createdAt
        updatedAt
        __typename
      }
      subtotal
      fee
      printedPrice
      total
      discountAmount
      syncWithCrm
      crmIssueKey
      sentToAlendum
      alendumProjectId
      syncWithFms
      fmsInvoiceId
      syncWithWms
      wmsProjectId
      isCoupa
      sentToCoupa
      isRfq
      requireSamples
      requestedSamples
      approvedSamples
      authorizedQA
      active
      currentProcess
      currentSubprocess
      processes {
        id
        name
        descripcion
        duration
        position
        responsible
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        madeBy
        madeAt
        cards {
          id
          name
          __typename
        }
        subprocesses {
          id
          name
          position
          descripcion
          action
          process
          madeBy
          madeAt
          __typename
        }
        __typename
      }
      updatedAt
      created
      updated
      logistic {
        premiumOrderId
        tracking_number
        destiny_latitude
        destiny_longitude
        status
        status_activity
        status_description
        origin_latitude
        origin_longitude
        carrier
        clave_sat
        customer_delivery_start_date
        customer_email
        customer_external_number
        customer_first_name
        customer_last_name
        customer_mobile_number
        customer_postcode
        customer_settlement
        customer_street
        descripcion_sat
        peligroso
        primary_client
        purchase_order_number
        shipping_method
        shipping_option
        created
        __typename
      }
      createdAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PremiumOrdersByClientQueryVariables,
  APITypes.PremiumOrdersByClientQuery
>;
export const PremiumOrdersByUserBrand = /* GraphQL */ `query PremiumOrdersByUserBrand(
  $userBrandId: ID!
  $orderId: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPremiumOrderFilterInput
  $limit: Int
  $nextToken: String
) {
  PremiumOrdersByUserBrand(
    userBrandId: $userBrandId
    orderId: $orderId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      requirement
      bank_reference
      hasVat
      billingData {
        name
        rfc
        regimen
        cfdi_use
        cp
        email
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        __typename
      }
      orderId
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      logs {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        role
        __typename
      }
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_fee
      delivery_discount
      delivery_time
      delivery_date
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      taxSituationFile {
        key
        url
        color
        palette
        colorName
        __typename
      }
      clipUrl
      clipStatus
      listProviders {
        provider_id
        order_id
        payment_date
        gr_code
        order_confirmation
        invoice
        invoiceRequested
        uploadedGr
        uploadedBill
        delivered
        deliveredFormat
        __typename
      }
      providers {
        items {
          id
          provider_id
          clientId
          orderId
          orderProvidersPremiumOrderId
          payment_date
          gr_code
          invoice
          invoiceRequested
          uploadedGr
          uploadedBill
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      listsProducts {
        product_id
        provider_id
        index
        print
        printPrice
        product_name
        description
        category
        unspsc
        price
        originalPrice
        sample_requested
        sample_request
        sample_authorize
        sample_authorized
        quality_requested
        quality_request
        uploadedSample
        quantity
        isExternal
        variant {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        sku
        qualityForm {
          initiativeDescription
          targetUser
          retailBrandName
          itemCategory
          itemPicture
          originCountry
          quantityPerCountryOfDist
          initiativeDates
          isPartOfAnMSOCustOrSpecPack
          incluesClientLogo
          isAReorderWithinTwelveMonths
          isReorder
          PGPLContactName
          ulTracking
          PLContactName
          contactEmailAddress
          PGPurchaseOrderNumber
          EBBSorSupplierProvidedProjectNumber
          vendorCompanyName
          vendorContactName
          vendorEmailAddress
          vendorJobTitle
          vendorTelephone
          vendorMailingAddress
          vendorCity
          vendorState
          vendorCountry
          vendorPC
          physicalItemDescription
          SampleOrMaterialComponentSubmitted
          toWhom
          descriptionOfItemPackagingAndArtwork
          regulatoryAndLegislativeProductCertification
          dateFinalApprovalRequestedSubmittedToPG
          DateOfDeclarationOfConformity
          dateOfApprovalExpirationOfPremiumItem
          itemClasification
          PGRepresentativeMarketingDesign
          PGProjectLeaderRequestor
          PGRestrictedItemsLocalPGLegal
          PGLocalCategoryGM
          PGLocalCategoryJoanAbbinanteNissenNotPowered
          idProduct
          pathDocument
          __typename
        }
        fee
        increment
        discount
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        sellMode
        kitPieces
        __typename
      }
      cotizationsList {
        id
        created
        createdBy
        products {
          product_id
          provider_id
          index
          print
          printPrice
          product_name
          description
          category
          unspsc
          price
          originalPrice
          sample_requested
          sample_request
          sample_authorize
          sample_authorized
          quality_requested
          quality_request
          uploadedSample
          quantity
          isExternal
          sku
          fee
          increment
          discount
          sellMode
          kitPieces
          __typename
        }
        __typename
      }
      orderCreatorId
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      invoiceContact {
        name
        email
        authorized
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      premiumOrderClientId
      client {
        id
        status
        business_name
        comertial_name
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        buyerInfo {
          name
          email
          authorized
          __typename
        }
        buyersInfo {
          name
          email
          authorized
          __typename
        }
        biography
        plan
        fee
        increment
        mercadoFee
        mercadoIncrement
        popFee
        popIncrement
        printedFee
        printedIncrement
        users
        restrictedUsers
        nonRestrictedUsers
        regions
        providers
        popProviders
        printedProviders
        logisticFrequency
        agents {
          id
          name
          email
          phoneNumber
          __typename
        }
        administrators {
          id
          name
          email
          phoneNumber
          __typename
        }
        signDocument {
          url
          enabled
          __typename
        }
        legal_representative
        legal_representative_email
        legal_representative_address
        tcdUsers
        billingUsers {
          id
          name
          email
          phoneNumber
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      userBrandId
      userBrand {
        id
        name
        description
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        clientId
        createdAt
        updatedAt
        __typename
      }
      subtotal
      fee
      printedPrice
      total
      discountAmount
      syncWithCrm
      crmIssueKey
      sentToAlendum
      alendumProjectId
      syncWithFms
      fmsInvoiceId
      syncWithWms
      wmsProjectId
      isCoupa
      sentToCoupa
      isRfq
      requireSamples
      requestedSamples
      approvedSamples
      authorizedQA
      active
      currentProcess
      currentSubprocess
      processes {
        id
        name
        descripcion
        duration
        position
        responsible
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        madeBy
        madeAt
        cards {
          id
          name
          __typename
        }
        subprocesses {
          id
          name
          position
          descripcion
          action
          process
          madeBy
          madeAt
          __typename
        }
        __typename
      }
      updatedAt
      created
      updated
      logistic {
        premiumOrderId
        tracking_number
        destiny_latitude
        destiny_longitude
        status
        status_activity
        status_description
        origin_latitude
        origin_longitude
        carrier
        clave_sat
        customer_delivery_start_date
        customer_email
        customer_external_number
        customer_first_name
        customer_last_name
        customer_mobile_number
        customer_postcode
        customer_settlement
        customer_street
        descripcion_sat
        peligroso
        primary_client
        purchase_order_number
        shipping_method
        shipping_option
        created
        __typename
      }
      createdAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PremiumOrdersByUserBrandQueryVariables,
  APITypes.PremiumOrdersByUserBrandQuery
>;
export const PremiumOrdersByOrderId = /* GraphQL */ `query PremiumOrdersByOrderId(
  $active: String!
  $orderId: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPremiumOrderFilterInput
  $limit: Int
  $nextToken: String
) {
  PremiumOrdersByOrderId(
    active: $active
    orderId: $orderId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      requirement
      bank_reference
      hasVat
      billingData {
        name
        rfc
        regimen
        cfdi_use
        cp
        email
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        __typename
      }
      orderId
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      logs {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        role
        __typename
      }
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_fee
      delivery_discount
      delivery_time
      delivery_date
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      taxSituationFile {
        key
        url
        color
        palette
        colorName
        __typename
      }
      clipUrl
      clipStatus
      listProviders {
        provider_id
        order_id
        payment_date
        gr_code
        order_confirmation
        invoice
        invoiceRequested
        uploadedGr
        uploadedBill
        delivered
        deliveredFormat
        __typename
      }
      providers {
        items {
          id
          provider_id
          clientId
          orderId
          orderProvidersPremiumOrderId
          payment_date
          gr_code
          invoice
          invoiceRequested
          uploadedGr
          uploadedBill
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      listsProducts {
        product_id
        provider_id
        index
        print
        printPrice
        product_name
        description
        category
        unspsc
        price
        originalPrice
        sample_requested
        sample_request
        sample_authorize
        sample_authorized
        quality_requested
        quality_request
        uploadedSample
        quantity
        isExternal
        variant {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        sku
        qualityForm {
          initiativeDescription
          targetUser
          retailBrandName
          itemCategory
          itemPicture
          originCountry
          quantityPerCountryOfDist
          initiativeDates
          isPartOfAnMSOCustOrSpecPack
          incluesClientLogo
          isAReorderWithinTwelveMonths
          isReorder
          PGPLContactName
          ulTracking
          PLContactName
          contactEmailAddress
          PGPurchaseOrderNumber
          EBBSorSupplierProvidedProjectNumber
          vendorCompanyName
          vendorContactName
          vendorEmailAddress
          vendorJobTitle
          vendorTelephone
          vendorMailingAddress
          vendorCity
          vendorState
          vendorCountry
          vendorPC
          physicalItemDescription
          SampleOrMaterialComponentSubmitted
          toWhom
          descriptionOfItemPackagingAndArtwork
          regulatoryAndLegislativeProductCertification
          dateFinalApprovalRequestedSubmittedToPG
          DateOfDeclarationOfConformity
          dateOfApprovalExpirationOfPremiumItem
          itemClasification
          PGRepresentativeMarketingDesign
          PGProjectLeaderRequestor
          PGRestrictedItemsLocalPGLegal
          PGLocalCategoryGM
          PGLocalCategoryJoanAbbinanteNissenNotPowered
          idProduct
          pathDocument
          __typename
        }
        fee
        increment
        discount
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        sellMode
        kitPieces
        __typename
      }
      cotizationsList {
        id
        created
        createdBy
        products {
          product_id
          provider_id
          index
          print
          printPrice
          product_name
          description
          category
          unspsc
          price
          originalPrice
          sample_requested
          sample_request
          sample_authorize
          sample_authorized
          quality_requested
          quality_request
          uploadedSample
          quantity
          isExternal
          sku
          fee
          increment
          discount
          sellMode
          kitPieces
          __typename
        }
        __typename
      }
      orderCreatorId
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      invoiceContact {
        name
        email
        authorized
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      premiumOrderClientId
      client {
        id
        status
        business_name
        comertial_name
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        grayLogo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        contact {
          first_name
          last_name
          email
          mobile_phone
          local_phone
          __typename
        }
        address {
          street
          outdoor_number
          inside_number
          colony
          delegation
          state
          city
          postal_code
          chain
          name
          description
          __typename
        }
        buyerInfo {
          name
          email
          authorized
          __typename
        }
        buyersInfo {
          name
          email
          authorized
          __typename
        }
        biography
        plan
        fee
        increment
        mercadoFee
        mercadoIncrement
        popFee
        popIncrement
        printedFee
        printedIncrement
        users
        restrictedUsers
        nonRestrictedUsers
        regions
        providers
        popProviders
        printedProviders
        logisticFrequency
        agents {
          id
          name
          email
          phoneNumber
          __typename
        }
        administrators {
          id
          name
          email
          phoneNumber
          __typename
        }
        signDocument {
          url
          enabled
          __typename
        }
        legal_representative
        legal_representative_email
        legal_representative_address
        tcdUsers
        billingUsers {
          id
          name
          email
          phoneNumber
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      userBrandId
      userBrand {
        id
        name
        description
        logo {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        clientId
        createdAt
        updatedAt
        __typename
      }
      subtotal
      fee
      printedPrice
      total
      discountAmount
      syncWithCrm
      crmIssueKey
      sentToAlendum
      alendumProjectId
      syncWithFms
      fmsInvoiceId
      syncWithWms
      wmsProjectId
      isCoupa
      sentToCoupa
      isRfq
      requireSamples
      requestedSamples
      approvedSamples
      authorizedQA
      active
      currentProcess
      currentSubprocess
      processes {
        id
        name
        descripcion
        duration
        position
        responsible
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        madeBy
        madeAt
        cards {
          id
          name
          __typename
        }
        subprocesses {
          id
          name
          position
          descripcion
          action
          process
          madeBy
          madeAt
          __typename
        }
        __typename
      }
      updatedAt
      created
      updated
      logistic {
        premiumOrderId
        tracking_number
        destiny_latitude
        destiny_longitude
        status
        status_activity
        status_description
        origin_latitude
        origin_longitude
        carrier
        clave_sat
        customer_delivery_start_date
        customer_email
        customer_external_number
        customer_first_name
        customer_last_name
        customer_mobile_number
        customer_postcode
        customer_settlement
        customer_street
        descripcion_sat
        peligroso
        primary_client
        purchase_order_number
        shipping_method
        shipping_option
        created
        __typename
      }
      createdAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PremiumOrdersByOrderIdQueryVariables,
  APITypes.PremiumOrdersByOrderIdQuery
>;
export const PrintedSubcategoriesByCategory = /* GraphQL */ `query PrintedSubcategoriesByCategory(
  $printedCategoryId: ID!
  $name: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPrintedSubcategoryFilterInput
  $limit: Int
  $nextToken: String
) {
  PrintedSubcategoriesByCategory(
    printedCategoryId: $printedCategoryId
    name: $name
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      printedCategoryId
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      parent {
        id
        name
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        route
        clientDiscounts {
          index
          clientId
          minUnits
          maxUnits
          percent
          __typename
        }
        clientFeeIncrements {
          index
          clientId
          percent
          __typename
        }
        clientIncrements {
          index
          clientId
          percent
          __typename
        }
        printedSubcategories {
          nextToken
          __typename
        }
        printedProducts {
          nextToken
          __typename
        }
        created
        visibleFor
        region
        createdAt
        updatedAt
        __typename
      }
      created
      printedProducts {
        items {
          id
          status
          position
          name
          width
          height
          price
          long_description
          short_description
          creator
          providerId
          finalDimensions
          pagesNumber
          finishes
          inksFourByCero
          inksFourByFour
          paperKind
          grammage
          hasBarniz
          hasRebase
          orientation
          specialInstructions
          PrintedSubcategoryId
          printedCategoryId
          created
          visibleFor
          filterColors
          regions
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      visibleFor
      region
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PrintedSubcategoriesByCategoryQueryVariables,
  APITypes.PrintedSubcategoriesByCategoryQuery
>;
export const PrintedProductsBySubcategoryPosition = /* GraphQL */ `query PrintedProductsBySubcategoryPosition(
  $PrintedSubcategoryId: ID!
  $position: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPrintedProductsFilterInput
  $limit: Int
  $nextToken: String
) {
  PrintedProductsBySubcategoryPosition(
    PrintedSubcategoryId: $PrintedSubcategoryId
    position: $position
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      position
      name
      width
      height
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      price
      long_description
      short_description
      creator
      providerId
      finalDimensions
      pagesNumber
      finishes
      inksFourByCero
      inksFourByFour
      paperKind
      grammage
      hasBarniz
      hasRebase
      orientation
      specialInstructions
      PrintedSubcategoryId
      printedCategoryId
      created
      variants {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      visibleFor
      filterColors
      regions
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PrintedProductsBySubcategoryPositionQueryVariables,
  APITypes.PrintedProductsBySubcategoryPositionQuery
>;
export const PrintedProductsBySubcategoryCreated = /* GraphQL */ `query PrintedProductsBySubcategoryCreated(
  $PrintedSubcategoryId: ID!
  $created: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPrintedProductsFilterInput
  $limit: Int
  $nextToken: String
) {
  PrintedProductsBySubcategoryCreated(
    PrintedSubcategoryId: $PrintedSubcategoryId
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      position
      name
      width
      height
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      price
      long_description
      short_description
      creator
      providerId
      finalDimensions
      pagesNumber
      finishes
      inksFourByCero
      inksFourByFour
      paperKind
      grammage
      hasBarniz
      hasRebase
      orientation
      specialInstructions
      PrintedSubcategoryId
      printedCategoryId
      created
      variants {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      visibleFor
      filterColors
      regions
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PrintedProductsBySubcategoryCreatedQueryVariables,
  APITypes.PrintedProductsBySubcategoryCreatedQuery
>;
export const PrintedProductsByCategoryPosition = /* GraphQL */ `query PrintedProductsByCategoryPosition(
  $printedCategoryId: ID!
  $position: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPrintedProductsFilterInput
  $limit: Int
  $nextToken: String
) {
  PrintedProductsByCategoryPosition(
    printedCategoryId: $printedCategoryId
    position: $position
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      position
      name
      width
      height
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      price
      long_description
      short_description
      creator
      providerId
      finalDimensions
      pagesNumber
      finishes
      inksFourByCero
      inksFourByFour
      paperKind
      grammage
      hasBarniz
      hasRebase
      orientation
      specialInstructions
      PrintedSubcategoryId
      printedCategoryId
      created
      variants {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      visibleFor
      filterColors
      regions
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PrintedProductsByCategoryPositionQueryVariables,
  APITypes.PrintedProductsByCategoryPositionQuery
>;
export const PrintedProductsByCategoryCreated = /* GraphQL */ `query PrintedProductsByCategoryCreated(
  $printedCategoryId: ID!
  $created: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPrintedProductsFilterInput
  $limit: Int
  $nextToken: String
) {
  PrintedProductsByCategoryCreated(
    printedCategoryId: $printedCategoryId
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      position
      name
      width
      height
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      price
      long_description
      short_description
      creator
      providerId
      finalDimensions
      pagesNumber
      finishes
      inksFourByCero
      inksFourByFour
      paperKind
      grammage
      hasBarniz
      hasRebase
      orientation
      specialInstructions
      PrintedSubcategoryId
      printedCategoryId
      created
      variants {
        sku
        name
        description
        colors
        filterColors
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        stock_available
        price
        size
        logoType
        __typename
      }
      visibleFor
      filterColors
      regions
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PrintedProductsByCategoryCreatedQueryVariables,
  APITypes.PrintedProductsByCategoryCreatedQuery
>;
export const ListRfqsPrintedByCreated = /* GraphQL */ `query ListRfqsPrintedByCreated(
  $estatus: String!
  $created: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPrintedRfqFilterInput
  $limit: Int
  $nextToken: String
) {
  ListRfqsPrintedByCreated(
    estatus: $estatus
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      nombre
      requerimiento
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      limit_time
      proposals {
        items {
          id
          provider_id
          price
          validity_days
          description
          created
          updated
          hidden
          printedProposalRfqId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      creator
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      clientId
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      estatus
      printedOrderId
      start_time
      delivery_time
      created
      saving
      saving_percentage
      saving_real
      createdAt
      updatedAt
      updated
      providers {
        idProvider
        __typename
      }
      printedProductsRfq {
        name
        description
        pieces
        createdId
        __typename
      }
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRfqsPrintedByCreatedQueryVariables,
  APITypes.ListRfqsPrintedByCreatedQuery
>;
export const ListPrintedProductosRfqPrice = /* GraphQL */ `query ListPrintedProductosRfqPrice(
  $category_id: ID!
  $price: ModelFloatKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPrintedProductoRfqFilterInput
  $limit: Int
  $nextToken: String
) {
  ListPrintedProductosRfqPrice(
    category_id: $category_id
    price: $price
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      description
      category_id
      provider_id
      price
      category
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      estatus
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPrintedProductosRfqPriceQueryVariables,
  APITypes.ListPrintedProductosRfqPriceQuery
>;
export const PrintedOrdersByBuyer = /* GraphQL */ `query PrintedOrdersByBuyer(
  $orderCreatorId: String!
  $orderId: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPrintedOrderFilterInput
  $limit: Int
  $nextToken: String
) {
  PrintedOrdersByBuyer(
    orderCreatorId: $orderCreatorId
    orderId: $orderId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      orderId
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      listProviders {
        provider_id
        order_id
        payment_date
        gr_code
        order_confirmation
        invoice
        invoiceRequested
        uploadedGr
        uploadedBill
        delivered
        deliveredFormat
        __typename
      }
      listProvidersKey
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      listPrintedProducts {
        product_id
        provider_id
        visible
        product_name
        price
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        sample_requested
        sample_request
        uploadedSample
        quantity
        variant {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        __typename
      }
      cotizationsList {
        id
        created
        createdBy
        products {
          product_id
          provider_id
          visible
          product_name
          price
          sample_requested
          sample_request
          uploadedSample
          quantity
          __typename
        }
        __typename
      }
      orderCreatorId
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      printedOrderClientId
      subtotal
      total
      isCoupa
      sentToCoupa
      isRfq
      status
      currentProcess
      currentSubprocess
      updatedAt
      created
      updated
      createdAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PrintedOrdersByBuyerQueryVariables,
  APITypes.PrintedOrdersByBuyerQuery
>;
export const PrintedOrdersByClient = /* GraphQL */ `query PrintedOrdersByClient(
  $printedOrderClientId: ID!
  $orderId: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPrintedOrderFilterInput
  $limit: Int
  $nextToken: String
) {
  PrintedOrdersByClient(
    printedOrderClientId: $printedOrderClientId
    orderId: $orderId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      orderId
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      listProviders {
        provider_id
        order_id
        payment_date
        gr_code
        order_confirmation
        invoice
        invoiceRequested
        uploadedGr
        uploadedBill
        delivered
        deliveredFormat
        __typename
      }
      listProvidersKey
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      listPrintedProducts {
        product_id
        provider_id
        visible
        product_name
        price
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        sample_requested
        sample_request
        uploadedSample
        quantity
        variant {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        __typename
      }
      cotizationsList {
        id
        created
        createdBy
        products {
          product_id
          provider_id
          visible
          product_name
          price
          sample_requested
          sample_request
          uploadedSample
          quantity
          __typename
        }
        __typename
      }
      orderCreatorId
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      printedOrderClientId
      subtotal
      total
      isCoupa
      sentToCoupa
      isRfq
      status
      currentProcess
      currentSubprocess
      updatedAt
      created
      updated
      createdAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PrintedOrdersByClientQueryVariables,
  APITypes.PrintedOrdersByClientQuery
>;
export const PrintedOrdersByOrderId = /* GraphQL */ `query PrintedOrdersByOrderId(
  $status: String!
  $orderId: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPrintedOrderFilterInput
  $limit: Int
  $nextToken: String
) {
  PrintedOrdersByOrderId(
    status: $status
    orderId: $orderId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      orderId
      comments {
        text
        created
        creator_id
        creator_name
        creator_email
        isSourceDataUser
        creator_avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        company {
          comertial_name
          id
          __typename
        }
        replyTo
        role
        text_request
        nameUserReply
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        jiraKey
        __typename
      }
      delivery_addresses {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      delivery_cost
      delivery_time
      files {
        created
        creator_id
        file {
          key
          url
          color
          palette
          colorName
          __typename
        }
        status
        statusFile
        name
        provider_id
        product_id
        tracking_code
        gr_code
        coupa_order
        description
        __typename
      }
      listProviders {
        provider_id
        order_id
        payment_date
        gr_code
        order_confirmation
        invoice
        invoiceRequested
        uploadedGr
        uploadedBill
        delivered
        deliveredFormat
        __typename
      }
      listProvidersKey
      orderAgents {
        name
        email
        phoneNumber
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      orderAgentIds
      listPrintedProducts {
        product_id
        provider_id
        visible
        product_name
        price
        image {
          key
          url
          color
          palette
          colorName
          __typename
        }
        sample_requested
        sample_request
        uploadedSample
        quantity
        variant {
          sku
          name
          description
          colors
          filterColors
          stock_available
          price
          size
          logoType
          __typename
        }
        logs {
          product_id
          user_id
          text
          created
          __typename
        }
        __typename
      }
      cotizationsList {
        id
        created
        createdBy
        products {
          product_id
          provider_id
          visible
          product_name
          price
          sample_requested
          sample_request
          uploadedSample
          quantity
          __typename
        }
        __typename
      }
      orderCreatorId
      creator {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      buyerInfo {
        name
        email
        authorized
        __typename
      }
      buyersInfo {
        name
        email
        authorized
        __typename
      }
      contact {
        name
        tel
        __typename
      }
      printedOrderClientId
      subtotal
      total
      isCoupa
      sentToCoupa
      isRfq
      status
      currentProcess
      currentSubprocess
      updatedAt
      created
      updated
      createdAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PrintedOrdersByOrderIdQueryVariables,
  APITypes.PrintedOrdersByOrderIdQuery
>;
export const PrintedOrdersByProvider = /* GraphQL */ `query PrintedOrdersByProvider(
  $provider_id: String!
  $orderId: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPrintedOrderProvidersFilterInput
  $limit: Int
  $nextToken: String
) {
  PrintedOrdersByProvider(
    provider_id: $provider_id
    orderId: $orderId
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      provider_id
      orderId
      printedOrderProvidersPrintedOrderId
      payment_date
      gr_code
      invoice
      invoiceRequested
      uploadedGr
      uploadedBill
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PrintedOrdersByProviderQueryVariables,
  APITypes.PrintedOrdersByProviderQuery
>;
export const BuyerContactsClientByCompanyId = /* GraphQL */ `query BuyerContactsClientByCompanyId(
  $companyId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelBuyerContactClientFilterInput
  $limit: Int
  $nextToken: String
) {
  BuyerContactsClientByCompanyId(
    companyId: $companyId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      companyId
      status
      defaultContact
      name
      email
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.BuyerContactsClientByCompanyIdQueryVariables,
  APITypes.BuyerContactsClientByCompanyIdQuery
>;
export const AutomobilesEmailsByCompanyId = /* GraphQL */ `query AutomobilesEmailsByCompanyId(
  $companyId: ID!
  $created: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelAutomobilesEmailsFilterInput
  $limit: Int
  $nextToken: String
) {
  AutomobilesEmailsByCompanyId(
    companyId: $companyId
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      companyId
      status
      name
      email
      created
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.AutomobilesEmailsByCompanyIdQueryVariables,
  APITypes.AutomobilesEmailsByCompanyIdQuery
>;
export const QAEmailsByCompanyId = /* GraphQL */ `query QAEmailsByCompanyId(
  $companyId: ID!
  $created: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelQAEmailsFilterInput
  $limit: Int
  $nextToken: String
) {
  QAEmailsByCompanyId(
    companyId: $companyId
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      companyId
      status
      name
      email
      created
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.QAEmailsByCompanyIdQueryVariables,
  APITypes.QAEmailsByCompanyIdQuery
>;
export const OrderPopAdminEmailsByCompanyId = /* GraphQL */ `query OrderPopAdminEmailsByCompanyId(
  $companyId: ID!
  $created: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelOrderPopAdminEmailsFilterInput
  $limit: Int
  $nextToken: String
) {
  OrderPopAdminEmailsByCompanyId(
    companyId: $companyId
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      companyId
      status
      name
      email
      created
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OrderPopAdminEmailsByCompanyIdQueryVariables,
  APITypes.OrderPopAdminEmailsByCompanyIdQuery
>;
export const OrderPopCheckoutEmailsByCompanyId = /* GraphQL */ `query OrderPopCheckoutEmailsByCompanyId(
  $companyId: ID!
  $created: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelOrderPopCheckoutEmailsFilterInput
  $limit: Int
  $nextToken: String
) {
  OrderPopCheckoutEmailsByCompanyId(
    companyId: $companyId
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      companyId
      status
      name
      email
      created
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.OrderPopCheckoutEmailsByCompanyIdQueryVariables,
  APITypes.OrderPopCheckoutEmailsByCompanyIdQuery
>;
export const GREmailsByCompanyId = /* GraphQL */ `query GREmailsByCompanyId(
  $companyId: ID!
  $created: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelGREmailsFilterInput
  $limit: Int
  $nextToken: String
) {
  GREmailsByCompanyId(
    companyId: $companyId
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      companyId
      status
      name
      email
      created
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.GREmailsByCompanyIdQueryVariables,
  APITypes.GREmailsByCompanyIdQuery
>;
export const DefaultAddressByCompanyId = /* GraphQL */ `query DefaultAddressByCompanyId(
  $companyId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelDefaultAddressFilterInput
  $limit: Int
  $nextToken: String
) {
  DefaultAddressByCompanyId(
    companyId: $companyId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      companyId
      userId
      status
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DefaultAddressByCompanyIdQueryVariables,
  APITypes.DefaultAddressByCompanyIdQuery
>;
export const DefaultAddressByUserId = /* GraphQL */ `query DefaultAddressByUserId(
  $userId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelDefaultAddressFilterInput
  $limit: Int
  $nextToken: String
) {
  DefaultAddressByUserId(
    userId: $userId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      companyId
      userId
      status
      address {
        street
        outdoor_number
        inside_number
        colony
        delegation
        state
        city
        postal_code
        chain
        name
        description
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DefaultAddressByUserIdQueryVariables,
  APITypes.DefaultAddressByUserIdQuery
>;
export const DefaultDeliveryContactByCompanyId = /* GraphQL */ `query DefaultDeliveryContactByCompanyId(
  $companyId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelDefaultDeliveryContactFilterInput
  $limit: Int
  $nextToken: String
) {
  DefaultDeliveryContactByCompanyId(
    companyId: $companyId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      companyId
      userId
      status
      name
      phoneNumber
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DefaultDeliveryContactByCompanyIdQueryVariables,
  APITypes.DefaultDeliveryContactByCompanyIdQuery
>;
export const DefaultDeliveryContactByUserId = /* GraphQL */ `query DefaultDeliveryContactByUserId(
  $userId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelDefaultDeliveryContactFilterInput
  $limit: Int
  $nextToken: String
) {
  DefaultDeliveryContactByUserId(
    userId: $userId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      companyId
      userId
      status
      name
      phoneNumber
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.DefaultDeliveryContactByUserIdQueryVariables,
  APITypes.DefaultDeliveryContactByUserIdQuery
>;
export const PopCategoriesByMaterial = /* GraphQL */ `query PopCategoriesByMaterial(
  $materialId: ID!
  $created: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPopCategoriesFilterInput
  $limit: Int
  $nextToken: String
) {
  PopCategoriesByMaterial(
    materialId: $materialId
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      materialId
      name
      visibleFor
      clientDiscounts {
        index
        clientId
        minUnits
        maxUnits
        percent
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      created
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PopCategoriesByMaterialQueryVariables,
  APITypes.PopCategoriesByMaterialQuery
>;
export const ListRfpsByCreated = /* GraphQL */ `query ListRfpsByCreated(
  $status: String!
  $created: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRfpFilterInput
  $limit: Int
  $nextToken: String
) {
  ListRfpsByCreated(
    status: $status
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      clientId
      status
      name
      nombre
      requerimiento
      estatus
      descripcion
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      url
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      proposals {
        items {
          id
          provider_id
          price
          name
          description
          validity_days
          created
          updated
          multipleProducts
          hidden
          rfpProposalsRfpId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      limit_time
      creator
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      providers {
        idProvider
        __typename
      }
      start_time
      delivery_time
      saving
      saving_percentage
      saving_real
      created
      createdAt
      updated
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRfpsByCreatedQueryVariables,
  APITypes.ListRfpsByCreatedQuery
>;
export const ListRfpsByCreatedAt = /* GraphQL */ `query ListRfpsByCreatedAt(
  $estatus: String!
  $created: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelRfpFilterInput
  $limit: Int
  $nextToken: String
) {
  ListRfpsByCreatedAt(
    estatus: $estatus
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      clientId
      status
      name
      nombre
      requerimiento
      estatus
      descripcion
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      chat {
        role
        is_reply
        to_user_id
        user_id
        text
        files {
          key
          url
          color
          palette
          colorName
          __typename
        }
        created
        __typename
      }
      url
      creatorInfo {
        name
        email
        avatar {
          key
          url
          color
          palette
          colorName
          __typename
        }
        user_id
        __typename
      }
      proposals {
        items {
          id
          provider_id
          price
          name
          description
          validity_days
          created
          updated
          multipleProducts
          hidden
          rfpProposalsRfpId
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      compras {
        first_name
        last_name
        email
        mobile_phone
        local_phone
        __typename
      }
      limit_time
      creator
      winner {
        proveeedor_id
        date
        __typename
      }
      logs {
        creatorId
        description
        date
        status
        provider_id
        __typename
      }
      providers {
        idProvider
        __typename
      }
      start_time
      delivery_time
      saving
      saving_percentage
      saving_real
      created
      createdAt
      updated
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListRfpsByCreatedAtQueryVariables,
  APITypes.ListRfpsByCreatedAtQuery
>;
export const ListLogsByProduct = /* GraphQL */ `query ListLogsByProduct(
  $productId: ID!
  $created: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLogProductFilterInput
  $limit: Int
  $nextToken: String
) {
  ListLogsByProduct(
    productId: $productId
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      creator
      created
      productId
      description
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLogsByProductQueryVariables,
  APITypes.ListLogsByProductQuery
>;
export const ListLogsByRfq = /* GraphQL */ `query ListLogsByRfq(
  $rfqId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLogRfqFilterInput
  $limit: Int
  $nextToken: String
) {
  ListLogsByRfq(
    rfqId: $rfqId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      creator
      rfqId
      description
      provider_id
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLogsByRfqQueryVariables,
  APITypes.ListLogsByRfqQuery
>;
export const ListLogsByProvider = /* GraphQL */ `query ListLogsByProvider(
  $provider_id: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLogRfqFilterInput
  $limit: Int
  $nextToken: String
) {
  ListLogsByProvider(
    provider_id: $provider_id
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      creator
      rfqId
      description
      provider_id
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLogsByProviderQueryVariables,
  APITypes.ListLogsByProviderQuery
>;
export const listLogsByProductLabel = /* GraphQL */ `query ListLogsByProductLabel(
  $productLabelId: ID!
  $created: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLogProductLabelFilterInput
  $limit: Int
  $nextToken: String
) {
  listLogsByProductLabel(
    productLabelId: $productLabelId
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      creator
      created
      productLabelId
      description
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLogsByProductLabelQueryVariables,
  APITypes.ListLogsByProductLabelQuery
>;
export const ListLogsByAuto = /* GraphQL */ `query ListLogsByAuto(
  $id_auto: ID!
  $created: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLogGanadorAutoFilterInput
  $limit: Int
  $nextToken: String
) {
  ListLogsByAuto(
    id_auto: $id_auto
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      id_auto
      id_user
      fecha_rifa
      email
      nombre
      a_paterno
      a_materno
      status_buyer
      date_buyer
      winner
      refused
      since
      process_buyer
      reactive
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListLogsByAutoQueryVariables,
  APITypes.ListLogsByAutoQuery
>;
export const LogsGanadorAutoByUser = /* GraphQL */ `query LogsGanadorAutoByUser(
  $id_user: ID!
  $created: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelLogGanadorAutoFilterInput
  $limit: Int
  $nextToken: String
) {
  LogsGanadorAutoByUser(
    id_user: $id_user
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      id_auto
      id_user
      fecha_rifa
      email
      nombre
      a_paterno
      a_materno
      status_buyer
      date_buyer
      winner
      refused
      since
      process_buyer
      reactive
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.LogsGanadorAutoByUserQueryVariables,
  APITypes.LogsGanadorAutoByUserQuery
>;
export const NotificationsByType = /* GraphQL */ `query NotificationsByType(
  $type: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  NotificationsByType(
    type: $type
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      remember
      stared
      important
      status
      isChat
      creatorName
      creatorEmail
      creatorRole
      creatorId
      receipentName
      receipentRole
      receipentEmail
      receipentId
      showPopUp
      sendEmail
      title
      subtitle
      description
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      path
      idParent
      createdAt
      seenAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotificationsByTypeQueryVariables,
  APITypes.NotificationsByTypeQuery
>;
export const NotificationsByRemember = /* GraphQL */ `query NotificationsByRemember(
  $remember: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  NotificationsByRemember(
    remember: $remember
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      remember
      stared
      important
      status
      isChat
      creatorName
      creatorEmail
      creatorRole
      creatorId
      receipentName
      receipentRole
      receipentEmail
      receipentId
      showPopUp
      sendEmail
      title
      subtitle
      description
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      path
      idParent
      createdAt
      seenAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotificationsByRememberQueryVariables,
  APITypes.NotificationsByRememberQuery
>;
export const NotificationsByStared = /* GraphQL */ `query NotificationsByStared(
  $stared: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  NotificationsByStared(
    stared: $stared
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      remember
      stared
      important
      status
      isChat
      creatorName
      creatorEmail
      creatorRole
      creatorId
      receipentName
      receipentRole
      receipentEmail
      receipentId
      showPopUp
      sendEmail
      title
      subtitle
      description
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      path
      idParent
      createdAt
      seenAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotificationsByStaredQueryVariables,
  APITypes.NotificationsByStaredQuery
>;
export const NotificationsByImportant = /* GraphQL */ `query NotificationsByImportant(
  $important: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  NotificationsByImportant(
    important: $important
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      remember
      stared
      important
      status
      isChat
      creatorName
      creatorEmail
      creatorRole
      creatorId
      receipentName
      receipentRole
      receipentEmail
      receipentId
      showPopUp
      sendEmail
      title
      subtitle
      description
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      path
      idParent
      createdAt
      seenAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotificationsByImportantQueryVariables,
  APITypes.NotificationsByImportantQuery
>;
export const NotificationsByStatus = /* GraphQL */ `query NotificationsByStatus(
  $status: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  NotificationsByStatus(
    status: $status
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      remember
      stared
      important
      status
      isChat
      creatorName
      creatorEmail
      creatorRole
      creatorId
      receipentName
      receipentRole
      receipentEmail
      receipentId
      showPopUp
      sendEmail
      title
      subtitle
      description
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      path
      idParent
      createdAt
      seenAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotificationsByStatusQueryVariables,
  APITypes.NotificationsByStatusQuery
>;
export const NotificationsByChat = /* GraphQL */ `query NotificationsByChat(
  $isChat: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  NotificationsByChat(
    isChat: $isChat
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      remember
      stared
      important
      status
      isChat
      creatorName
      creatorEmail
      creatorRole
      creatorId
      receipentName
      receipentRole
      receipentEmail
      receipentId
      showPopUp
      sendEmail
      title
      subtitle
      description
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      path
      idParent
      createdAt
      seenAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotificationsByChatQueryVariables,
  APITypes.NotificationsByChatQuery
>;
export const NotificationsByReceipent = /* GraphQL */ `query NotificationsByReceipent(
  $receipentEmail: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  NotificationsByReceipent(
    receipentEmail: $receipentEmail
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      remember
      stared
      important
      status
      isChat
      creatorName
      creatorEmail
      creatorRole
      creatorId
      receipentName
      receipentRole
      receipentEmail
      receipentId
      showPopUp
      sendEmail
      title
      subtitle
      description
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      path
      idParent
      createdAt
      seenAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotificationsByReceipentQueryVariables,
  APITypes.NotificationsByReceipentQuery
>;
export const NotificationsByReceipentId = /* GraphQL */ `query NotificationsByReceipentId(
  $receipentId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  NotificationsByReceipentId(
    receipentId: $receipentId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      remember
      stared
      important
      status
      isChat
      creatorName
      creatorEmail
      creatorRole
      creatorId
      receipentName
      receipentRole
      receipentEmail
      receipentId
      showPopUp
      sendEmail
      title
      subtitle
      description
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      path
      idParent
      createdAt
      seenAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotificationsByReceipentIdQueryVariables,
  APITypes.NotificationsByReceipentIdQuery
>;
export const NotificationsBySubtitle = /* GraphQL */ `query NotificationsBySubtitle(
  $subtitle: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  NotificationsBySubtitle(
    subtitle: $subtitle
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      remember
      stared
      important
      status
      isChat
      creatorName
      creatorEmail
      creatorRole
      creatorId
      receipentName
      receipentRole
      receipentEmail
      receipentId
      showPopUp
      sendEmail
      title
      subtitle
      description
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      path
      idParent
      createdAt
      seenAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotificationsBySubtitleQueryVariables,
  APITypes.NotificationsBySubtitleQuery
>;
export const NotificationsByIdParent = /* GraphQL */ `query NotificationsByIdParent(
  $idParent: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelNotificationFilterInput
  $limit: Int
  $nextToken: String
) {
  NotificationsByIdParent(
    idParent: $idParent
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      remember
      stared
      important
      status
      isChat
      creatorName
      creatorEmail
      creatorRole
      creatorId
      receipentName
      receipentRole
      receipentEmail
      receipentId
      showPopUp
      sendEmail
      title
      subtitle
      description
      files {
        key
        url
        color
        palette
        colorName
        __typename
      }
      path
      idParent
      createdAt
      seenAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.NotificationsByIdParentQueryVariables,
  APITypes.NotificationsByIdParentQuery
>;
export const MercadoProductsByClient = /* GraphQL */ `query MercadoProductsByClient(
  $idClient: ID!
  $created: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelMercadoProductCategoryClientFilterInput
  $limit: Int
  $nextToken: String
) {
  MercadoProductsByClient(
    idClient: $idClient
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      idClient
      idMercadoCategory
      unrestrictedProducts
      restrictedProducts
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MercadoProductsByClientQueryVariables,
  APITypes.MercadoProductsByClientQuery
>;
export const MercadoProductsByCategory = /* GraphQL */ `query MercadoProductsByCategory(
  $idMercadoCategory: ID!
  $created: ModelIntKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelMercadoProductCategoryClientFilterInput
  $limit: Int
  $nextToken: String
) {
  MercadoProductsByCategory(
    idMercadoCategory: $idMercadoCategory
    created: $created
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      idClient
      idMercadoCategory
      unrestrictedProducts
      restrictedProducts
      created
      updated
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.MercadoProductsByCategoryQueryVariables,
  APITypes.MercadoProductsByCategoryQuery
>;
export const ListPrintLogosByClient = /* GraphQL */ `query ListPrintLogosByClient(
  $clientId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPrintLogosFilterInput
  $limit: Int
  $nextToken: String
) {
  ListPrintLogosByClient(
    clientId: $clientId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      creator
      description
      identifier
      clientId
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ListPrintLogosByClientQueryVariables,
  APITypes.ListPrintLogosByClientQuery
>;
export const PakmailCarriersByStatus = /* GraphQL */ `query PakmailCarriersByStatus(
  $status: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPakmailCarrierFilterInput
  $limit: Int
  $nextToken: String
) {
  PakmailCarriersByStatus(
    status: $status
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      identifier
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      visibleFor
      region
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PakmailCarriersByStatusQueryVariables,
  APITypes.PakmailCarriersByStatusQuery
>;
export const PakmailCarrierByIdentifier = /* GraphQL */ `query PakmailCarrierByIdentifier(
  $identifier: Int!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPakmailCarrierFilterInput
  $limit: Int
  $nextToken: String
) {
  PakmailCarrierByIdentifier(
    identifier: $identifier
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      identifier
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      visibleFor
      region
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PakmailCarrierByIdentifierQueryVariables,
  APITypes.PakmailCarrierByIdentifierQuery
>;
export const PakmailServicesByStatus = /* GraphQL */ `query PakmailServicesByStatus(
  $status: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPakmailServiceFilterInput
  $limit: Int
  $nextToken: String
) {
  PakmailServicesByStatus(
    status: $status
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      identifier
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      visibleFor
      region
      isNational
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PakmailServicesByStatusQueryVariables,
  APITypes.PakmailServicesByStatusQuery
>;
export const PakmailServicesByIdentifier = /* GraphQL */ `query PakmailServicesByIdentifier(
  $identifier: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPakmailServiceFilterInput
  $limit: Int
  $nextToken: String
) {
  PakmailServicesByIdentifier(
    identifier: $identifier
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      identifier
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      clientFeeIncrements {
        index
        clientId
        percent
        __typename
      }
      clientIncrements {
        index
        clientId
        percent
        __typename
      }
      visibleFor
      region
      isNational
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PakmailServicesByIdentifierQueryVariables,
  APITypes.PakmailServicesByIdentifierQuery
>;
export const PakmailShipmentStatusesByStatus = /* GraphQL */ `query PakmailShipmentStatusesByStatus(
  $status: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPakmailShipmentStatusFilterInput
  $limit: Int
  $nextToken: String
) {
  PakmailShipmentStatusesByStatus(
    status: $status
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      identifier
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      notifications {
        group
        enabledEmail
        enabledPopUp
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PakmailShipmentStatusesByStatusQueryVariables,
  APITypes.PakmailShipmentStatusesByStatusQuery
>;
export const PakmailShipmentStatusesByIdentifier = /* GraphQL */ `query PakmailShipmentStatusesByIdentifier(
  $identifier: Int!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPakmailShipmentStatusFilterInput
  $limit: Int
  $nextToken: String
) {
  PakmailShipmentStatusesByIdentifier(
    identifier: $identifier
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      identifier
      image {
        key
        url
        color
        palette
        colorName
        __typename
      }
      visibleFor
      notifications {
        group
        enabledEmail
        enabledPopUp
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PakmailShipmentStatusesByIdentifierQueryVariables,
  APITypes.PakmailShipmentStatusesByIdentifierQuery
>;
export const PakmailShipmentEventsByStatus = /* GraphQL */ `query PakmailShipmentEventsByStatus(
  $status: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPakmailShipmentEventFilterInput
  $limit: Int
  $nextToken: String
) {
  PakmailShipmentEventsByStatus(
    status: $status
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      identifier
      visibleFor
      color
      notifications {
        group
        enabledEmail
        enabledPopUp
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PakmailShipmentEventsByStatusQueryVariables,
  APITypes.PakmailShipmentEventsByStatusQuery
>;
export const PakmailShipmentEventsByIdentifier = /* GraphQL */ `query PakmailShipmentEventsByIdentifier(
  $identifier: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPakmailShipmentEventFilterInput
  $limit: Int
  $nextToken: String
) {
  PakmailShipmentEventsByIdentifier(
    identifier: $identifier
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      identifier
      visibleFor
      color
      notifications {
        group
        enabledEmail
        enabledPopUp
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PakmailShipmentEventsByIdentifierQueryVariables,
  APITypes.PakmailShipmentEventsByIdentifierQuery
>;
export const PakmailPickupStatusesByStatus = /* GraphQL */ `query PakmailPickupStatusesByStatus(
  $status: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPakmailPickupStatusFilterInput
  $limit: Int
  $nextToken: String
) {
  PakmailPickupStatusesByStatus(
    status: $status
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      identifier
      visibleFor
      notifications {
        group
        enabledEmail
        enabledPopUp
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PakmailPickupStatusesByStatusQueryVariables,
  APITypes.PakmailPickupStatusesByStatusQuery
>;
export const PakmailPickupStatusesByIdentifier = /* GraphQL */ `query PakmailPickupStatusesByIdentifier(
  $identifier: Int!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPakmailPickupStatusFilterInput
  $limit: Int
  $nextToken: String
) {
  PakmailPickupStatusesByIdentifier(
    identifier: $identifier
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      status
      identifier
      visibleFor
      notifications {
        group
        enabledEmail
        enabledPopUp
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PakmailPickupStatusesByIdentifierQueryVariables,
  APITypes.PakmailPickupStatusesByIdentifierQuery
>;
export const PremiumOrderLogisticGuidesByType = /* GraphQL */ `query PremiumOrderLogisticGuidesByType(
  $type: LogisticGuideType!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPremiumOrderLogisticGuideFilterInput
  $limit: Int
  $nextToken: String
) {
  PremiumOrderLogisticGuidesByType(
    type: $type
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      pakmailId
      premiumOrderId
      clientId
      creatorId
      originAddressId
      destinationAddressId
      originAddress
      destinationAddress
      products {
        indexProduct
        productId
        quantity
        unitWidth
        unitHeight
        unitDepth
        unitWeight
        __typename
      }
      price
      increment
      fee
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PremiumOrderLogisticGuidesByTypeQueryVariables,
  APITypes.PremiumOrderLogisticGuidesByTypeQuery
>;
export const PremiumOrderLogisticGuidesByPakmailId = /* GraphQL */ `query PremiumOrderLogisticGuidesByPakmailId(
  $pakmailId: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPremiumOrderLogisticGuideFilterInput
  $limit: Int
  $nextToken: String
) {
  PremiumOrderLogisticGuidesByPakmailId(
    pakmailId: $pakmailId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      pakmailId
      premiumOrderId
      clientId
      creatorId
      originAddressId
      destinationAddressId
      originAddress
      destinationAddress
      products {
        indexProduct
        productId
        quantity
        unitWidth
        unitHeight
        unitDepth
        unitWeight
        __typename
      }
      price
      increment
      fee
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PremiumOrderLogisticGuidesByPakmailIdQueryVariables,
  APITypes.PremiumOrderLogisticGuidesByPakmailIdQuery
>;
export const PremiumOrderLogisticGuidesByPremiumOrder = /* GraphQL */ `query PremiumOrderLogisticGuidesByPremiumOrder(
  $premiumOrderId: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPremiumOrderLogisticGuideFilterInput
  $limit: Int
  $nextToken: String
) {
  PremiumOrderLogisticGuidesByPremiumOrder(
    premiumOrderId: $premiumOrderId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      pakmailId
      premiumOrderId
      clientId
      creatorId
      originAddressId
      destinationAddressId
      originAddress
      destinationAddress
      products {
        indexProduct
        productId
        quantity
        unitWidth
        unitHeight
        unitDepth
        unitWeight
        __typename
      }
      price
      increment
      fee
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PremiumOrderLogisticGuidesByPremiumOrderQueryVariables,
  APITypes.PremiumOrderLogisticGuidesByPremiumOrderQuery
>;
export const PremiumOrderLogisticGuidesByClient = /* GraphQL */ `query PremiumOrderLogisticGuidesByClient(
  $clientId: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPremiumOrderLogisticGuideFilterInput
  $limit: Int
  $nextToken: String
) {
  PremiumOrderLogisticGuidesByClient(
    clientId: $clientId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      pakmailId
      premiumOrderId
      clientId
      creatorId
      originAddressId
      destinationAddressId
      originAddress
      destinationAddress
      products {
        indexProduct
        productId
        quantity
        unitWidth
        unitHeight
        unitDepth
        unitWeight
        __typename
      }
      price
      increment
      fee
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PremiumOrderLogisticGuidesByClientQueryVariables,
  APITypes.PremiumOrderLogisticGuidesByClientQuery
>;
export const PremiumOrderLogisticGuidesByCreator = /* GraphQL */ `query PremiumOrderLogisticGuidesByCreator(
  $creatorId: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPremiumOrderLogisticGuideFilterInput
  $limit: Int
  $nextToken: String
) {
  PremiumOrderLogisticGuidesByCreator(
    creatorId: $creatorId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      type
      pakmailId
      premiumOrderId
      clientId
      creatorId
      originAddressId
      destinationAddressId
      originAddress
      destinationAddress
      products {
        indexProduct
        productId
        quantity
        unitWidth
        unitHeight
        unitDepth
        unitWeight
        __typename
      }
      price
      increment
      fee
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PremiumOrderLogisticGuidesByCreatorQueryVariables,
  APITypes.PremiumOrderLogisticGuidesByCreatorQuery
>;
export const ProductLabelItemsByProductId = /* GraphQL */ `query ProductLabelItemsByProductId(
  $productId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductLabelItemFilterInput
  $limit: Int
  $nextToken: String
) {
  ProductLabelItemsByProductId(
    productId: $productId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      productId
      productLabelId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductLabelItemsByProductIdQueryVariables,
  APITypes.ProductLabelItemsByProductIdQuery
>;
export const ProductLabelItemsByProductLabelId = /* GraphQL */ `query ProductLabelItemsByProductLabelId(
  $productLabelId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductLabelItemFilterInput
  $limit: Int
  $nextToken: String
) {
  ProductLabelItemsByProductLabelId(
    productLabelId: $productLabelId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      productId
      productLabelId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductLabelItemsByProductLabelIdQueryVariables,
  APITypes.ProductLabelItemsByProductLabelIdQuery
>;
export const ProductLabelsByName = /* GraphQL */ `query ProductLabelsByName(
  $name: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductLabelFilterInput
  $limit: Int
  $nextToken: String
) {
  ProductLabelsByName(
    name: $name
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      translation
      status
      visibleFor
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductLabelsByNameQueryVariables,
  APITypes.ProductLabelsByNameQuery
>;
export const ProductLabelsByTranslation = /* GraphQL */ `query ProductLabelsByTranslation(
  $translation: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductLabelFilterInput
  $limit: Int
  $nextToken: String
) {
  ProductLabelsByTranslation(
    translation: $translation
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      translation
      status
      visibleFor
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductLabelsByTranslationQueryVariables,
  APITypes.ProductLabelsByTranslationQuery
>;
export const ProductLabelsByStatus = /* GraphQL */ `query ProductLabelsByStatus(
  $status: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductLabelFilterInput
  $limit: Int
  $nextToken: String
) {
  ProductLabelsByStatus(
    status: $status
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      translation
      status
      visibleFor
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductLabelsByStatusQueryVariables,
  APITypes.ProductLabelsByStatusQuery
>;
export const ProductTextItemsByProductId = /* GraphQL */ `query ProductTextItemsByProductId(
  $productId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductTextItemFilterInput
  $limit: Int
  $nextToken: String
) {
  ProductTextItemsByProductId(
    productId: $productId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      productId
      productTextId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductTextItemsByProductIdQueryVariables,
  APITypes.ProductTextItemsByProductIdQuery
>;
export const ProductTextItemsByProductTextId = /* GraphQL */ `query ProductTextItemsByProductTextId(
  $productTextId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductTextItemFilterInput
  $limit: Int
  $nextToken: String
) {
  ProductTextItemsByProductTextId(
    productTextId: $productTextId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      productId
      productTextId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductTextItemsByProductTextIdQueryVariables,
  APITypes.ProductTextItemsByProductTextIdQuery
>;
export const ProductTextsByName = /* GraphQL */ `query ProductTextsByName(
  $name: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductTextFilterInput
  $limit: Int
  $nextToken: String
) {
  ProductTextsByName(
    name: $name
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      status
      visibleFor
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductTextsByNameQueryVariables,
  APITypes.ProductTextsByNameQuery
>;
export const ProductTextsByStatus = /* GraphQL */ `query ProductTextsByStatus(
  $status: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductTextFilterInput
  $limit: Int
  $nextToken: String
) {
  ProductTextsByStatus(
    status: $status
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      status
      visibleFor
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductTextsByStatusQueryVariables,
  APITypes.ProductTextsByStatusQuery
>;
export const ProductMasksByProductId = /* GraphQL */ `query ProductMasksByProductId(
  $productId: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductMaskFilterInput
  $limit: Int
  $nextToken: String
) {
  ProductMasksByProductId(
    productId: $productId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      sku
      productId
      clientId
      filterColors
      mainImage {
        key
        url
        color
        palette
        colorName
        __typename
      }
      increment
      fee
      discount
      stock
      categoryId
      sellMode
      kitPieces
      kitIncrement
      kitFee
      stockMode
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductMasksByProductIdQueryVariables,
  APITypes.ProductMasksByProductIdQuery
>;
export const ProductMasksByClientId = /* GraphQL */ `query ProductMasksByClientId(
  $clientId: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductMaskFilterInput
  $limit: Int
  $nextToken: String
) {
  ProductMasksByClientId(
    clientId: $clientId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      sku
      productId
      clientId
      filterColors
      mainImage {
        key
        url
        color
        palette
        colorName
        __typename
      }
      increment
      fee
      discount
      stock
      categoryId
      sellMode
      kitPieces
      kitIncrement
      kitFee
      stockMode
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductMasksByClientIdQueryVariables,
  APITypes.ProductMasksByClientIdQuery
>;
export const ProductMasksByCategoryId = /* GraphQL */ `query ProductMasksByCategoryId(
  $categoryId: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelProductMaskFilterInput
  $limit: Int
  $nextToken: String
) {
  ProductMasksByCategoryId(
    categoryId: $categoryId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      sku
      productId
      clientId
      filterColors
      mainImage {
        key
        url
        color
        palette
        colorName
        __typename
      }
      increment
      fee
      discount
      stock
      categoryId
      sellMode
      kitPieces
      kitIncrement
      kitFee
      stockMode
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.ProductMasksByCategoryIdQueryVariables,
  APITypes.ProductMasksByCategoryIdQuery
>;
export const VariantMasksByProductMaskId = /* GraphQL */ `query VariantMasksByProductMaskId(
  $productMaskId: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelVariantMaskFilterInput
  $limit: Int
  $nextToken: String
) {
  VariantMasksByProductMaskId(
    productMaskId: $productMaskId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      filterColors
      images {
        key
        url
        color
        palette
        colorName
        __typename
      }
      stock
      stockMode
      productMaskId
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.VariantMasksByProductMaskIdQueryVariables,
  APITypes.VariantMasksByProductMaskIdQuery
>;
export const couponsByCode = /* GraphQL */ `query CouponsByCode(
  $code: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCouponFilterInput
  $limit: Int
  $nextToken: String
) {
  couponsByCode(
    code: $code
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      code
      name
      description
      discountAmount
      discountPercentage
      minAmount
      maxAmount
      startDate
      endDate
      maxRedemptions
      maxRedemptionsPerUser
      applicableProducts
      applicableCategories
      excludedProducts
      status
      createdBy
      redemptions {
        items {
          id
          couponId
          couponCode
          userId
          clientId
          orderId
          cartId
          discountApplied
          originalAmount
          finalAmount
          appliedAt
          ipAddress
          userAgent
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CouponsByCodeQueryVariables,
  APITypes.CouponsByCodeQuery
>;
export const couponsByStatus = /* GraphQL */ `query CouponsByStatus(
  $status: String!
  $endDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCouponFilterInput
  $limit: Int
  $nextToken: String
) {
  couponsByStatus(
    status: $status
    endDate: $endDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      code
      name
      description
      discountAmount
      discountPercentage
      minAmount
      maxAmount
      startDate
      endDate
      maxRedemptions
      maxRedemptionsPerUser
      applicableProducts
      applicableCategories
      excludedProducts
      status
      createdBy
      redemptions {
        items {
          id
          couponId
          couponCode
          userId
          clientId
          orderId
          cartId
          discountApplied
          originalAmount
          finalAmount
          appliedAt
          ipAddress
          userAgent
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CouponsByStatusQueryVariables,
  APITypes.CouponsByStatusQuery
>;
export const couponsByCreatedBy = /* GraphQL */ `query CouponsByCreatedBy(
  $createdBy: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCouponFilterInput
  $limit: Int
  $nextToken: String
) {
  couponsByCreatedBy(
    createdBy: $createdBy
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      code
      name
      description
      discountAmount
      discountPercentage
      minAmount
      maxAmount
      startDate
      endDate
      maxRedemptions
      maxRedemptionsPerUser
      applicableProducts
      applicableCategories
      excludedProducts
      status
      createdBy
      redemptions {
        items {
          id
          couponId
          couponCode
          userId
          clientId
          orderId
          cartId
          discountApplied
          originalAmount
          finalAmount
          appliedAt
          ipAddress
          userAgent
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.CouponsByCreatedByQueryVariables,
  APITypes.CouponsByCreatedByQuery
>;
export const redemptionsByCoupon = /* GraphQL */ `query RedemptionsByCoupon(
  $couponId: ID!
  $appliedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCouponRedemptionFilterInput
  $limit: Int
  $nextToken: String
) {
  redemptionsByCoupon(
    couponId: $couponId
    appliedAt: $appliedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      couponId
      couponCode
      userId
      clientId
      orderId
      cartId
      discountApplied
      originalAmount
      finalAmount
      appliedAt
      ipAddress
      userAgent
      coupon {
        id
        code
        name
        description
        discountAmount
        discountPercentage
        minAmount
        maxAmount
        startDate
        endDate
        maxRedemptions
        maxRedemptionsPerUser
        applicableProducts
        applicableCategories
        excludedProducts
        status
        createdBy
        redemptions {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RedemptionsByCouponQueryVariables,
  APITypes.RedemptionsByCouponQuery
>;
export const redemptionsByCouponCode = /* GraphQL */ `query RedemptionsByCouponCode(
  $couponCode: String!
  $appliedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCouponRedemptionFilterInput
  $limit: Int
  $nextToken: String
) {
  redemptionsByCouponCode(
    couponCode: $couponCode
    appliedAt: $appliedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      couponId
      couponCode
      userId
      clientId
      orderId
      cartId
      discountApplied
      originalAmount
      finalAmount
      appliedAt
      ipAddress
      userAgent
      coupon {
        id
        code
        name
        description
        discountAmount
        discountPercentage
        minAmount
        maxAmount
        startDate
        endDate
        maxRedemptions
        maxRedemptionsPerUser
        applicableProducts
        applicableCategories
        excludedProducts
        status
        createdBy
        redemptions {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RedemptionsByCouponCodeQueryVariables,
  APITypes.RedemptionsByCouponCodeQuery
>;
export const redemptionsByUser = /* GraphQL */ `query RedemptionsByUser(
  $userId: String!
  $appliedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelCouponRedemptionFilterInput
  $limit: Int
  $nextToken: String
) {
  redemptionsByUser(
    userId: $userId
    appliedAt: $appliedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      couponId
      couponCode
      userId
      clientId
      orderId
      cartId
      discountApplied
      originalAmount
      finalAmount
      appliedAt
      ipAddress
      userAgent
      coupon {
        id
        code
        name
        description
        discountAmount
        discountPercentage
        minAmount
        maxAmount
        startDate
        endDate
        maxRedemptions
        maxRedemptionsPerUser
        applicableProducts
        applicableCategories
        excludedProducts
        status
        createdBy
        redemptions {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RedemptionsByUserQueryVariables,
  APITypes.RedemptionsByUserQuery
>;
export const promotionsByStatus = /* GraphQL */ `query PromotionsByStatus(
  $status: String!
  $endDate: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPromotionFilterInput
  $limit: Int
  $nextToken: String
) {
  promotionsByStatus(
    status: $status
    endDate: $endDate
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      description
      triggerProductIds
      minQuantity
      minAmount
      triggerRule
      giftProductId
      giftQuantity
      isStackable
      applicableClientIds
      startDate
      endDate
      maxRedemptions
      maxRedemptionsPerUser
      status
      createdBy
      redemptions {
        items {
          id
          promotionId
          userId
          clientId
          orderId
          cartId
          triggerQuantity
          giftQuantityApplied
          appliedAt
          ipAddress
          userAgent
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PromotionsByStatusQueryVariables,
  APITypes.PromotionsByStatusQuery
>;
export const promotionsByCreatedBy = /* GraphQL */ `query PromotionsByCreatedBy(
  $createdBy: String!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPromotionFilterInput
  $limit: Int
  $nextToken: String
) {
  promotionsByCreatedBy(
    createdBy: $createdBy
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      name
      description
      triggerProductIds
      minQuantity
      minAmount
      triggerRule
      giftProductId
      giftQuantity
      isStackable
      applicableClientIds
      startDate
      endDate
      maxRedemptions
      maxRedemptionsPerUser
      status
      createdBy
      redemptions {
        items {
          id
          promotionId
          userId
          clientId
          orderId
          cartId
          triggerQuantity
          giftQuantityApplied
          appliedAt
          ipAddress
          userAgent
          createdAt
          updatedAt
          __typename
        }
        nextToken
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PromotionsByCreatedByQueryVariables,
  APITypes.PromotionsByCreatedByQuery
>;
export const redemptionsByPromotion = /* GraphQL */ `query RedemptionsByPromotion(
  $promotionId: ID!
  $appliedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPromotionRedemptionFilterInput
  $limit: Int
  $nextToken: String
) {
  redemptionsByPromotion(
    promotionId: $promotionId
    appliedAt: $appliedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      promotionId
      userId
      clientId
      orderId
      cartId
      triggerQuantity
      giftQuantityApplied
      appliedAt
      ipAddress
      userAgent
      promotion {
        id
        name
        description
        triggerProductIds
        minQuantity
        minAmount
        triggerRule
        giftProductId
        giftQuantity
        isStackable
        applicableClientIds
        startDate
        endDate
        maxRedemptions
        maxRedemptionsPerUser
        status
        createdBy
        redemptions {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.RedemptionsByPromotionQueryVariables,
  APITypes.RedemptionsByPromotionQuery
>;
export const promotionRedemptionsByUser = /* GraphQL */ `query PromotionRedemptionsByUser(
  $userId: String!
  $appliedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPromotionRedemptionFilterInput
  $limit: Int
  $nextToken: String
) {
  promotionRedemptionsByUser(
    userId: $userId
    appliedAt: $appliedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      promotionId
      userId
      clientId
      orderId
      cartId
      triggerQuantity
      giftQuantityApplied
      appliedAt
      ipAddress
      userAgent
      promotion {
        id
        name
        description
        triggerProductIds
        minQuantity
        minAmount
        triggerRule
        giftProductId
        giftQuantity
        isStackable
        applicableClientIds
        startDate
        endDate
        maxRedemptions
        maxRedemptionsPerUser
        status
        createdBy
        redemptions {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PromotionRedemptionsByUserQueryVariables,
  APITypes.PromotionRedemptionsByUserQuery
>;
export const promotionRedemptionsByClient = /* GraphQL */ `query PromotionRedemptionsByClient(
  $clientId: String!
  $appliedAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelPromotionRedemptionFilterInput
  $limit: Int
  $nextToken: String
) {
  promotionRedemptionsByClient(
    clientId: $clientId
    appliedAt: $appliedAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      promotionId
      userId
      clientId
      orderId
      cartId
      triggerQuantity
      giftQuantityApplied
      appliedAt
      ipAddress
      userAgent
      promotion {
        id
        name
        description
        triggerProductIds
        minQuantity
        minAmount
        triggerRule
        giftProductId
        giftQuantity
        isStackable
        applicableClientIds
        startDate
        endDate
        maxRedemptions
        maxRedemptionsPerUser
        status
        createdBy
        redemptions {
          nextToken
          __typename
        }
        createdAt
        updatedAt
        __typename
      }
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.PromotionRedemptionsByClientQueryVariables,
  APITypes.PromotionRedemptionsByClientQuery
>;
export const WalletMovementsByUserId = /* GraphQL */ `query WalletMovementsByUserId(
  $userId: ID!
  $createdAt: ModelStringKeyConditionInput
  $sortDirection: ModelSortDirection
  $filter: ModelWalletMovementFilterInput
  $limit: Int
  $nextToken: String
) {
  WalletMovementsByUserId(
    userId: $userId
    createdAt: $createdAt
    sortDirection: $sortDirection
    filter: $filter
    limit: $limit
    nextToken: $nextToken
  ) {
    items {
      id
      userId
      type
      amount
      orderId
      createdByUserId
      couponId
      couponCode
      availableUntil
      isValidated
      validatedAt
      validatedBy
      createdAt
      updatedAt
      __typename
    }
    nextToken
    __typename
  }
}
` as GeneratedQuery<
  APITypes.WalletMovementsByUserIdQueryVariables,
  APITypes.WalletMovementsByUserIdQuery
>;
